(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
Stimulus 3.2.1
Copyright © 2023 Basecamp, LLC
 */ function $cd0bb46fcf33db2e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $cd0bb46fcf33db2e$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $cd0bb46fcf33db2e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $cd0bb46fcf33db2e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


function $4eedc8287d3685e8$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $625388bbfb3cd523$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $625388bbfb3cd523$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $625388bbfb3cd523$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $625388bbfb3cd523$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $a6437d79afda84c4$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $9c9f503bd82065f0$export$71511d61b312f219(o) {
    $9c9f503bd82065f0$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9c9f503bd82065f0$export$71511d61b312f219(o);
}


function $ae6a5f02b01abd08$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $9c9f503bd82065f0$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $b12a51be9d81d1bc$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $b12a51be9d81d1bc$export$71511d61b312f219 = Reflect.get;
    else $b12a51be9d81d1bc$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $ae6a5f02b01abd08$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $b12a51be9d81d1bc$export$71511d61b312f219(target, property, receiver || target);
}



function $318f103d6c039280$export$71511d61b312f219(o, p) {
    $318f103d6c039280$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $318f103d6c039280$export$71511d61b312f219(o, p);
}


function $28f6179e2b599279$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $318f103d6c039280$export$71511d61b312f219)(subClass, superClass);
}


function $a5f6cdc932bbffa3$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $961a7dd09e0f91db$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $c634cf1d97a12780$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $a47104e1707b411c$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $36be118b55e0b615$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $a47104e1707b411c$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $a47104e1707b411c$export$71511d61b312f219)(o, minLen);
}


function $1733e6e3a24db77c$export$71511d61b312f219(arr, i) {
    return (0, $a5f6cdc932bbffa3$export$71511d61b312f219)(arr) || (0, $961a7dd09e0f91db$export$71511d61b312f219)(arr, i) || (0, $36be118b55e0b615$export$71511d61b312f219)(arr, i) || (0, $c634cf1d97a12780$export$71511d61b312f219)();
}



function $3faf97f7474da518$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $a47104e1707b411c$export$71511d61b312f219)(arr);
}


function $222be757f0b96279$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $da79643899409985$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $f655aa2a9acfd1eb$export$71511d61b312f219(arr) {
    return (0, $3faf97f7474da518$export$71511d61b312f219)(arr) || (0, $222be757f0b96279$export$71511d61b312f219)(arr) || (0, $36be118b55e0b615$export$71511d61b312f219)(arr) || (0, $da79643899409985$export$71511d61b312f219)();
}


function $0cd339a6e98df7f5$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}



function $3722a5ccbf29c80e$export$71511d61b312f219() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}


function $9b101634070cfba3$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



function $b909ea23cfad744d$export$71511d61b312f219(self, call) {
    if (call && ((0, $0cd339a6e98df7f5$export$71511d61b312f219)(call) === "object" || typeof call === "function")) return call;
    return (0, $9b101634070cfba3$export$71511d61b312f219)(self);
}


function $1c23ba689bfccaac$export$71511d61b312f219(Derived) {
    var hasNativeReflectConstruct = (0, $3722a5ccbf29c80e$export$71511d61b312f219)();
    return function _createSuperInternal() {
        var Super = (0, $9c9f503bd82065f0$export$71511d61b312f219)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $9c9f503bd82065f0$export$71511d61b312f219)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $b909ea23cfad744d$export$71511d61b312f219)(this, result);
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $248fc3c53839d9ba$var$extendStatics = function extendStatics1(d, b) {
    $248fc3c53839d9ba$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $248fc3c53839d9ba$var$extendStatics(d, b);
};
function $248fc3c53839d9ba$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $248fc3c53839d9ba$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $248fc3c53839d9ba$export$18ce0697a983be9b = function __assign1() {
    $248fc3c53839d9ba$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $248fc3c53839d9ba$export$18ce0697a983be9b.apply(this, arguments);
};
function $248fc3c53839d9ba$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $248fc3c53839d9ba$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $248fc3c53839d9ba$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $248fc3c53839d9ba$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $248fc3c53839d9ba$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $248fc3c53839d9ba$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(x)) === "symbol" ? x : "".concat(x);
}
function $248fc3c53839d9ba$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $248fc3c53839d9ba$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $248fc3c53839d9ba$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $248fc3c53839d9ba$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $248fc3c53839d9ba$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $248fc3c53839d9ba$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $248fc3c53839d9ba$export$45d3717a4c69092e(o, m, p);
}
function $248fc3c53839d9ba$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $248fc3c53839d9ba$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $248fc3c53839d9ba$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($248fc3c53839d9ba$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $248fc3c53839d9ba$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $248fc3c53839d9ba$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $248fc3c53839d9ba$export$10c90e4f7922046c(v) {
    return this instanceof $248fc3c53839d9ba$export$10c90e4f7922046c ? (this.v = v, this) : new $248fc3c53839d9ba$export$10c90e4f7922046c(v);
}
function $248fc3c53839d9ba$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $248fc3c53839d9ba$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $248fc3c53839d9ba$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $248fc3c53839d9ba$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $248fc3c53839d9ba$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $248fc3c53839d9ba$export$19a8beecd37a4c45 === "function" ? $248fc3c53839d9ba$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $248fc3c53839d9ba$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $248fc3c53839d9ba$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $248fc3c53839d9ba$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $248fc3c53839d9ba$export$45d3717a4c69092e(result, mod, k);
    }
    $248fc3c53839d9ba$var$__setModuleDefault(result, mod);
    return result;
}
function $248fc3c53839d9ba$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
}
function $248fc3c53839d9ba$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $248fc3c53839d9ba$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $248fc3c53839d9ba$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $248fc3c53839d9ba$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $248fc3c53839d9ba$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $248fc3c53839d9ba$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $248fc3c53839d9ba$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $248fc3c53839d9ba$export$2e2bcd8739ae039 = {
    __extends: $248fc3c53839d9ba$export$a8ba968b8961cb8a,
    __assign: $248fc3c53839d9ba$export$18ce0697a983be9b,
    __rest: $248fc3c53839d9ba$export$3c9a16f847548506,
    __decorate: $248fc3c53839d9ba$export$29e00dfd3077644b,
    __param: $248fc3c53839d9ba$export$d5ad3fd78186038f,
    __metadata: $248fc3c53839d9ba$export$f1db080c865becb9,
    __awaiter: $248fc3c53839d9ba$export$1050f835b63b671e,
    __generator: $248fc3c53839d9ba$export$67ebef60e6f28a6,
    __createBinding: $248fc3c53839d9ba$export$45d3717a4c69092e,
    __exportStar: $248fc3c53839d9ba$export$f33643c0debef087,
    __values: $248fc3c53839d9ba$export$19a8beecd37a4c45,
    __read: $248fc3c53839d9ba$export$8d051b38c9118094,
    __spread: $248fc3c53839d9ba$export$afc72e2116322959,
    __spreadArrays: $248fc3c53839d9ba$export$6388937ca91ccae8,
    __spreadArray: $248fc3c53839d9ba$export$1216008129fb82ed,
    __await: $248fc3c53839d9ba$export$10c90e4f7922046c,
    __asyncGenerator: $248fc3c53839d9ba$export$e427f37a30a4de9b,
    __asyncDelegator: $248fc3c53839d9ba$export$bbd80228419bb833,
    __asyncValues: $248fc3c53839d9ba$export$e3b29a3d6162315f,
    __makeTemplateObject: $248fc3c53839d9ba$export$4fb47efe1390b86f,
    __importStar: $248fc3c53839d9ba$export$c21735bcef00d192,
    __importDefault: $248fc3c53839d9ba$export$da59b14a69baef04,
    __classPrivateFieldGet: $248fc3c53839d9ba$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $248fc3c53839d9ba$export$d40a35129aaff81f,
    __classPrivateFieldIn: $248fc3c53839d9ba$export$81fdc39f203e4e04,
    __addDisposableResource: $248fc3c53839d9ba$export$88ac25d8e944e405,
    __disposeResources: $248fc3c53839d9ba$export$8f076105dc360e92
};


var $9761593eb1d92c30$var$EventListener = /*#__PURE__*/ function() {
    "use strict";
    function EventListener(eventTarget, eventName, eventOptions) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, EventListener);
        this.eventTarget = eventTarget;
        this.eventName = eventName;
        this.eventOptions = eventOptions;
        this.unorderedBindings = new Set();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(EventListener, [
        {
            key: "connect",
            value: function connect() {
                this.eventTarget.addEventListener(this.eventName, this, this.eventOptions);
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                this.eventTarget.removeEventListener(this.eventName, this, this.eventOptions);
            }
        },
        {
            key: "bindingConnected",
            value: function bindingConnected(binding) {
                this.unorderedBindings.add(binding);
            }
        },
        {
            key: "bindingDisconnected",
            value: function bindingDisconnected(binding) {
                this.unorderedBindings["delete"](binding);
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(event) {
                var extendedEvent = $9761593eb1d92c30$var$extendEvent(event);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.bindings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var binding = _step.value;
                        if (extendedEvent.immediatePropagationStopped) break;
                        else binding.handleEvent(extendedEvent);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "hasBindings",
            value: function hasBindings() {
                return this.unorderedBindings.size > 0;
            }
        },
        {
            key: "bindings",
            get: function get() {
                return Array.from(this.unorderedBindings).sort(function(left, right) {
                    var leftIndex = left.index, rightIndex = right.index;
                    return leftIndex < rightIndex ? -1 : leftIndex > rightIndex ? 1 : 0;
                });
            }
        }
    ]);
    return EventListener;
}();
function $9761593eb1d92c30$var$extendEvent(event) {
    if ("immediatePropagationStopped" in event) return event;
    else {
        var stopImmediatePropagation = event.stopImmediatePropagation;
        return Object.assign(event, {
            immediatePropagationStopped: false,
            stopImmediatePropagation: function() {
                this.immediatePropagationStopped = true;
                stopImmediatePropagation.call(this);
            }
        });
    }
}
var $9761593eb1d92c30$var$Dispatcher = /*#__PURE__*/ function() {
    "use strict";
    function Dispatcher(application) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Dispatcher);
        this.application = application;
        this.eventListenerMaps = new Map();
        this.started = false;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Dispatcher, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    this.eventListeners.forEach(function(eventListener) {
                        return eventListener.connect();
                    });
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.started = false;
                    this.eventListeners.forEach(function(eventListener) {
                        return eventListener.disconnect();
                    });
                }
            }
        },
        {
            key: "eventListeners",
            get: function get() {
                return Array.from(this.eventListenerMaps.values()).reduce(function(listeners, map) {
                    return listeners.concat(Array.from(map.values()));
                }, []);
            }
        },
        {
            key: "bindingConnected",
            value: function bindingConnected(binding) {
                this.fetchEventListenerForBinding(binding).bindingConnected(binding);
            }
        },
        {
            key: "bindingDisconnected",
            value: function bindingDisconnected(binding) {
                var clearEventListeners = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                this.fetchEventListenerForBinding(binding).bindingDisconnected(binding);
                if (clearEventListeners) this.clearEventListenersForBinding(binding);
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message) {
                var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                this.application.handleError(error, "Error ".concat(message), detail);
            }
        },
        {
            key: "clearEventListenersForBinding",
            value: function clearEventListenersForBinding(binding) {
                var eventListener = this.fetchEventListenerForBinding(binding);
                if (!eventListener.hasBindings()) {
                    eventListener.disconnect();
                    this.removeMappedEventListenerFor(binding);
                }
            }
        },
        {
            key: "removeMappedEventListenerFor",
            value: function removeMappedEventListenerFor(binding) {
                var eventTarget = binding.eventTarget, eventName = binding.eventName, eventOptions = binding.eventOptions;
                var eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
                var cacheKey = this.cacheKey(eventName, eventOptions);
                eventListenerMap["delete"](cacheKey);
                if (eventListenerMap.size == 0) this.eventListenerMaps["delete"](eventTarget);
            }
        },
        {
            key: "fetchEventListenerForBinding",
            value: function fetchEventListenerForBinding(binding) {
                var eventTarget = binding.eventTarget, eventName = binding.eventName, eventOptions = binding.eventOptions;
                return this.fetchEventListener(eventTarget, eventName, eventOptions);
            }
        },
        {
            key: "fetchEventListener",
            value: function fetchEventListener(eventTarget, eventName, eventOptions) {
                var eventListenerMap = this.fetchEventListenerMapForEventTarget(eventTarget);
                var cacheKey = this.cacheKey(eventName, eventOptions);
                var eventListener = eventListenerMap.get(cacheKey);
                if (!eventListener) {
                    eventListener = this.createEventListener(eventTarget, eventName, eventOptions);
                    eventListenerMap.set(cacheKey, eventListener);
                }
                return eventListener;
            }
        },
        {
            key: "createEventListener",
            value: function createEventListener(eventTarget, eventName, eventOptions) {
                var eventListener = new $9761593eb1d92c30$var$EventListener(eventTarget, eventName, eventOptions);
                if (this.started) eventListener.connect();
                return eventListener;
            }
        },
        {
            key: "fetchEventListenerMapForEventTarget",
            value: function fetchEventListenerMapForEventTarget(eventTarget) {
                var eventListenerMap = this.eventListenerMaps.get(eventTarget);
                if (!eventListenerMap) {
                    eventListenerMap = new Map();
                    this.eventListenerMaps.set(eventTarget, eventListenerMap);
                }
                return eventListenerMap;
            }
        },
        {
            key: "cacheKey",
            value: function cacheKey(eventName, eventOptions) {
                var parts = [
                    eventName
                ];
                Object.keys(eventOptions).sort().forEach(function(key) {
                    parts.push("".concat(eventOptions[key] ? "" : "!").concat(key));
                });
                return parts.join(":");
            }
        }
    ]);
    return Dispatcher;
}();
var $9761593eb1d92c30$var$defaultActionDescriptorFilters = {
    stop: function(param) {
        var event = param.event, value = param.value;
        if (value) event.stopPropagation();
        return true;
    },
    prevent: function(param) {
        var event = param.event, value = param.value;
        if (value) event.preventDefault();
        return true;
    },
    self: function(param) {
        var event = param.event, value = param.value, element = param.element;
        if (value) return element === event.target;
        else return true;
    }
};
var $9761593eb1d92c30$var$descriptorPattern = /^(?:(?:([^.]+?)\+)?(.+?)(?:\.(.+?))?(?:@(window|document))?->)?(.+?)(?:#([^:]+?))(?::(.+))?$/;
function $9761593eb1d92c30$var$parseActionDescriptorString(descriptorString) {
    var source = descriptorString.trim();
    var matches = source.match($9761593eb1d92c30$var$descriptorPattern) || [];
    var eventName = matches[2];
    var keyFilter = matches[3];
    if (keyFilter && ![
        "keydown",
        "keyup",
        "keypress"
    ].includes(eventName)) {
        eventName += ".".concat(keyFilter);
        keyFilter = "";
    }
    return {
        eventTarget: $9761593eb1d92c30$var$parseEventTarget(matches[4]),
        eventName: eventName,
        eventOptions: matches[7] ? $9761593eb1d92c30$var$parseEventOptions(matches[7]) : {},
        identifier: matches[5],
        methodName: matches[6],
        keyFilter: matches[1] || keyFilter
    };
}
function $9761593eb1d92c30$var$parseEventTarget(eventTargetName) {
    if (eventTargetName == "window") return window;
    else if (eventTargetName == "document") return document;
}
function $9761593eb1d92c30$var$parseEventOptions(eventOptions) {
    return eventOptions.split(":").reduce(function(options, token) {
        return Object.assign(options, (0, $a6437d79afda84c4$export$71511d61b312f219)({}, token.replace(/^!/, ""), !/^!/.test(token)));
    }, {});
}
function $9761593eb1d92c30$var$stringifyEventTarget(eventTarget) {
    if (eventTarget == window) return "window";
    else if (eventTarget == document) return "document";
}
function $9761593eb1d92c30$var$camelize(value) {
    return value.replace(/(?:[_-])([a-z0-9])/g, function(_, _char) {
        return _char.toUpperCase();
    });
}
function $9761593eb1d92c30$var$namespaceCamelize(value) {
    return $9761593eb1d92c30$var$camelize(value.replace(/--/g, "-").replace(/__/g, "_"));
}
function $9761593eb1d92c30$var$capitalize(value) {
    return value.charAt(0).toUpperCase() + value.slice(1);
}
function $9761593eb1d92c30$var$dasherize(value) {
    return value.replace(/([A-Z])/g, function(_, _char) {
        return "-".concat(_char.toLowerCase());
    });
}
function $9761593eb1d92c30$var$tokenize(value) {
    return value.match(/[^\s]+/g) || [];
}
function $9761593eb1d92c30$var$isSomething(object) {
    return object !== null && object !== undefined;
}
function $9761593eb1d92c30$var$hasProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
var $9761593eb1d92c30$var$allModifiers = [
    "meta",
    "ctrl",
    "alt",
    "shift"
];
var $9761593eb1d92c30$var$Action = /*#__PURE__*/ function() {
    "use strict";
    function Action(element, index, descriptor, schema) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Action);
        this.element = element;
        this.index = index;
        this.eventTarget = descriptor.eventTarget || element;
        this.eventName = descriptor.eventName || $9761593eb1d92c30$var$getDefaultEventNameForElement(element) || $9761593eb1d92c30$var$error("missing event name");
        this.eventOptions = descriptor.eventOptions || {};
        this.identifier = descriptor.identifier || $9761593eb1d92c30$var$error("missing identifier");
        this.methodName = descriptor.methodName || $9761593eb1d92c30$var$error("missing method name");
        this.keyFilter = descriptor.keyFilter || "";
        this.schema = schema;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Action, [
        {
            key: "toString",
            value: function toString() {
                var eventFilter = this.keyFilter ? ".".concat(this.keyFilter) : "";
                var eventTarget = this.eventTargetName ? "@".concat(this.eventTargetName) : "";
                return "".concat(this.eventName).concat(eventFilter).concat(eventTarget, "->").concat(this.identifier, "#").concat(this.methodName);
            }
        },
        {
            key: "shouldIgnoreKeyboardEvent",
            value: function shouldIgnoreKeyboardEvent(event) {
                if (!this.keyFilter) return false;
                var filters = this.keyFilter.split("+");
                if (this.keyFilterDissatisfied(event, filters)) return true;
                var standardFilter = filters.filter(function(key) {
                    return !$9761593eb1d92c30$var$allModifiers.includes(key);
                })[0];
                if (!standardFilter) return false;
                if (!$9761593eb1d92c30$var$hasProperty(this.keyMappings, standardFilter)) $9761593eb1d92c30$var$error("contains unknown key filter: ".concat(this.keyFilter));
                return this.keyMappings[standardFilter].toLowerCase() !== event.key.toLowerCase();
            }
        },
        {
            key: "shouldIgnoreMouseEvent",
            value: function shouldIgnoreMouseEvent(event) {
                if (!this.keyFilter) return false;
                var filters = [
                    this.keyFilter
                ];
                if (this.keyFilterDissatisfied(event, filters)) return true;
                return false;
            }
        },
        {
            key: "params",
            get: function get() {
                var params = {};
                var pattern = new RegExp("^data-".concat(this.identifier, "-(.+)-param$"), "i");
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(this.element.attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, name = _step_value.name, value = _step_value.value;
                        var match = name.match(pattern);
                        var key = match && match[1];
                        if (key) params[$9761593eb1d92c30$var$camelize(key)] = $9761593eb1d92c30$var$typecast(value);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return params;
            }
        },
        {
            key: "eventTargetName",
            get: function get() {
                return $9761593eb1d92c30$var$stringifyEventTarget(this.eventTarget);
            }
        },
        {
            key: "keyMappings",
            get: function get() {
                return this.schema.keyMappings;
            }
        },
        {
            key: "keyFilterDissatisfied",
            value: function keyFilterDissatisfied(event, filters) {
                var _allModifiers_map = (0, $1733e6e3a24db77c$export$71511d61b312f219)($9761593eb1d92c30$var$allModifiers.map(function(modifier) {
                    return filters.includes(modifier);
                }), 4), meta = _allModifiers_map[0], ctrl = _allModifiers_map[1], alt = _allModifiers_map[2], shift = _allModifiers_map[3];
                return event.metaKey !== meta || event.ctrlKey !== ctrl || event.altKey !== alt || event.shiftKey !== shift;
            }
        }
    ], [
        {
            key: "forToken",
            value: function forToken(token, schema) {
                return new this(token.element, token.index, $9761593eb1d92c30$var$parseActionDescriptorString(token.content), schema);
            }
        }
    ]);
    return Action;
}();
var $9761593eb1d92c30$var$defaultEventNames = {
    a: function() {
        return "click";
    },
    button: function() {
        return "click";
    },
    form: function() {
        return "submit";
    },
    details: function() {
        return "toggle";
    },
    input: function(e) {
        return e.getAttribute("type") == "submit" ? "click" : "input";
    },
    select: function() {
        return "change";
    },
    textarea: function() {
        return "input";
    }
};
function $9761593eb1d92c30$var$getDefaultEventNameForElement(element) {
    var tagName = element.tagName.toLowerCase();
    if (tagName in $9761593eb1d92c30$var$defaultEventNames) return $9761593eb1d92c30$var$defaultEventNames[tagName](element);
}
function $9761593eb1d92c30$var$error(message) {
    throw new Error(message);
}
function $9761593eb1d92c30$var$typecast(value) {
    try {
        return JSON.parse(value);
    } catch (o_O) {
        return value;
    }
}
var $9761593eb1d92c30$var$Binding = /*#__PURE__*/ function() {
    "use strict";
    function Binding(context, action) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Binding);
        this.context = context;
        this.action = action;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Binding, [
        {
            key: "index",
            get: function get() {
                return this.action.index;
            }
        },
        {
            key: "eventTarget",
            get: function get() {
                return this.action.eventTarget;
            }
        },
        {
            key: "eventOptions",
            get: function get() {
                return this.action.eventOptions;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.context.identifier;
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(event) {
                var actionEvent = this.prepareActionEvent(event);
                if (this.willBeInvokedByEvent(event) && this.applyEventModifiers(actionEvent)) this.invokeWithEvent(actionEvent);
            }
        },
        {
            key: "eventName",
            get: function get() {
                return this.action.eventName;
            }
        },
        {
            key: "method",
            get: function get() {
                var method = this.controller[this.methodName];
                if (typeof method == "function") return method;
                throw new Error('Action "'.concat(this.action, '" references undefined method "').concat(this.methodName, '"'));
            }
        },
        {
            key: "applyEventModifiers",
            value: function applyEventModifiers(event) {
                var element = this.action.element;
                var actionDescriptorFilters = this.context.application.actionDescriptorFilters;
                var controller = this.context.controller;
                var passes = true;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this.eventOptions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $1733e6e3a24db77c$export$71511d61b312f219)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                        if (name in actionDescriptorFilters) {
                            var filter = actionDescriptorFilters[name];
                            passes = passes && filter({
                                name: name,
                                value: value,
                                event: event,
                                element: element,
                                controller: controller
                            });
                        } else continue;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return passes;
            }
        },
        {
            key: "prepareActionEvent",
            value: function prepareActionEvent(event) {
                return Object.assign(event, {
                    params: this.action.params
                });
            }
        },
        {
            key: "invokeWithEvent",
            value: function invokeWithEvent(event) {
                var target = event.target, currentTarget = event.currentTarget;
                try {
                    this.method.call(this.controller, event);
                    this.context.logDebugActivity(this.methodName, {
                        event: event,
                        target: target,
                        currentTarget: currentTarget,
                        action: this.methodName
                    });
                } catch (error) {
                    var _this = this, identifier = _this.identifier, controller = _this.controller, element = _this.element, index = _this.index;
                    var detail = {
                        identifier: identifier,
                        controller: controller,
                        element: element,
                        index: index,
                        event: event
                    };
                    this.context.handleError(error, 'invoking action "'.concat(this.action, '"'), detail);
                }
            }
        },
        {
            key: "willBeInvokedByEvent",
            value: function willBeInvokedByEvent(event) {
                var eventTarget = event.target;
                if (event instanceof KeyboardEvent && this.action.shouldIgnoreKeyboardEvent(event)) return false;
                if (event instanceof MouseEvent && this.action.shouldIgnoreMouseEvent(event)) return false;
                if (this.element === eventTarget) return true;
                else if (eventTarget instanceof Element && this.element.contains(eventTarget)) return this.scope.containsElement(eventTarget);
                else return this.scope.containsElement(this.action.element);
            }
        },
        {
            key: "controller",
            get: function get() {
                return this.context.controller;
            }
        },
        {
            key: "methodName",
            get: function get() {
                return this.action.methodName;
            }
        },
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        }
    ]);
    return Binding;
}();
var $9761593eb1d92c30$export$12e07a2a9f87578a = /*#__PURE__*/ function() {
    "use strict";
    function ElementObserver(element, delegate) {
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ElementObserver);
        this.mutationObserverInit = {
            attributes: true,
            childList: true,
            subtree: true
        };
        this.element = element;
        this.started = false;
        this.delegate = delegate;
        this.elements = new Set();
        this.mutationObserver = new MutationObserver(function(mutations) {
            return _this.processMutations(mutations);
        });
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ElementObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    this.mutationObserver.observe(this.element, this.mutationObserverInit);
                    this.refresh();
                }
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                if (this.started) {
                    this.mutationObserver.disconnect();
                    this.started = false;
                }
                callback();
                if (!this.started) {
                    this.mutationObserver.observe(this.element, this.mutationObserverInit);
                    this.started = true;
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.mutationObserver.takeRecords();
                    this.mutationObserver.disconnect();
                    this.started = false;
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (this.started) {
                    var matches = new Set(this.matchElementsInTree());
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Array.from(this.elements)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            if (!matches.has(element)) this.removeElement(element);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                                _iterator["return"]();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = Array.from(matches)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var element1 = _step1.value;
                            this.addElement(element1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1["return"] != null) {
                                _iterator1["return"]();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
            }
        },
        {
            key: "processMutations",
            value: function processMutations(mutations) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.started) try {
                    for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var mutation = _step.value;
                        this.processMutation(mutation);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processMutation",
            value: function processMutation(mutation) {
                if (mutation.type == "attributes") this.processAttributeChange(mutation.target, mutation.attributeName);
                else if (mutation.type == "childList") {
                    this.processRemovedNodes(mutation.removedNodes);
                    this.processAddedNodes(mutation.addedNodes);
                }
            }
        },
        {
            key: "processAttributeChange",
            value: function processAttributeChange(element, attributeName) {
                if (this.elements.has(element)) {
                    if (this.delegate.elementAttributeChanged && this.matchElement(element)) this.delegate.elementAttributeChanged(element, attributeName);
                    else this.removeElement(element);
                } else if (this.matchElement(element)) this.addElement(element);
            }
        },
        {
            key: "processRemovedNodes",
            value: function processRemovedNodes(nodes) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        var element = this.elementFromNode(node);
                        if (element) this.processTree(element, this.removeElement);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processAddedNodes",
            value: function processAddedNodes(nodes) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Array.from(nodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        var element = this.elementFromNode(node);
                        if (element && this.elementIsActive(element)) this.processTree(element, this.addElement);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "matchElement",
            value: function matchElement(element) {
                return this.delegate.matchElement(element);
            }
        },
        {
            key: "matchElementsInTree",
            value: function matchElementsInTree() {
                var tree = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.element;
                return this.delegate.matchElementsInTree(tree);
            }
        },
        {
            key: "processTree",
            value: function processTree(tree, processor) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.matchElementsInTree(tree)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        processor.call(this, element);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "elementFromNode",
            value: function elementFromNode(node) {
                if (node.nodeType == Node.ELEMENT_NODE) return node;
            }
        },
        {
            key: "elementIsActive",
            value: function elementIsActive(element) {
                if (element.isConnected != this.element.isConnected) return false;
                else return this.element.contains(element);
            }
        },
        {
            key: "addElement",
            value: function addElement(element) {
                if (!this.elements.has(element)) {
                    if (this.elementIsActive(element)) {
                        this.elements.add(element);
                        if (this.delegate.elementMatched) this.delegate.elementMatched(element);
                    }
                }
            }
        },
        {
            key: "removeElement",
            value: function removeElement(element) {
                if (this.elements.has(element)) {
                    this.elements["delete"](element);
                    if (this.delegate.elementUnmatched) this.delegate.elementUnmatched(element);
                }
            }
        }
    ]);
    return ElementObserver;
}();
var $9761593eb1d92c30$export$fe68319d413d05cb = /*#__PURE__*/ function() {
    "use strict";
    function AttributeObserver(element, attributeName, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, AttributeObserver);
        this.attributeName = attributeName;
        this.delegate = delegate;
        this.elementObserver = new $9761593eb1d92c30$export$12e07a2a9f87578a(element, this);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(AttributeObserver, [
        {
            key: "element",
            get: function get() {
                return this.elementObserver.element;
            }
        },
        {
            key: "selector",
            get: function get() {
                return "[".concat(this.attributeName, "]");
            }
        },
        {
            key: "start",
            value: function start() {
                this.elementObserver.start();
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                this.elementObserver.pause(callback);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.elementObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.elementObserver.refresh();
            }
        },
        {
            key: "started",
            get: function get() {
                return this.elementObserver.started;
            }
        },
        {
            key: "matchElement",
            value: function matchElement(element) {
                return element.hasAttribute(this.attributeName);
            }
        },
        {
            key: "matchElementsInTree",
            value: function matchElementsInTree(tree) {
                var match = this.matchElement(tree) ? [
                    tree
                ] : [];
                var matches = Array.from(tree.querySelectorAll(this.selector));
                return match.concat(matches);
            }
        },
        {
            key: "elementMatched",
            value: function elementMatched(element) {
                if (this.delegate.elementMatchedAttribute) this.delegate.elementMatchedAttribute(element, this.attributeName);
            }
        },
        {
            key: "elementUnmatched",
            value: function elementUnmatched(element) {
                if (this.delegate.elementUnmatchedAttribute) this.delegate.elementUnmatchedAttribute(element, this.attributeName);
            }
        },
        {
            key: "elementAttributeChanged",
            value: function elementAttributeChanged(element, attributeName) {
                if (this.delegate.elementAttributeValueChanged && this.attributeName == attributeName) this.delegate.elementAttributeValueChanged(element, attributeName);
            }
        }
    ]);
    return AttributeObserver;
}();
function $9761593eb1d92c30$export$e16d8520af44a096(map, key, value) {
    $9761593eb1d92c30$export$e7aa7bc5c1b3cfb3(map, key).add(value);
}
function $9761593eb1d92c30$export$1d2f21e549771e67(map, key, value) {
    $9761593eb1d92c30$export$e7aa7bc5c1b3cfb3(map, key)["delete"](value);
    $9761593eb1d92c30$export$d6cf75919f12ca5a(map, key);
}
function $9761593eb1d92c30$export$e7aa7bc5c1b3cfb3(map, key) {
    var values = map.get(key);
    if (!values) {
        values = new Set();
        map.set(key, values);
    }
    return values;
}
function $9761593eb1d92c30$export$d6cf75919f12ca5a(map, key) {
    var values = map.get(key);
    if (values != null && values.size == 0) map["delete"](key);
}
var $9761593eb1d92c30$export$8bd4ad37b76db6ba = /*#__PURE__*/ function() {
    "use strict";
    function Multimap() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Multimap);
        this.valuesByKey = new Map();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Multimap, [
        {
            key: "keys",
            get: function get() {
                return Array.from(this.valuesByKey.keys());
            }
        },
        {
            key: "values",
            get: function get() {
                var sets = Array.from(this.valuesByKey.values());
                return sets.reduce(function(values, set) {
                    return values.concat(Array.from(set));
                }, []);
            }
        },
        {
            key: "size",
            get: function get() {
                var sets = Array.from(this.valuesByKey.values());
                return sets.reduce(function(size, set) {
                    return size + set.size;
                }, 0);
            }
        },
        {
            key: "add",
            value: function add1(key, value) {
                $9761593eb1d92c30$export$e16d8520af44a096(this.valuesByKey, key, value);
            }
        },
        {
            key: "delete",
            value: function _delete(key, value) {
                $9761593eb1d92c30$export$1d2f21e549771e67(this.valuesByKey, key, value);
            }
        },
        {
            key: "has",
            value: function has(key, value) {
                var values = this.valuesByKey.get(key);
                return values != null && values.has(value);
            }
        },
        {
            key: "hasKey",
            value: function hasKey(key) {
                return this.valuesByKey.has(key);
            }
        },
        {
            key: "hasValue",
            value: function hasValue(value) {
                var sets = Array.from(this.valuesByKey.values());
                return sets.some(function(set) {
                    return set.has(value);
                });
            }
        },
        {
            key: "getValuesForKey",
            value: function getValuesForKey(key) {
                var values = this.valuesByKey.get(key);
                return values ? Array.from(values) : [];
            }
        },
        {
            key: "getKeysForValue",
            value: function getKeysForValue(value) {
                return Array.from(this.valuesByKey).filter(function(param) {
                    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), _key = _param[0], values = _param[1];
                    return values.has(value);
                }).map(function(param) {
                    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), key = _param[0], _values = _param[1];
                    return key;
                });
            }
        }
    ]);
    return Multimap;
}();
var $9761593eb1d92c30$export$a7c3d2c2552a674d = /*#__PURE__*/ function(Multimap) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(IndexedMultimap, Multimap);
    var _super = (0, $1c23ba689bfccaac$export$71511d61b312f219)(IndexedMultimap);
    function IndexedMultimap() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, IndexedMultimap);
        var _this;
        _this = _super.call(this);
        _this.keysByValue = new Map();
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(IndexedMultimap, [
        {
            key: "values",
            get: function get() {
                return Array.from(this.keysByValue.keys());
            }
        },
        {
            key: "add",
            value: function add1(key, value) {
                (0, $b12a51be9d81d1bc$export$71511d61b312f219)((0, $9c9f503bd82065f0$export$71511d61b312f219)(IndexedMultimap.prototype), "add", this).call(this, key, value);
                $9761593eb1d92c30$export$e16d8520af44a096(this.keysByValue, value, key);
            }
        },
        {
            key: "delete",
            value: function _delete(key, value) {
                (0, $b12a51be9d81d1bc$export$71511d61b312f219)((0, $9c9f503bd82065f0$export$71511d61b312f219)(IndexedMultimap.prototype), "delete", this).call(this, key, value);
                $9761593eb1d92c30$export$1d2f21e549771e67(this.keysByValue, value, key);
            }
        },
        {
            key: "hasValue",
            value: function hasValue(value) {
                return this.keysByValue.has(value);
            }
        },
        {
            key: "getKeysForValue",
            value: function getKeysForValue(value) {
                var set = this.keysByValue.get(value);
                return set ? Array.from(set) : [];
            }
        }
    ]);
    return IndexedMultimap;
}($9761593eb1d92c30$export$8bd4ad37b76db6ba);
var $9761593eb1d92c30$export$116e0b48509995b = /*#__PURE__*/ function() {
    "use strict";
    function SelectorObserver(element, selector, delegate, details) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, SelectorObserver);
        this._selector = selector;
        this.details = details;
        this.elementObserver = new $9761593eb1d92c30$export$12e07a2a9f87578a(element, this);
        this.delegate = delegate;
        this.matchesByElement = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(SelectorObserver, [
        {
            key: "started",
            get: function get() {
                return this.elementObserver.started;
            }
        },
        {
            key: "selector",
            get: function get() {
                return this._selector;
            },
            set: function set(selector) {
                this._selector = selector;
                this.refresh();
            }
        },
        {
            key: "start",
            value: function start() {
                this.elementObserver.start();
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                this.elementObserver.pause(callback);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.elementObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.elementObserver.refresh();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.elementObserver.element;
            }
        },
        {
            key: "matchElement",
            value: function matchElement(element) {
                var selector = this.selector;
                if (selector) {
                    var matches = element.matches(selector);
                    if (this.delegate.selectorMatchElement) return matches && this.delegate.selectorMatchElement(element, this.details);
                    return matches;
                } else return false;
            }
        },
        {
            key: "matchElementsInTree",
            value: function matchElementsInTree(tree) {
                var _this = this;
                var selector = this.selector;
                if (selector) {
                    var match = this.matchElement(tree) ? [
                        tree
                    ] : [];
                    var matches = Array.from(tree.querySelectorAll(selector)).filter(function(match) {
                        return _this.matchElement(match);
                    });
                    return match.concat(matches);
                } else return [];
            }
        },
        {
            key: "elementMatched",
            value: function elementMatched(element) {
                var selector = this.selector;
                if (selector) this.selectorMatched(element, selector);
            }
        },
        {
            key: "elementUnmatched",
            value: function elementUnmatched(element) {
                var selectors = this.matchesByElement.getKeysForValue(element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = selectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var selector = _step.value;
                        this.selectorUnmatched(element, selector);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "elementAttributeChanged",
            value: function elementAttributeChanged(element, _attributeName) {
                var selector = this.selector;
                if (selector) {
                    var matches = this.matchElement(element);
                    var matchedBefore = this.matchesByElement.has(selector, element);
                    if (matches && !matchedBefore) this.selectorMatched(element, selector);
                    else if (!matches && matchedBefore) this.selectorUnmatched(element, selector);
                }
            }
        },
        {
            key: "selectorMatched",
            value: function selectorMatched(element, selector) {
                this.delegate.selectorMatched(element, selector, this.details);
                this.matchesByElement.add(selector, element);
            }
        },
        {
            key: "selectorUnmatched",
            value: function selectorUnmatched(element, selector) {
                this.delegate.selectorUnmatched(element, selector, this.details);
                this.matchesByElement["delete"](selector, element);
            }
        }
    ]);
    return SelectorObserver;
}();
var $9761593eb1d92c30$export$da226bebbf7f6caa = /*#__PURE__*/ function() {
    "use strict";
    function StringMapObserver(element, delegate) {
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, StringMapObserver);
        this.element = element;
        this.delegate = delegate;
        this.started = false;
        this.stringMap = new Map();
        this.mutationObserver = new MutationObserver(function(mutations) {
            return _this.processMutations(mutations);
        });
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(StringMapObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.started) {
                    this.started = true;
                    this.mutationObserver.observe(this.element, {
                        attributes: true,
                        attributeOldValue: true
                    });
                    this.refresh();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.mutationObserver.takeRecords();
                    this.mutationObserver.disconnect();
                    this.started = false;
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.started) try {
                    for(var _iterator = this.knownAttributeNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attributeName = _step.value;
                        this.refreshAttribute(attributeName, null);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processMutations",
            value: function processMutations(mutations) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (this.started) try {
                    for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var mutation = _step.value;
                        this.processMutation(mutation);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "processMutation",
            value: function processMutation(mutation) {
                var attributeName = mutation.attributeName;
                if (attributeName) this.refreshAttribute(attributeName, mutation.oldValue);
            }
        },
        {
            key: "refreshAttribute",
            value: function refreshAttribute(attributeName, oldValue) {
                var key = this.delegate.getStringMapKeyForAttribute(attributeName);
                if (key != null) {
                    if (!this.stringMap.has(attributeName)) this.stringMapKeyAdded(key, attributeName);
                    var value = this.element.getAttribute(attributeName);
                    if (this.stringMap.get(attributeName) != value) this.stringMapValueChanged(value, key, oldValue);
                    if (value == null) {
                        var _$oldValue = this.stringMap.get(attributeName);
                        this.stringMap["delete"](attributeName);
                        if (_$oldValue) this.stringMapKeyRemoved(key, attributeName, _$oldValue);
                    } else this.stringMap.set(attributeName, value);
                }
            }
        },
        {
            key: "stringMapKeyAdded",
            value: function stringMapKeyAdded(key, attributeName) {
                if (this.delegate.stringMapKeyAdded) this.delegate.stringMapKeyAdded(key, attributeName);
            }
        },
        {
            key: "stringMapValueChanged",
            value: function stringMapValueChanged(value, key, oldValue) {
                if (this.delegate.stringMapValueChanged) this.delegate.stringMapValueChanged(value, key, oldValue);
            }
        },
        {
            key: "stringMapKeyRemoved",
            value: function stringMapKeyRemoved(key, attributeName, oldValue) {
                if (this.delegate.stringMapKeyRemoved) this.delegate.stringMapKeyRemoved(key, attributeName, oldValue);
            }
        },
        {
            key: "knownAttributeNames",
            get: function get() {
                return Array.from(new Set(this.currentAttributeNames.concat(this.recordedAttributeNames)));
            }
        },
        {
            key: "currentAttributeNames",
            get: function get() {
                return Array.from(this.element.attributes).map(function(attribute) {
                    return attribute.name;
                });
            }
        },
        {
            key: "recordedAttributeNames",
            get: function get() {
                return Array.from(this.stringMap.keys());
            }
        }
    ]);
    return StringMapObserver;
}();
var $9761593eb1d92c30$export$3aa21c2f03ef6b3b = /*#__PURE__*/ function() {
    "use strict";
    function TokenListObserver(element, attributeName, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, TokenListObserver);
        this.attributeObserver = new $9761593eb1d92c30$export$fe68319d413d05cb(element, attributeName, this);
        this.delegate = delegate;
        this.tokensByElement = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(TokenListObserver, [
        {
            key: "started",
            get: function get() {
                return this.attributeObserver.started;
            }
        },
        {
            key: "start",
            value: function start() {
                this.attributeObserver.start();
            }
        },
        {
            key: "pause",
            value: function pause(callback) {
                this.attributeObserver.pause(callback);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.attributeObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.attributeObserver.refresh();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.attributeObserver.element;
            }
        },
        {
            key: "attributeName",
            get: function get() {
                return this.attributeObserver.attributeName;
            }
        },
        {
            key: "elementMatchedAttribute",
            value: function elementMatchedAttribute(element) {
                this.tokensMatched(this.readTokensForElement(element));
            }
        },
        {
            key: "elementAttributeValueChanged",
            value: function elementAttributeValueChanged(element) {
                var _this_refreshTokensForElement = (0, $1733e6e3a24db77c$export$71511d61b312f219)(this.refreshTokensForElement(element), 2), unmatchedTokens = _this_refreshTokensForElement[0], matchedTokens = _this_refreshTokensForElement[1];
                this.tokensUnmatched(unmatchedTokens);
                this.tokensMatched(matchedTokens);
            }
        },
        {
            key: "elementUnmatchedAttribute",
            value: function elementUnmatchedAttribute(element) {
                this.tokensUnmatched(this.tokensByElement.getValuesForKey(element));
            }
        },
        {
            key: "tokensMatched",
            value: function tokensMatched(tokens) {
                var _this = this;
                tokens.forEach(function(token) {
                    return _this.tokenMatched(token);
                });
            }
        },
        {
            key: "tokensUnmatched",
            value: function tokensUnmatched(tokens) {
                var _this = this;
                tokens.forEach(function(token) {
                    return _this.tokenUnmatched(token);
                });
            }
        },
        {
            key: "tokenMatched",
            value: function tokenMatched(token) {
                this.delegate.tokenMatched(token);
                this.tokensByElement.add(token.element, token);
            }
        },
        {
            key: "tokenUnmatched",
            value: function tokenUnmatched(token) {
                this.delegate.tokenUnmatched(token);
                this.tokensByElement["delete"](token.element, token);
            }
        },
        {
            key: "refreshTokensForElement",
            value: function refreshTokensForElement(element) {
                var previousTokens = this.tokensByElement.getValuesForKey(element);
                var currentTokens = this.readTokensForElement(element);
                var firstDifferingIndex = $9761593eb1d92c30$var$zip(previousTokens, currentTokens).findIndex(function(param) {
                    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), previousToken = _param[0], currentToken = _param[1];
                    return !$9761593eb1d92c30$var$tokensAreEqual(previousToken, currentToken);
                });
                if (firstDifferingIndex == -1) return [
                    [],
                    []
                ];
                else return [
                    previousTokens.slice(firstDifferingIndex),
                    currentTokens.slice(firstDifferingIndex)
                ];
            }
        },
        {
            key: "readTokensForElement",
            value: function readTokensForElement(element) {
                var attributeName = this.attributeName;
                var tokenString = element.getAttribute(attributeName) || "";
                return $9761593eb1d92c30$var$parseTokenString(tokenString, element, attributeName);
            }
        }
    ]);
    return TokenListObserver;
}();
function $9761593eb1d92c30$var$parseTokenString(tokenString, element, attributeName) {
    return tokenString.trim().split(/\s+/).filter(function(content) {
        return content.length;
    }).map(function(content, index) {
        return {
            element: element,
            attributeName: attributeName,
            content: content,
            index: index
        };
    });
}
function $9761593eb1d92c30$var$zip(left, right) {
    var length = Math.max(left.length, right.length);
    return Array.from({
        length: length
    }, function(_, index) {
        return [
            left[index],
            right[index]
        ];
    });
}
function $9761593eb1d92c30$var$tokensAreEqual(left, right) {
    return left && right && left.index == right.index && left.content == right.content;
}
var $9761593eb1d92c30$export$d27fa4c7330a452e = /*#__PURE__*/ function() {
    "use strict";
    function ValueListObserver(element, attributeName, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ValueListObserver);
        this.tokenListObserver = new $9761593eb1d92c30$export$3aa21c2f03ef6b3b(element, attributeName, this);
        this.delegate = delegate;
        this.parseResultsByToken = new WeakMap();
        this.valuesByTokenByElement = new WeakMap();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ValueListObserver, [
        {
            key: "started",
            get: function get() {
                return this.tokenListObserver.started;
            }
        },
        {
            key: "start",
            value: function start() {
                this.tokenListObserver.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.tokenListObserver.stop();
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.tokenListObserver.refresh();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.tokenListObserver.element;
            }
        },
        {
            key: "attributeName",
            get: function get() {
                return this.tokenListObserver.attributeName;
            }
        },
        {
            key: "tokenMatched",
            value: function tokenMatched(token) {
                var element = token.element;
                var value = this.fetchParseResultForToken(token).value;
                if (value) {
                    this.fetchValuesByTokenForElement(element).set(token, value);
                    this.delegate.elementMatchedValue(element, value);
                }
            }
        },
        {
            key: "tokenUnmatched",
            value: function tokenUnmatched(token) {
                var element = token.element;
                var value = this.fetchParseResultForToken(token).value;
                if (value) {
                    this.fetchValuesByTokenForElement(element)["delete"](token);
                    this.delegate.elementUnmatchedValue(element, value);
                }
            }
        },
        {
            key: "fetchParseResultForToken",
            value: function fetchParseResultForToken(token) {
                var parseResult = this.parseResultsByToken.get(token);
                if (!parseResult) {
                    parseResult = this.parseToken(token);
                    this.parseResultsByToken.set(token, parseResult);
                }
                return parseResult;
            }
        },
        {
            key: "fetchValuesByTokenForElement",
            value: function fetchValuesByTokenForElement(element) {
                var valuesByToken = this.valuesByTokenByElement.get(element);
                if (!valuesByToken) {
                    valuesByToken = new Map();
                    this.valuesByTokenByElement.set(element, valuesByToken);
                }
                return valuesByToken;
            }
        },
        {
            key: "parseToken",
            value: function parseToken(token) {
                try {
                    var value = this.delegate.parseValueForToken(token);
                    return {
                        value: value
                    };
                } catch (error) {
                    return {
                        error: error
                    };
                }
            }
        }
    ]);
    return ValueListObserver;
}();
var $9761593eb1d92c30$var$BindingObserver = /*#__PURE__*/ function() {
    "use strict";
    function BindingObserver(context, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, BindingObserver);
        this.context = context;
        this.delegate = delegate;
        this.bindingsByAction = new Map();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(BindingObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.valueListObserver) {
                    this.valueListObserver = new $9761593eb1d92c30$export$d27fa4c7330a452e(this.element, this.actionAttribute, this);
                    this.valueListObserver.start();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.valueListObserver) {
                    this.valueListObserver.stop();
                    delete this.valueListObserver;
                    this.disconnectAllActions();
                }
            }
        },
        {
            key: "element",
            get: function get() {
                return this.context.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.context.identifier;
            }
        },
        {
            key: "actionAttribute",
            get: function get() {
                return this.schema.actionAttribute;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.context.schema;
            }
        },
        {
            key: "bindings",
            get: function get() {
                return Array.from(this.bindingsByAction.values());
            }
        },
        {
            key: "connectAction",
            value: function connectAction(action) {
                var binding = new $9761593eb1d92c30$var$Binding(this.context, action);
                this.bindingsByAction.set(action, binding);
                this.delegate.bindingConnected(binding);
            }
        },
        {
            key: "disconnectAction",
            value: function disconnectAction(action) {
                var binding = this.bindingsByAction.get(action);
                if (binding) {
                    this.bindingsByAction["delete"](action);
                    this.delegate.bindingDisconnected(binding);
                }
            }
        },
        {
            key: "disconnectAllActions",
            value: function disconnectAllActions() {
                var _this = this;
                this.bindings.forEach(function(binding) {
                    return _this.delegate.bindingDisconnected(binding, true);
                });
                this.bindingsByAction.clear();
            }
        },
        {
            key: "parseValueForToken",
            value: function parseValueForToken(token) {
                var action = $9761593eb1d92c30$var$Action.forToken(token, this.schema);
                if (action.identifier == this.identifier) return action;
            }
        },
        {
            key: "elementMatchedValue",
            value: function elementMatchedValue(element, action) {
                this.connectAction(action);
            }
        },
        {
            key: "elementUnmatchedValue",
            value: function elementUnmatchedValue(element, action) {
                this.disconnectAction(action);
            }
        }
    ]);
    return BindingObserver;
}();
var $9761593eb1d92c30$var$ValueObserver = /*#__PURE__*/ function() {
    "use strict";
    function ValueObserver(context, receiver) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ValueObserver);
        this.context = context;
        this.receiver = receiver;
        this.stringMapObserver = new $9761593eb1d92c30$export$da226bebbf7f6caa(this.element, this);
        this.valueDescriptorMap = this.controller.valueDescriptorMap;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ValueObserver, [
        {
            key: "start",
            value: function start() {
                this.stringMapObserver.start();
                this.invokeChangedCallbacksForDefaultValues();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.stringMapObserver.stop();
            }
        },
        {
            key: "element",
            get: function get() {
                return this.context.element;
            }
        },
        {
            key: "controller",
            get: function get() {
                return this.context.controller;
            }
        },
        {
            key: "getStringMapKeyForAttribute",
            value: function getStringMapKeyForAttribute(attributeName) {
                if (attributeName in this.valueDescriptorMap) return this.valueDescriptorMap[attributeName].name;
            }
        },
        {
            key: "stringMapKeyAdded",
            value: function stringMapKeyAdded(key, attributeName) {
                var descriptor = this.valueDescriptorMap[attributeName];
                if (!this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), descriptor.writer(descriptor.defaultValue));
            }
        },
        {
            key: "stringMapValueChanged",
            value: function stringMapValueChanged(value, name, oldValue) {
                var descriptor = this.valueDescriptorNameMap[name];
                if (value === null) return;
                if (oldValue === null) oldValue = descriptor.writer(descriptor.defaultValue);
                this.invokeChangedCallback(name, value, oldValue);
            }
        },
        {
            key: "stringMapKeyRemoved",
            value: function stringMapKeyRemoved(key, attributeName, oldValue) {
                var descriptor = this.valueDescriptorNameMap[key];
                if (this.hasValue(key)) this.invokeChangedCallback(key, descriptor.writer(this.receiver[key]), oldValue);
                else this.invokeChangedCallback(key, descriptor.writer(descriptor.defaultValue), oldValue);
            }
        },
        {
            key: "invokeChangedCallbacksForDefaultValues",
            value: function invokeChangedCallbacksForDefaultValues() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.valueDescriptors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, key = _step_value.key, name = _step_value.name, defaultValue = _step_value.defaultValue, writer = _step_value.writer;
                        if (defaultValue != undefined && !this.controller.data.has(key)) this.invokeChangedCallback(name, writer(defaultValue), undefined);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "invokeChangedCallback",
            value: function invokeChangedCallback(name, rawValue, rawOldValue) {
                var changedMethodName = "".concat(name, "Changed");
                var changedMethod = this.receiver[changedMethodName];
                if (typeof changedMethod == "function") {
                    var descriptor = this.valueDescriptorNameMap[name];
                    try {
                        var value = descriptor.reader(rawValue);
                        var oldValue = rawOldValue;
                        if (rawOldValue) oldValue = descriptor.reader(rawOldValue);
                        changedMethod.call(this.receiver, value, oldValue);
                    } catch (error) {
                        if (error instanceof TypeError) error.message = 'Stimulus Value "'.concat(this.context.identifier, ".").concat(descriptor.name, '" - ').concat(error.message);
                        throw error;
                    }
                }
            }
        },
        {
            key: "valueDescriptors",
            get: function get() {
                var valueDescriptorMap = this.valueDescriptorMap;
                return Object.keys(valueDescriptorMap).map(function(key) {
                    return valueDescriptorMap[key];
                });
            }
        },
        {
            key: "valueDescriptorNameMap",
            get: function get() {
                var _this = this;
                var descriptors = {};
                Object.keys(this.valueDescriptorMap).forEach(function(key) {
                    var descriptor = _this.valueDescriptorMap[key];
                    descriptors[descriptor.name] = descriptor;
                });
                return descriptors;
            }
        },
        {
            key: "hasValue",
            value: function hasValue(attributeName) {
                var descriptor = this.valueDescriptorNameMap[attributeName];
                var hasMethodName = "has".concat($9761593eb1d92c30$var$capitalize(descriptor.name));
                return this.receiver[hasMethodName];
            }
        }
    ]);
    return ValueObserver;
}();
var $9761593eb1d92c30$var$TargetObserver = /*#__PURE__*/ function() {
    "use strict";
    function TargetObserver(context, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, TargetObserver);
        this.context = context;
        this.delegate = delegate;
        this.targetsByName = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(TargetObserver, [
        {
            key: "start",
            value: function start() {
                if (!this.tokenListObserver) {
                    this.tokenListObserver = new $9761593eb1d92c30$export$3aa21c2f03ef6b3b(this.element, this.attributeName, this);
                    this.tokenListObserver.start();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.tokenListObserver) {
                    this.disconnectAllTargets();
                    this.tokenListObserver.stop();
                    delete this.tokenListObserver;
                }
            }
        },
        {
            key: "tokenMatched",
            value: function tokenMatched(param) {
                var element = param.element, name = param.content;
                if (this.scope.containsElement(element)) this.connectTarget(element, name);
            }
        },
        {
            key: "tokenUnmatched",
            value: function tokenUnmatched(param) {
                var element = param.element, name = param.content;
                this.disconnectTarget(element, name);
            }
        },
        {
            key: "connectTarget",
            value: function connectTarget(element, name) {
                var _this = this;
                var _a;
                if (!this.targetsByName.has(name, element)) {
                    this.targetsByName.add(name, element);
                    (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.targetConnected(element, name);
                    });
                }
            }
        },
        {
            key: "disconnectTarget",
            value: function disconnectTarget(element, name) {
                var _this = this;
                var _a;
                if (this.targetsByName.has(name, element)) {
                    this.targetsByName["delete"](name, element);
                    (_a = this.tokenListObserver) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.targetDisconnected(element, name);
                    });
                }
            }
        },
        {
            key: "disconnectAllTargets",
            value: function disconnectAllTargets() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = this.targetsByName.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var name = _step.value;
                        try {
                            for(var _iterator1 = this.targetsByName.getValuesForKey(name)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var element = _step1.value;
                                this.disconnectTarget(element, name);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "attributeName",
            get: function get() {
                return "data-".concat(this.context.identifier, "-target");
            }
        },
        {
            key: "element",
            get: function get() {
                return this.context.element;
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        }
    ]);
    return TargetObserver;
}();
function $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, propertyName) {
    var ancestors = $9761593eb1d92c30$var$getAncestorsForConstructor(constructor);
    return Array.from(ancestors.reduce(function(values, constructor) {
        $9761593eb1d92c30$var$getOwnStaticArrayValues(constructor, propertyName).forEach(function(name) {
            return values.add(name);
        });
        return values;
    }, new Set()));
}
function $9761593eb1d92c30$var$readInheritableStaticObjectPairs(constructor, propertyName) {
    var ancestors = $9761593eb1d92c30$var$getAncestorsForConstructor(constructor);
    return ancestors.reduce(function(pairs, constructor) {
        var _pairs;
        (_pairs = pairs).push.apply(_pairs, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)($9761593eb1d92c30$var$getOwnStaticObjectPairs(constructor, propertyName)));
        return pairs;
    }, []);
}
function $9761593eb1d92c30$var$getAncestorsForConstructor(constructor) {
    var ancestors = [];
    while(constructor){
        ancestors.push(constructor);
        constructor = Object.getPrototypeOf(constructor);
    }
    return ancestors.reverse();
}
function $9761593eb1d92c30$var$getOwnStaticArrayValues(constructor, propertyName) {
    var definition = constructor[propertyName];
    return Array.isArray(definition) ? definition : [];
}
function $9761593eb1d92c30$var$getOwnStaticObjectPairs(constructor, propertyName) {
    var definition = constructor[propertyName];
    return definition ? Object.keys(definition).map(function(key) {
        return [
            key,
            definition[key]
        ];
    }) : [];
}
var $9761593eb1d92c30$var$OutletObserver = /*#__PURE__*/ function() {
    "use strict";
    function OutletObserver(context, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, OutletObserver);
        this.started = false;
        this.context = context;
        this.delegate = delegate;
        this.outletsByName = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
        this.outletElementsByName = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
        this.selectorObserverMap = new Map();
        this.attributeObserverMap = new Map();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(OutletObserver, [
        {
            key: "start",
            value: function start() {
                var _this = this;
                if (!this.started) {
                    this.outletDefinitions.forEach(function(outletName) {
                        _this.setupSelectorObserverForOutlet(outletName);
                        _this.setupAttributeObserverForOutlet(outletName);
                    });
                    this.started = true;
                    this.dependentContexts.forEach(function(context) {
                        return context.refresh();
                    });
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.selectorObserverMap.forEach(function(observer) {
                    return observer.refresh();
                });
                this.attributeObserverMap.forEach(function(observer) {
                    return observer.refresh();
                });
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.started) {
                    this.started = false;
                    this.disconnectAllOutlets();
                    this.stopSelectorObservers();
                    this.stopAttributeObservers();
                }
            }
        },
        {
            key: "stopSelectorObservers",
            value: function stopSelectorObservers() {
                if (this.selectorObserverMap.size > 0) {
                    this.selectorObserverMap.forEach(function(observer) {
                        return observer.stop();
                    });
                    this.selectorObserverMap.clear();
                }
            }
        },
        {
            key: "stopAttributeObservers",
            value: function stopAttributeObservers() {
                if (this.attributeObserverMap.size > 0) {
                    this.attributeObserverMap.forEach(function(observer) {
                        return observer.stop();
                    });
                    this.attributeObserverMap.clear();
                }
            }
        },
        {
            key: "selectorMatched",
            value: function selectorMatched(element, _selector, param) {
                var outletName = param.outletName;
                var outlet = this.getOutlet(element, outletName);
                if (outlet) this.connectOutlet(outlet, element, outletName);
            }
        },
        {
            key: "selectorUnmatched",
            value: function selectorUnmatched(element, _selector, param) {
                var outletName = param.outletName;
                var outlet = this.getOutletFromMap(element, outletName);
                if (outlet) this.disconnectOutlet(outlet, element, outletName);
            }
        },
        {
            key: "selectorMatchElement",
            value: function selectorMatchElement(element, param) {
                var outletName = param.outletName;
                var selector = this.selector(outletName);
                var hasOutlet = this.hasOutlet(element, outletName);
                var hasOutletController = element.matches("[".concat(this.schema.controllerAttribute, "~=").concat(outletName, "]"));
                if (selector) return hasOutlet && hasOutletController && element.matches(selector);
                else return false;
            }
        },
        {
            key: "elementMatchedAttribute",
            value: function elementMatchedAttribute(_element, attributeName) {
                var outletName = this.getOutletNameFromOutletAttributeName(attributeName);
                if (outletName) this.updateSelectorObserverForOutlet(outletName);
            }
        },
        {
            key: "elementAttributeValueChanged",
            value: function elementAttributeValueChanged(_element, attributeName) {
                var outletName = this.getOutletNameFromOutletAttributeName(attributeName);
                if (outletName) this.updateSelectorObserverForOutlet(outletName);
            }
        },
        {
            key: "elementUnmatchedAttribute",
            value: function elementUnmatchedAttribute(_element, attributeName) {
                var outletName = this.getOutletNameFromOutletAttributeName(attributeName);
                if (outletName) this.updateSelectorObserverForOutlet(outletName);
            }
        },
        {
            key: "connectOutlet",
            value: function connectOutlet(outlet, element, outletName) {
                var _this = this;
                var _a;
                if (!this.outletElementsByName.has(outletName, element)) {
                    this.outletsByName.add(outletName, outlet);
                    this.outletElementsByName.add(outletName, element);
                    (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.outletConnected(outlet, element, outletName);
                    });
                }
            }
        },
        {
            key: "disconnectOutlet",
            value: function disconnectOutlet(outlet, element, outletName) {
                var _this = this;
                var _a;
                if (this.outletElementsByName.has(outletName, element)) {
                    this.outletsByName["delete"](outletName, outlet);
                    this.outletElementsByName["delete"](outletName, element);
                    (_a = this.selectorObserverMap.get(outletName)) === null || _a === void 0 || _a.pause(function() {
                        return _this.delegate.outletDisconnected(outlet, element, outletName);
                    });
                }
            }
        },
        {
            key: "disconnectAllOutlets",
            value: function disconnectAllOutlets() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.outletElementsByName.keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var outletName = _step.value;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator1 = this.outletElementsByName.getValuesForKey(outletName)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion2 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion2 = true){
                                var element = _step1.value;
                                try {
                                    for(var _iterator2 = this.outletsByName.getValuesForKey(outletName)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion1 = true){
                                        var outlet = _step2.value;
                                        this.disconnectOutlet(outlet, element, outletName);
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator2["return"] != null) {
                                            _iterator2["return"]();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator1["return"] != null) {
                                    _iterator1["return"]();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "updateSelectorObserverForOutlet",
            value: function updateSelectorObserverForOutlet(outletName) {
                var observer = this.selectorObserverMap.get(outletName);
                if (observer) observer.selector = this.selector(outletName);
            }
        },
        {
            key: "setupSelectorObserverForOutlet",
            value: function setupSelectorObserverForOutlet(outletName) {
                var selector = this.selector(outletName);
                var selectorObserver = new $9761593eb1d92c30$export$116e0b48509995b(document.body, selector, this, {
                    outletName: outletName
                });
                this.selectorObserverMap.set(outletName, selectorObserver);
                selectorObserver.start();
            }
        },
        {
            key: "setupAttributeObserverForOutlet",
            value: function setupAttributeObserverForOutlet(outletName) {
                var attributeName = this.attributeNameForOutletName(outletName);
                var attributeObserver = new $9761593eb1d92c30$export$fe68319d413d05cb(this.scope.element, attributeName, this);
                this.attributeObserverMap.set(outletName, attributeObserver);
                attributeObserver.start();
            }
        },
        {
            key: "selector",
            value: function selector(outletName) {
                return this.scope.outlets.getSelectorForOutletName(outletName);
            }
        },
        {
            key: "attributeNameForOutletName",
            value: function attributeNameForOutletName(outletName) {
                return this.scope.schema.outletAttributeForScope(this.identifier, outletName);
            }
        },
        {
            key: "getOutletNameFromOutletAttributeName",
            value: function getOutletNameFromOutletAttributeName(attributeName) {
                var _this = this;
                return this.outletDefinitions.find(function(outletName) {
                    return _this.attributeNameForOutletName(outletName) === attributeName;
                });
            }
        },
        {
            key: "outletDependencies",
            get: function get() {
                var dependencies = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
                this.router.modules.forEach(function(module) {
                    var constructor = module.definition.controllerConstructor;
                    var outlets = $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, "outlets");
                    outlets.forEach(function(outlet) {
                        return dependencies.add(outlet, module.identifier);
                    });
                });
                return dependencies;
            }
        },
        {
            key: "outletDefinitions",
            get: function get() {
                return this.outletDependencies.getKeysForValue(this.identifier);
            }
        },
        {
            key: "dependentControllerIdentifiers",
            get: function get() {
                return this.outletDependencies.getValuesForKey(this.identifier);
            }
        },
        {
            key: "dependentContexts",
            get: function get() {
                var identifiers = this.dependentControllerIdentifiers;
                return this.router.contexts.filter(function(context) {
                    return identifiers.includes(context.identifier);
                });
            }
        },
        {
            key: "hasOutlet",
            value: function hasOutlet(element, outletName) {
                return !!this.getOutlet(element, outletName) || !!this.getOutletFromMap(element, outletName);
            }
        },
        {
            key: "getOutlet",
            value: function getOutlet(element, outletName) {
                return this.application.getControllerForElementAndIdentifier(element, outletName);
            }
        },
        {
            key: "getOutletFromMap",
            value: function getOutletFromMap(element, outletName) {
                return this.outletsByName.getValuesForKey(outletName).find(function(outlet) {
                    return outlet.element === element;
                });
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.context.schema;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.context.identifier;
            }
        },
        {
            key: "application",
            get: function get() {
                return this.context.application;
            }
        },
        {
            key: "router",
            get: function get() {
                return this.application.router;
            }
        }
    ]);
    return OutletObserver;
}();
var $9761593eb1d92c30$export$841858b892ce1f4c = /*#__PURE__*/ function() {
    "use strict";
    function Context(module, scope) {
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Context);
        this.logDebugActivity = function(functionName) {
            var detail = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var identifier = _this.identifier, controller = _this.controller, element = _this.element;
            detail = Object.assign({
                identifier: identifier,
                controller: controller,
                element: element
            }, detail);
            _this.application.logDebugActivity(_this.identifier, functionName, detail);
        };
        this.module = module;
        this.scope = scope;
        this.controller = new module.controllerConstructor(this);
        this.bindingObserver = new $9761593eb1d92c30$var$BindingObserver(this, this.dispatcher);
        this.valueObserver = new $9761593eb1d92c30$var$ValueObserver(this, this.controller);
        this.targetObserver = new $9761593eb1d92c30$var$TargetObserver(this, this);
        this.outletObserver = new $9761593eb1d92c30$var$OutletObserver(this, this);
        try {
            this.controller.initialize();
            this.logDebugActivity("initialize");
        } catch (error) {
            this.handleError(error, "initializing controller");
        }
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Context, [
        {
            key: "connect",
            value: function connect() {
                this.bindingObserver.start();
                this.valueObserver.start();
                this.targetObserver.start();
                this.outletObserver.start();
                try {
                    this.controller.connect();
                    this.logDebugActivity("connect");
                } catch (error) {
                    this.handleError(error, "connecting controller");
                }
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                this.outletObserver.refresh();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                try {
                    this.controller.disconnect();
                    this.logDebugActivity("disconnect");
                } catch (error) {
                    this.handleError(error, "disconnecting controller");
                }
                this.outletObserver.stop();
                this.targetObserver.stop();
                this.valueObserver.stop();
                this.bindingObserver.stop();
            }
        },
        {
            key: "application",
            get: function get() {
                return this.module.application;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.module.identifier;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.application.schema;
            }
        },
        {
            key: "dispatcher",
            get: function get() {
                return this.application.dispatcher;
            }
        },
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "parentElement",
            get: function get() {
                return this.element.parentElement;
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message) {
                var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this, identifier = _this.identifier, controller = _this.controller, element = _this.element;
                detail = Object.assign({
                    identifier: identifier,
                    controller: controller,
                    element: element
                }, detail);
                this.application.handleError(error, "Error ".concat(message), detail);
            }
        },
        {
            key: "targetConnected",
            value: function targetConnected(element, name) {
                this.invokeControllerMethod("".concat(name, "TargetConnected"), element);
            }
        },
        {
            key: "targetDisconnected",
            value: function targetDisconnected(element, name) {
                this.invokeControllerMethod("".concat(name, "TargetDisconnected"), element);
            }
        },
        {
            key: "outletConnected",
            value: function outletConnected(outlet, element, name) {
                this.invokeControllerMethod("".concat($9761593eb1d92c30$var$namespaceCamelize(name), "OutletConnected"), outlet, element);
            }
        },
        {
            key: "outletDisconnected",
            value: function outletDisconnected(outlet, element, name) {
                this.invokeControllerMethod("".concat($9761593eb1d92c30$var$namespaceCamelize(name), "OutletDisconnected"), outlet, element);
            }
        },
        {
            key: "invokeControllerMethod",
            value: function invokeControllerMethod(methodName) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var _controller;
                var controller = this.controller;
                if (typeof controller[methodName] == "function") (_controller = controller)[methodName].apply(_controller, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
            }
        }
    ]);
    return Context;
}();
function $9761593eb1d92c30$var$bless(constructor) {
    return $9761593eb1d92c30$var$shadow(constructor, $9761593eb1d92c30$var$getBlessedProperties(constructor));
}
function $9761593eb1d92c30$var$shadow(constructor, properties) {
    var shadowConstructor = $9761593eb1d92c30$var$extend(constructor);
    var shadowProperties = $9761593eb1d92c30$var$getShadowProperties(constructor.prototype, properties);
    Object.defineProperties(shadowConstructor.prototype, shadowProperties);
    return shadowConstructor;
}
function $9761593eb1d92c30$var$getBlessedProperties(constructor) {
    var blessings = $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, "blessings");
    return blessings.reduce(function(blessedProperties, blessing) {
        var properties = blessing(constructor);
        for(var key in properties){
            var descriptor = blessedProperties[key] || {};
            blessedProperties[key] = Object.assign(descriptor, properties[key]);
        }
        return blessedProperties;
    }, {});
}
function $9761593eb1d92c30$var$getShadowProperties(prototype, properties) {
    return $9761593eb1d92c30$var$getOwnKeys(properties).reduce(function(shadowProperties, key) {
        var descriptor = $9761593eb1d92c30$var$getShadowedDescriptor(prototype, properties, key);
        if (descriptor) Object.assign(shadowProperties, (0, $a6437d79afda84c4$export$71511d61b312f219)({}, key, descriptor));
        return shadowProperties;
    }, {});
}
function $9761593eb1d92c30$var$getShadowedDescriptor(prototype, properties, key) {
    var shadowingDescriptor = Object.getOwnPropertyDescriptor(prototype, key);
    var shadowedByValue = shadowingDescriptor && "value" in shadowingDescriptor;
    if (!shadowedByValue) {
        var descriptor = Object.getOwnPropertyDescriptor(properties, key).value;
        if (shadowingDescriptor) {
            descriptor.get = shadowingDescriptor.get || descriptor.get;
            descriptor.set = shadowingDescriptor.set || descriptor.set;
        }
        return descriptor;
    }
}
var $9761593eb1d92c30$var$getOwnKeys = function() {
    if (typeof Object.getOwnPropertySymbols == "function") return function(object) {
        return (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(Object.getOwnPropertyNames(object)).concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(Object.getOwnPropertySymbols(object)));
    };
    else return Object.getOwnPropertyNames;
}();
var $9761593eb1d92c30$var$extend = function _target() {
    var extendWithReflect = function extendWithReflect(constructor) {
        function extended() {
            return Reflect.construct(constructor, arguments, this instanceof extended ? this.constructor : void 0);
        }
        extended.prototype = Object.create(constructor.prototype, {
            constructor: {
                value: extended
            }
        });
        Reflect.setPrototypeOf(extended, constructor);
        return extended;
    };
    var testReflectExtension = function testReflectExtension() {
        var a = function a() {
            this.a.call(this);
        };
        var b = extendWithReflect(a);
        b.prototype.a = function() {};
        return new b();
    };
    try {
        testReflectExtension();
        return extendWithReflect;
    } catch (error) {
        return function(constructor) {
            return /*#__PURE__*/ function(constructor) {
                "use strict";
                (0, $28f6179e2b599279$export$71511d61b312f219)(extended, constructor);
                var _super = (0, $1c23ba689bfccaac$export$71511d61b312f219)(extended);
                function extended() {
                    (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, extended);
                    return _super.apply(this, arguments);
                }
                return extended;
            }(constructor);
        };
    }
}();
function $9761593eb1d92c30$var$blessDefinition(definition) {
    return {
        identifier: definition.identifier,
        controllerConstructor: $9761593eb1d92c30$var$bless(definition.controllerConstructor)
    };
}
var $9761593eb1d92c30$var$Module = /*#__PURE__*/ function() {
    "use strict";
    function Module(application, definition) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Module);
        this.application = application;
        this.definition = $9761593eb1d92c30$var$blessDefinition(definition);
        this.contextsByScope = new WeakMap();
        this.connectedContexts = new Set();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Module, [
        {
            key: "identifier",
            get: function get() {
                return this.definition.identifier;
            }
        },
        {
            key: "controllerConstructor",
            get: function get() {
                return this.definition.controllerConstructor;
            }
        },
        {
            key: "contexts",
            get: function get() {
                return Array.from(this.connectedContexts);
            }
        },
        {
            key: "connectContextForScope",
            value: function connectContextForScope(scope) {
                var context = this.fetchContextForScope(scope);
                this.connectedContexts.add(context);
                context.connect();
            }
        },
        {
            key: "disconnectContextForScope",
            value: function disconnectContextForScope(scope) {
                var context = this.contextsByScope.get(scope);
                if (context) {
                    this.connectedContexts["delete"](context);
                    context.disconnect();
                }
            }
        },
        {
            key: "fetchContextForScope",
            value: function fetchContextForScope(scope) {
                var context = this.contextsByScope.get(scope);
                if (!context) {
                    context = new $9761593eb1d92c30$export$841858b892ce1f4c(this, scope);
                    this.contextsByScope.set(scope, context);
                }
                return context;
            }
        }
    ]);
    return Module;
}();
var $9761593eb1d92c30$var$ClassMap = /*#__PURE__*/ function() {
    "use strict";
    function ClassMap(scope) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ClassMap);
        this.scope = scope;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ClassMap, [
        {
            key: "has",
            value: function has(name) {
                return this.data.has(this.getDataKey(name));
            }
        },
        {
            key: "get",
            value: function get(name) {
                return this.getAll(name)[0];
            }
        },
        {
            key: "getAll",
            value: function getAll(name) {
                var tokenString = this.data.get(this.getDataKey(name)) || "";
                return $9761593eb1d92c30$var$tokenize(tokenString);
            }
        },
        {
            key: "getAttributeName",
            value: function getAttributeName(name) {
                return this.data.getAttributeNameForKey(this.getDataKey(name));
            }
        },
        {
            key: "getDataKey",
            value: function getDataKey(name) {
                return "".concat(name, "-class");
            }
        },
        {
            key: "data",
            get: function get() {
                return this.scope.data;
            }
        }
    ]);
    return ClassMap;
}();
var $9761593eb1d92c30$var$DataMap = /*#__PURE__*/ function() {
    "use strict";
    function DataMap(scope) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, DataMap);
        this.scope = scope;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(DataMap, [
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "get",
            value: function get(key) {
                var name = this.getAttributeNameForKey(key);
                return this.element.getAttribute(name);
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                var name = this.getAttributeNameForKey(key);
                this.element.setAttribute(name, value);
                return this.get(key);
            }
        },
        {
            key: "has",
            value: function has(key) {
                var name = this.getAttributeNameForKey(key);
                return this.element.hasAttribute(name);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                if (this.has(key)) {
                    var name = this.getAttributeNameForKey(key);
                    this.element.removeAttribute(name);
                    return true;
                } else return false;
            }
        },
        {
            key: "getAttributeNameForKey",
            value: function getAttributeNameForKey(key) {
                return "data-".concat(this.identifier, "-").concat($9761593eb1d92c30$var$dasherize(key));
            }
        }
    ]);
    return DataMap;
}();
var $9761593eb1d92c30$var$Guide = /*#__PURE__*/ function() {
    "use strict";
    function Guide(logger) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Guide);
        this.warnedKeysByObject = new WeakMap();
        this.logger = logger;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Guide, [
        {
            key: "warn",
            value: function warn(object, key, message) {
                var warnedKeys = this.warnedKeysByObject.get(object);
                if (!warnedKeys) {
                    warnedKeys = new Set();
                    this.warnedKeysByObject.set(object, warnedKeys);
                }
                if (!warnedKeys.has(key)) {
                    warnedKeys.add(key);
                    this.logger.warn(message, object);
                }
            }
        }
    ]);
    return Guide;
}();
function $9761593eb1d92c30$var$attributeValueContainsToken(attributeName, token) {
    return "[".concat(attributeName, '~="').concat(token, '"]');
}
var $9761593eb1d92c30$var$TargetSet = /*#__PURE__*/ function() {
    "use strict";
    function TargetSet(scope) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, TargetSet);
        this.scope = scope;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(TargetSet, [
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.scope.schema;
            }
        },
        {
            key: "has",
            value: function has(targetName) {
                return this.find(targetName) != null;
            }
        },
        {
            key: "find",
            value: function find() {
                var _this = this;
                for(var _len = arguments.length, targetNames = new Array(_len), _key = 0; _key < _len; _key++){
                    targetNames[_key] = arguments[_key];
                }
                return targetNames.reduce(function(target, targetName) {
                    return target || _this.findTarget(targetName) || _this.findLegacyTarget(targetName);
                }, undefined);
            }
        },
        {
            key: "findAll",
            value: function findAll() {
                var _this = this;
                for(var _len = arguments.length, targetNames = new Array(_len), _key = 0; _key < _len; _key++){
                    targetNames[_key] = arguments[_key];
                }
                return targetNames.reduce(function(targets, targetName) {
                    return (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(targets).concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(_this.findAllTargets(targetName)), (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(_this.findAllLegacyTargets(targetName)));
                }, []);
            }
        },
        {
            key: "findTarget",
            value: function findTarget(targetName) {
                var selector = this.getSelectorForTargetName(targetName);
                return this.scope.findElement(selector);
            }
        },
        {
            key: "findAllTargets",
            value: function findAllTargets(targetName) {
                var selector = this.getSelectorForTargetName(targetName);
                return this.scope.findAllElements(selector);
            }
        },
        {
            key: "getSelectorForTargetName",
            value: function getSelectorForTargetName(targetName) {
                var attributeName = this.schema.targetAttributeForScope(this.identifier);
                return $9761593eb1d92c30$var$attributeValueContainsToken(attributeName, targetName);
            }
        },
        {
            key: "findLegacyTarget",
            value: function findLegacyTarget(targetName) {
                var selector = this.getLegacySelectorForTargetName(targetName);
                return this.deprecate(this.scope.findElement(selector), targetName);
            }
        },
        {
            key: "findAllLegacyTargets",
            value: function findAllLegacyTargets(targetName) {
                var _this = this;
                var selector = this.getLegacySelectorForTargetName(targetName);
                return this.scope.findAllElements(selector).map(function(element) {
                    return _this.deprecate(element, targetName);
                });
            }
        },
        {
            key: "getLegacySelectorForTargetName",
            value: function getLegacySelectorForTargetName(targetName) {
                var targetDescriptor = "".concat(this.identifier, ".").concat(targetName);
                return $9761593eb1d92c30$var$attributeValueContainsToken(this.schema.targetAttribute, targetDescriptor);
            }
        },
        {
            key: "deprecate",
            value: function deprecate(element, targetName) {
                if (element) {
                    var identifier = this.identifier;
                    var attributeName = this.schema.targetAttribute;
                    var revisedAttributeName = this.schema.targetAttributeForScope(identifier);
                    this.guide.warn(element, "target:".concat(targetName), "Please replace ".concat(attributeName, '="').concat(identifier, ".").concat(targetName, '" with ').concat(revisedAttributeName, '="').concat(targetName, '". ') + "The ".concat(attributeName, " attribute is deprecated and will be removed in a future version of Stimulus."));
                }
                return element;
            }
        },
        {
            key: "guide",
            get: function get() {
                return this.scope.guide;
            }
        }
    ]);
    return TargetSet;
}();
var $9761593eb1d92c30$var$OutletSet = /*#__PURE__*/ function() {
    "use strict";
    function OutletSet(scope, controllerElement) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, OutletSet);
        this.scope = scope;
        this.controllerElement = controllerElement;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(OutletSet, [
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.scope.schema;
            }
        },
        {
            key: "has",
            value: function has(outletName) {
                return this.find(outletName) != null;
            }
        },
        {
            key: "find",
            value: function find() {
                var _this = this;
                for(var _len = arguments.length, outletNames = new Array(_len), _key = 0; _key < _len; _key++){
                    outletNames[_key] = arguments[_key];
                }
                return outletNames.reduce(function(outlet, outletName) {
                    return outlet || _this.findOutlet(outletName);
                }, undefined);
            }
        },
        {
            key: "findAll",
            value: function findAll() {
                var _this = this;
                for(var _len = arguments.length, outletNames = new Array(_len), _key = 0; _key < _len; _key++){
                    outletNames[_key] = arguments[_key];
                }
                return outletNames.reduce(function(outlets, outletName) {
                    return (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(outlets).concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(_this.findAllOutlets(outletName)));
                }, []);
            }
        },
        {
            key: "getSelectorForOutletName",
            value: function getSelectorForOutletName(outletName) {
                var attributeName = this.schema.outletAttributeForScope(this.identifier, outletName);
                return this.controllerElement.getAttribute(attributeName);
            }
        },
        {
            key: "findOutlet",
            value: function findOutlet(outletName) {
                var selector = this.getSelectorForOutletName(outletName);
                if (selector) return this.findElement(selector, outletName);
            }
        },
        {
            key: "findAllOutlets",
            value: function findAllOutlets(outletName) {
                var selector = this.getSelectorForOutletName(outletName);
                return selector ? this.findAllElements(selector, outletName) : [];
            }
        },
        {
            key: "findElement",
            value: function findElement(selector, outletName) {
                var _this = this;
                var elements = this.scope.queryElements(selector);
                return elements.filter(function(element) {
                    return _this.matchesElement(element, selector, outletName);
                })[0];
            }
        },
        {
            key: "findAllElements",
            value: function findAllElements(selector, outletName) {
                var _this = this;
                var elements = this.scope.queryElements(selector);
                return elements.filter(function(element) {
                    return _this.matchesElement(element, selector, outletName);
                });
            }
        },
        {
            key: "matchesElement",
            value: function matchesElement(element, selector, outletName) {
                var controllerAttribute = element.getAttribute(this.scope.schema.controllerAttribute) || "";
                return element.matches(selector) && controllerAttribute.split(" ").includes(outletName);
            }
        }
    ]);
    return OutletSet;
}();
var $9761593eb1d92c30$var$Scope = /*#__PURE__*/ function() {
    "use strict";
    function Scope(schema, element, identifier, logger) {
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Scope);
        this.targets = new $9761593eb1d92c30$var$TargetSet(this);
        this.classes = new $9761593eb1d92c30$var$ClassMap(this);
        this.data = new $9761593eb1d92c30$var$DataMap(this);
        this.containsElement = function(element) {
            return element.closest(_this.controllerSelector) === _this.element;
        };
        this.schema = schema;
        this.element = element;
        this.identifier = identifier;
        this.guide = new $9761593eb1d92c30$var$Guide(logger);
        this.outlets = new $9761593eb1d92c30$var$OutletSet(this.documentScope, element);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Scope, [
        {
            key: "findElement",
            value: function findElement(selector) {
                return this.element.matches(selector) ? this.element : this.queryElements(selector).find(this.containsElement);
            }
        },
        {
            key: "findAllElements",
            value: function findAllElements(selector) {
                return (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(this.element.matches(selector) ? [
                    this.element
                ] : []).concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(this.queryElements(selector).filter(this.containsElement)));
            }
        },
        {
            key: "queryElements",
            value: function queryElements(selector) {
                return Array.from(this.element.querySelectorAll(selector));
            }
        },
        {
            key: "controllerSelector",
            get: function get() {
                return $9761593eb1d92c30$var$attributeValueContainsToken(this.schema.controllerAttribute, this.identifier);
            }
        },
        {
            key: "isDocumentScope",
            get: function get() {
                return this.element === document.documentElement;
            }
        },
        {
            key: "documentScope",
            get: function get() {
                return this.isDocumentScope ? this : new Scope(this.schema, document.documentElement, this.identifier, this.guide.logger);
            }
        }
    ]);
    return Scope;
}();
var $9761593eb1d92c30$var$ScopeObserver = /*#__PURE__*/ function() {
    "use strict";
    function ScopeObserver(element, schema, delegate) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, ScopeObserver);
        this.element = element;
        this.schema = schema;
        this.delegate = delegate;
        this.valueListObserver = new $9761593eb1d92c30$export$d27fa4c7330a452e(this.element, this.controllerAttribute, this);
        this.scopesByIdentifierByElement = new WeakMap();
        this.scopeReferenceCounts = new WeakMap();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(ScopeObserver, [
        {
            key: "start",
            value: function start() {
                this.valueListObserver.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.valueListObserver.stop();
            }
        },
        {
            key: "controllerAttribute",
            get: function get() {
                return this.schema.controllerAttribute;
            }
        },
        {
            key: "parseValueForToken",
            value: function parseValueForToken(token) {
                var element = token.element, identifier = token.content;
                return this.parseValueForElementAndIdentifier(element, identifier);
            }
        },
        {
            key: "parseValueForElementAndIdentifier",
            value: function parseValueForElementAndIdentifier(element, identifier) {
                var scopesByIdentifier = this.fetchScopesByIdentifierForElement(element);
                var scope = scopesByIdentifier.get(identifier);
                if (!scope) {
                    scope = this.delegate.createScopeForElementAndIdentifier(element, identifier);
                    scopesByIdentifier.set(identifier, scope);
                }
                return scope;
            }
        },
        {
            key: "elementMatchedValue",
            value: function elementMatchedValue(element, value) {
                var referenceCount = (this.scopeReferenceCounts.get(value) || 0) + 1;
                this.scopeReferenceCounts.set(value, referenceCount);
                if (referenceCount == 1) this.delegate.scopeConnected(value);
            }
        },
        {
            key: "elementUnmatchedValue",
            value: function elementUnmatchedValue(element, value) {
                var referenceCount = this.scopeReferenceCounts.get(value);
                if (referenceCount) {
                    this.scopeReferenceCounts.set(value, referenceCount - 1);
                    if (referenceCount == 1) this.delegate.scopeDisconnected(value);
                }
            }
        },
        {
            key: "fetchScopesByIdentifierForElement",
            value: function fetchScopesByIdentifierForElement(element) {
                var scopesByIdentifier = this.scopesByIdentifierByElement.get(element);
                if (!scopesByIdentifier) {
                    scopesByIdentifier = new Map();
                    this.scopesByIdentifierByElement.set(element, scopesByIdentifier);
                }
                return scopesByIdentifier;
            }
        }
    ]);
    return ScopeObserver;
}();
var $9761593eb1d92c30$var$Router = /*#__PURE__*/ function() {
    "use strict";
    function Router(application) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Router);
        this.application = application;
        this.scopeObserver = new $9761593eb1d92c30$var$ScopeObserver(this.element, this.schema, this);
        this.scopesByIdentifier = new $9761593eb1d92c30$export$8bd4ad37b76db6ba();
        this.modulesByIdentifier = new Map();
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Router, [
        {
            key: "element",
            get: function get() {
                return this.application.element;
            }
        },
        {
            key: "schema",
            get: function get() {
                return this.application.schema;
            }
        },
        {
            key: "logger",
            get: function get() {
                return this.application.logger;
            }
        },
        {
            key: "controllerAttribute",
            get: function get() {
                return this.schema.controllerAttribute;
            }
        },
        {
            key: "modules",
            get: function get() {
                return Array.from(this.modulesByIdentifier.values());
            }
        },
        {
            key: "contexts",
            get: function get() {
                return this.modules.reduce(function(contexts, module) {
                    return contexts.concat(module.contexts);
                }, []);
            }
        },
        {
            key: "start",
            value: function start() {
                this.scopeObserver.start();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.scopeObserver.stop();
            }
        },
        {
            key: "loadDefinition",
            value: function loadDefinition(definition) {
                this.unloadIdentifier(definition.identifier);
                var module = new $9761593eb1d92c30$var$Module(this.application, definition);
                this.connectModule(module);
                var afterLoad = definition.controllerConstructor.afterLoad;
                if (afterLoad) afterLoad.call(definition.controllerConstructor, definition.identifier, this.application);
            }
        },
        {
            key: "unloadIdentifier",
            value: function unloadIdentifier(identifier) {
                var module = this.modulesByIdentifier.get(identifier);
                if (module) this.disconnectModule(module);
            }
        },
        {
            key: "getContextForElementAndIdentifier",
            value: function getContextForElementAndIdentifier(element, identifier) {
                var module = this.modulesByIdentifier.get(identifier);
                if (module) return module.contexts.find(function(context) {
                    return context.element == element;
                });
            }
        },
        {
            key: "proposeToConnectScopeForElementAndIdentifier",
            value: function proposeToConnectScopeForElementAndIdentifier(element, identifier) {
                var scope = this.scopeObserver.parseValueForElementAndIdentifier(element, identifier);
                if (scope) this.scopeObserver.elementMatchedValue(scope.element, scope);
                else console.error("Couldn't find or create scope for identifier: \"".concat(identifier, '" and element:'), element);
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message, detail) {
                this.application.handleError(error, message, detail);
            }
        },
        {
            key: "createScopeForElementAndIdentifier",
            value: function createScopeForElementAndIdentifier(element, identifier) {
                return new $9761593eb1d92c30$var$Scope(this.schema, element, identifier, this.logger);
            }
        },
        {
            key: "scopeConnected",
            value: function scopeConnected(scope) {
                this.scopesByIdentifier.add(scope.identifier, scope);
                var module = this.modulesByIdentifier.get(scope.identifier);
                if (module) module.connectContextForScope(scope);
            }
        },
        {
            key: "scopeDisconnected",
            value: function scopeDisconnected(scope) {
                this.scopesByIdentifier["delete"](scope.identifier, scope);
                var module = this.modulesByIdentifier.get(scope.identifier);
                if (module) module.disconnectContextForScope(scope);
            }
        },
        {
            key: "connectModule",
            value: function connectModule(module) {
                this.modulesByIdentifier.set(module.identifier, module);
                var scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
                scopes.forEach(function(scope) {
                    return module.connectContextForScope(scope);
                });
            }
        },
        {
            key: "disconnectModule",
            value: function disconnectModule(module) {
                this.modulesByIdentifier["delete"](module.identifier);
                var scopes = this.scopesByIdentifier.getValuesForKey(module.identifier);
                scopes.forEach(function(scope) {
                    return module.disconnectContextForScope(scope);
                });
            }
        }
    ]);
    return Router;
}();
var $9761593eb1d92c30$export$1db618b7b2275ea1 = {
    controllerAttribute: "data-controller",
    actionAttribute: "data-action",
    targetAttribute: "data-target",
    targetAttributeForScope: function(identifier) {
        return "data-".concat(identifier, "-target");
    },
    outletAttributeForScope: function(identifier, outlet) {
        return "data-".concat(identifier, "-").concat(outlet, "-outlet");
    },
    keyMappings: Object.assign(Object.assign({
        enter: "Enter",
        tab: "Tab",
        esc: "Escape",
        space: " ",
        up: "ArrowUp",
        down: "ArrowDown",
        left: "ArrowLeft",
        right: "ArrowRight",
        home: "Home",
        end: "End",
        page_up: "PageUp",
        page_down: "PageDown"
    }, $9761593eb1d92c30$var$objectFromEntries("abcdefghijklmnopqrstuvwxyz".split("").map(function(c) {
        return [
            c,
            c
        ];
    }))), $9761593eb1d92c30$var$objectFromEntries("0123456789".split("").map(function(n) {
        return [
            n,
            n
        ];
    })))
};
function $9761593eb1d92c30$var$objectFromEntries(array) {
    return array.reduce(function(memo, param) {
        var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), k = _param[0], v = _param[1];
        return Object.assign(Object.assign({}, memo), (0, $a6437d79afda84c4$export$71511d61b312f219)({}, k, v));
    }, {});
}
var $9761593eb1d92c30$export$16975c34e60e1e61 = /*#__PURE__*/ function() {
    "use strict";
    function Application() {
        var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.documentElement, schema = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $9761593eb1d92c30$export$1db618b7b2275ea1;
        var _this = this;
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Application);
        this.logger = console;
        this.debug = false;
        this.logDebugActivity = function(identifier, functionName) {
            var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (_this.debug) _this.logFormattedMessage(identifier, functionName, detail);
        };
        this.element = element;
        this.schema = schema;
        this.dispatcher = new $9761593eb1d92c30$var$Dispatcher(this);
        this.router = new $9761593eb1d92c30$var$Router(this);
        this.actionDescriptorFilters = Object.assign({}, $9761593eb1d92c30$var$defaultActionDescriptorFilters);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Application, [
        {
            key: "start",
            value: function start() {
                var _this = this;
                return (0, $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    $9761593eb1d92c30$var$domReady()
                                ];
                            case 1:
                                _state.sent();
                                _this.logDebugActivity("application", "starting");
                                _this.dispatcher.start();
                                _this.router.start();
                                _this.logDebugActivity("application", "start");
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.logDebugActivity("application", "stopping");
                this.dispatcher.stop();
                this.router.stop();
                this.logDebugActivity("application", "stop");
            }
        },
        {
            key: "register",
            value: function register(identifier, controllerConstructor) {
                this.load({
                    identifier: identifier,
                    controllerConstructor: controllerConstructor
                });
            }
        },
        {
            key: "registerActionOption",
            value: function registerActionOption(name, filter) {
                this.actionDescriptorFilters[name] = filter;
            }
        },
        {
            key: "load",
            value: function load(head) {
                var _this = this;
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                var definitions = Array.isArray(head) ? head : [
                    head
                ].concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(rest));
                definitions.forEach(function(definition) {
                    if (definition.controllerConstructor.shouldLoad) _this.router.loadDefinition(definition);
                });
            }
        },
        {
            key: "unload",
            value: function unload(head) {
                var _this = this;
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                var identifiers = Array.isArray(head) ? head : [
                    head
                ].concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(rest));
                identifiers.forEach(function(identifier) {
                    return _this.router.unloadIdentifier(identifier);
                });
            }
        },
        {
            key: "controllers",
            get: function get() {
                return this.router.contexts.map(function(context) {
                    return context.controller;
                });
            }
        },
        {
            key: "getControllerForElementAndIdentifier",
            value: function getControllerForElementAndIdentifier(element, identifier) {
                var context = this.router.getContextForElementAndIdentifier(element, identifier);
                return context ? context.controller : null;
            }
        },
        {
            key: "handleError",
            value: function handleError(error, message, detail) {
                var _a;
                this.logger.error("%s\n\n%o\n\n%o", message, error, detail);
                (_a = window.onerror) === null || _a === void 0 || _a.call(window, message, "", 0, 0, error);
            }
        },
        {
            key: "logFormattedMessage",
            value: function logFormattedMessage(identifier, functionName) {
                var detail = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                detail = Object.assign({
                    application: this
                }, detail);
                this.logger.groupCollapsed("".concat(identifier, " #").concat(functionName));
                this.logger.log("details:", Object.assign({}, detail));
                this.logger.groupEnd();
            }
        }
    ], [
        {
            key: "start",
            value: function start(element, schema) {
                var application = new this(element, schema);
                application.start();
                return application;
            }
        }
    ]);
    return Application;
}();
function $9761593eb1d92c30$var$domReady() {
    return new Promise(function(resolve) {
        if (document.readyState == "loading") document.addEventListener("DOMContentLoaded", function() {
            return resolve();
        });
        else resolve();
    });
}
function $9761593eb1d92c30$var$ClassPropertiesBlessing(constructor) {
    var classes = $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, "classes");
    return classes.reduce(function(properties, classDefinition) {
        return Object.assign(properties, $9761593eb1d92c30$var$propertiesForClassDefinition(classDefinition));
    }, {});
}
function $9761593eb1d92c30$var$propertiesForClassDefinition(key) {
    var _obj;
    return _obj = {}, (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(key, "Class"), {
        get: function() {
            var classes = this.classes;
            if (classes.has(key)) return classes.get(key);
            else {
                var attribute = classes.getAttributeName(key);
                throw new Error('Missing attribute "'.concat(attribute, '"'));
            }
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(key, "Classes"), {
        get: function() {
            return this.classes.getAll(key);
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "has".concat($9761593eb1d92c30$var$capitalize(key), "Class"), {
        get: function() {
            return this.classes.has(key);
        }
    }), _obj;
}
function $9761593eb1d92c30$var$OutletPropertiesBlessing(constructor) {
    var outlets = $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, "outlets");
    return outlets.reduce(function(properties, outletDefinition) {
        return Object.assign(properties, $9761593eb1d92c30$var$propertiesForOutletDefinition(outletDefinition));
    }, {});
}
function $9761593eb1d92c30$var$getOutletController(controller, element, identifier) {
    return controller.application.getControllerForElementAndIdentifier(element, identifier);
}
function $9761593eb1d92c30$var$getControllerAndEnsureConnectedScope(controller, element, outletName) {
    var outletController = $9761593eb1d92c30$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
    controller.application.router.proposeToConnectScopeForElementAndIdentifier(element, outletName);
    outletController = $9761593eb1d92c30$var$getOutletController(controller, element, outletName);
    if (outletController) return outletController;
}
function $9761593eb1d92c30$var$propertiesForOutletDefinition(name) {
    var camelizedName = $9761593eb1d92c30$var$namespaceCamelize(name);
    var _obj;
    return _obj = {}, (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(camelizedName, "Outlet"), {
        get: function() {
            var outletElement = this.outlets.find(name);
            var selector = this.outlets.getSelectorForOutletName(name);
            if (outletElement) {
                var outletController = $9761593eb1d92c30$var$getControllerAndEnsureConnectedScope(this, outletElement, name);
                if (outletController) return outletController;
                throw new Error('The provided outlet element is missing an outlet controller "'.concat(name, '" instance for host controller "').concat(this.identifier, '"'));
            }
            throw new Error('Missing outlet element "'.concat(name, '" for host controller "').concat(this.identifier, '". Stimulus couldn\'t find a matching outlet element using selector "').concat(selector, '".'));
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(camelizedName, "Outlets"), {
        get: function() {
            var _this = this;
            var outlets = this.outlets.findAll(name);
            if (outlets.length > 0) return outlets.map(function(outletElement) {
                var outletController = $9761593eb1d92c30$var$getControllerAndEnsureConnectedScope(_this, outletElement, name);
                if (outletController) return outletController;
                console.warn('The provided outlet element is missing an outlet controller "'.concat(name, '" instance for host controller "').concat(_this.identifier, '"'), outletElement);
            }).filter(function(controller) {
                return controller;
            });
            return [];
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(camelizedName, "OutletElement"), {
        get: function() {
            var outletElement = this.outlets.find(name);
            var selector = this.outlets.getSelectorForOutletName(name);
            if (outletElement) return outletElement;
            else throw new Error('Missing outlet element "'.concat(name, '" for host controller "').concat(this.identifier, '". Stimulus couldn\'t find a matching outlet element using selector "').concat(selector, '".'));
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(camelizedName, "OutletElements"), {
        get: function() {
            return this.outlets.findAll(name);
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "has".concat($9761593eb1d92c30$var$capitalize(camelizedName), "Outlet"), {
        get: function() {
            return this.outlets.has(name);
        }
    }), _obj;
}
function $9761593eb1d92c30$var$TargetPropertiesBlessing(constructor) {
    var targets = $9761593eb1d92c30$var$readInheritableStaticArrayValues(constructor, "targets");
    return targets.reduce(function(properties, targetDefinition) {
        return Object.assign(properties, $9761593eb1d92c30$var$propertiesForTargetDefinition(targetDefinition));
    }, {});
}
function $9761593eb1d92c30$var$propertiesForTargetDefinition(name) {
    var _obj;
    return _obj = {}, (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(name, "Target"), {
        get: function() {
            var target = this.targets.find(name);
            if (target) return target;
            else throw new Error('Missing target element "'.concat(name, '" for "').concat(this.identifier, '" controller'));
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "".concat(name, "Targets"), {
        get: function() {
            return this.targets.findAll(name);
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "has".concat($9761593eb1d92c30$var$capitalize(name), "Target"), {
        get: function() {
            return this.targets.has(name);
        }
    }), _obj;
}
function $9761593eb1d92c30$var$ValuePropertiesBlessing(constructor) {
    var valueDefinitionPairs = $9761593eb1d92c30$var$readInheritableStaticObjectPairs(constructor, "values");
    var propertyDescriptorMap = {
        valueDescriptorMap: {
            get: function() {
                var _this = this;
                return valueDefinitionPairs.reduce(function(result, valueDefinitionPair) {
                    var valueDescriptor = $9761593eb1d92c30$var$parseValueDefinitionPair(valueDefinitionPair, _this.identifier);
                    var attributeName = _this.data.getAttributeNameForKey(valueDescriptor.key);
                    return Object.assign(result, (0, $a6437d79afda84c4$export$71511d61b312f219)({}, attributeName, valueDescriptor));
                }, {});
            }
        }
    };
    return valueDefinitionPairs.reduce(function(properties, valueDefinitionPair) {
        return Object.assign(properties, $9761593eb1d92c30$var$propertiesForValueDefinitionPair(valueDefinitionPair));
    }, propertyDescriptorMap);
}
function $9761593eb1d92c30$var$propertiesForValueDefinitionPair(valueDefinitionPair, controller) {
    var definition = $9761593eb1d92c30$var$parseValueDefinitionPair(valueDefinitionPair, controller);
    var key = definition.key, name = definition.name, read = definition.reader, write = definition.writer;
    var _obj;
    return _obj = {}, (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, name, {
        get: function() {
            var value = this.data.get(key);
            if (value !== null) return read(value);
            else return definition.defaultValue;
        },
        set: function(value) {
            if (value === undefined) this.data["delete"](key);
            else this.data.set(key, write(value));
        }
    }), (0, $a6437d79afda84c4$export$71511d61b312f219)(_obj, "has".concat($9761593eb1d92c30$var$capitalize(name)), {
        get: function() {
            return this.data.has(key) || definition.hasCustomDefaultValue;
        }
    }), _obj;
}
function $9761593eb1d92c30$var$parseValueDefinitionPair(param, controller) {
    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), token = _param[0], typeDefinition = _param[1];
    return $9761593eb1d92c30$var$valueDescriptorForTokenAndTypeDefinition({
        controller: controller,
        token: token,
        typeDefinition: typeDefinition
    });
}
function $9761593eb1d92c30$var$parseValueTypeConstant(constant) {
    switch(constant){
        case Array:
            return "array";
        case Boolean:
            return "boolean";
        case Number:
            return "number";
        case Object:
            return "object";
        case String:
            return "string";
    }
}
function $9761593eb1d92c30$var$parseValueTypeDefault(defaultValue) {
    switch(typeof defaultValue === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(defaultValue)){
        case "boolean":
            return "boolean";
        case "number":
            return "number";
        case "string":
            return "string";
    }
    if (Array.isArray(defaultValue)) return "array";
    if (Object.prototype.toString.call(defaultValue) === "[object Object]") return "object";
}
function $9761593eb1d92c30$var$parseValueTypeObject(payload) {
    var controller = payload.controller, token = payload.token, typeObject = payload.typeObject;
    var hasType = $9761593eb1d92c30$var$isSomething(typeObject.type);
    var hasDefault = $9761593eb1d92c30$var$isSomething(typeObject["default"]);
    var fullObject = hasType && hasDefault;
    var onlyType = hasType && !hasDefault;
    var onlyDefault = !hasType && hasDefault;
    var typeFromObject = $9761593eb1d92c30$var$parseValueTypeConstant(typeObject.type);
    var typeFromDefaultValue = $9761593eb1d92c30$var$parseValueTypeDefault(payload.typeObject["default"]);
    if (onlyType) return typeFromObject;
    if (onlyDefault) return typeFromDefaultValue;
    if (typeFromObject !== typeFromDefaultValue) {
        var propertyPath = controller ? "".concat(controller, ".").concat(token) : token;
        throw new Error('The specified default value for the Stimulus Value "'.concat(propertyPath, '" must match the defined type "').concat(typeFromObject, '". The provided default value of "').concat(typeObject["default"], '" is of type "').concat(typeFromDefaultValue, '".'));
    }
    if (fullObject) return typeFromObject;
}
function $9761593eb1d92c30$var$parseValueTypeDefinition(payload) {
    var controller = payload.controller, token = payload.token, typeDefinition = payload.typeDefinition;
    var typeObject = {
        controller: controller,
        token: token,
        typeObject: typeDefinition
    };
    var typeFromObject = $9761593eb1d92c30$var$parseValueTypeObject(typeObject);
    var typeFromDefaultValue = $9761593eb1d92c30$var$parseValueTypeDefault(typeDefinition);
    var typeFromConstant = $9761593eb1d92c30$var$parseValueTypeConstant(typeDefinition);
    var type = typeFromObject || typeFromDefaultValue || typeFromConstant;
    if (type) return type;
    var propertyPath = controller ? "".concat(controller, ".").concat(typeDefinition) : token;
    throw new Error('Unknown value type "'.concat(propertyPath, '" for "').concat(token, '" value'));
}
function $9761593eb1d92c30$var$defaultValueForDefinition(typeDefinition) {
    var constant = $9761593eb1d92c30$var$parseValueTypeConstant(typeDefinition);
    if (constant) return $9761593eb1d92c30$var$defaultValuesByType[constant];
    var hasDefault = $9761593eb1d92c30$var$hasProperty(typeDefinition, "default");
    var hasType = $9761593eb1d92c30$var$hasProperty(typeDefinition, "type");
    var typeObject = typeDefinition;
    if (hasDefault) return typeObject["default"];
    if (hasType) {
        var type = typeObject.type;
        var constantFromType = $9761593eb1d92c30$var$parseValueTypeConstant(type);
        if (constantFromType) return $9761593eb1d92c30$var$defaultValuesByType[constantFromType];
    }
    return typeDefinition;
}
function $9761593eb1d92c30$var$valueDescriptorForTokenAndTypeDefinition(payload) {
    var token = payload.token, typeDefinition = payload.typeDefinition;
    var key = "".concat($9761593eb1d92c30$var$dasherize(token), "-value");
    var type = $9761593eb1d92c30$var$parseValueTypeDefinition(payload);
    return {
        type: type,
        key: key,
        name: $9761593eb1d92c30$var$camelize(key),
        get defaultValue () {
            return $9761593eb1d92c30$var$defaultValueForDefinition(typeDefinition);
        },
        get hasCustomDefaultValue () {
            return $9761593eb1d92c30$var$parseValueTypeDefault(typeDefinition) !== undefined;
        },
        reader: $9761593eb1d92c30$var$readers[type],
        writer: $9761593eb1d92c30$var$writers[type] || $9761593eb1d92c30$var$writers["default"]
    };
}
var $9761593eb1d92c30$var$defaultValuesByType = {
    get array () {
        return [];
    },
    boolean: false,
    number: 0,
    get object () {
        return {};
    },
    string: ""
};
var $9761593eb1d92c30$var$readers = {
    array: function(value) {
        var array = JSON.parse(value);
        if (!Array.isArray(array)) throw new TypeError('expected value of type "array" but instead got value "'.concat(value, '" of type "').concat($9761593eb1d92c30$var$parseValueTypeDefault(array), '"'));
        return array;
    },
    boolean: function(value) {
        return !(value == "0" || String(value).toLowerCase() == "false");
    },
    number: function(value) {
        return Number(value.replace(/_/g, ""));
    },
    object: function(value) {
        var object = JSON.parse(value);
        if (object === null || typeof object != "object" || Array.isArray(object)) throw new TypeError('expected value of type "object" but instead got value "'.concat(value, '" of type "').concat($9761593eb1d92c30$var$parseValueTypeDefault(object), '"'));
        return object;
    },
    string: function(value) {
        return value;
    }
};
var $9761593eb1d92c30$var$writers = {
    "default": $9761593eb1d92c30$var$writeString,
    array: $9761593eb1d92c30$var$writeJSON,
    object: $9761593eb1d92c30$var$writeJSON
};
function $9761593eb1d92c30$var$writeJSON(value) {
    return JSON.stringify(value);
}
function $9761593eb1d92c30$var$writeString(value) {
    return "".concat(value);
}
var $9761593eb1d92c30$export$bd0bf19f25da8474 = /*#__PURE__*/ function() {
    "use strict";
    function Controller(context) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Controller);
        this.context = context;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Controller, [
        {
            key: "application",
            get: function get() {
                return this.context.application;
            }
        },
        {
            key: "scope",
            get: function get() {
                return this.context.scope;
            }
        },
        {
            key: "element",
            get: function get() {
                return this.scope.element;
            }
        },
        {
            key: "identifier",
            get: function get() {
                return this.scope.identifier;
            }
        },
        {
            key: "targets",
            get: function get() {
                return this.scope.targets;
            }
        },
        {
            key: "outlets",
            get: function get() {
                return this.scope.outlets;
            }
        },
        {
            key: "classes",
            get: function get() {
                return this.scope.classes;
            }
        },
        {
            key: "data",
            get: function get() {
                return this.scope.data;
            }
        },
        {
            key: "initialize",
            value: function initialize() {}
        },
        {
            key: "connect",
            value: function connect() {}
        },
        {
            key: "disconnect",
            value: function disconnect() {}
        },
        {
            key: "dispatch",
            value: function dispatch(eventName) {
                var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_target = _ref.target, target = _ref_target === void 0 ? this.element : _ref_target, _ref_detail = _ref.detail, detail = _ref_detail === void 0 ? {} : _ref_detail, _ref_prefix = _ref.prefix, prefix = _ref_prefix === void 0 ? this.identifier : _ref_prefix, _ref_bubbles = _ref.bubbles, bubbles = _ref_bubbles === void 0 ? true : _ref_bubbles, _ref_cancelable = _ref.cancelable, cancelable = _ref_cancelable === void 0 ? true : _ref_cancelable;
                var type = prefix ? "".concat(prefix, ":").concat(eventName) : eventName;
                var event = new CustomEvent(type, {
                    detail: detail,
                    bubbles: bubbles,
                    cancelable: cancelable
                });
                target.dispatchEvent(event);
                return event;
            }
        }
    ], [
        {
            key: "shouldLoad",
            get: function get() {
                return true;
            }
        },
        {
            key: "afterLoad",
            value: function afterLoad(_identifier, _application) {
                return;
            }
        }
    ]);
    return Controller;
}();
$9761593eb1d92c30$export$bd0bf19f25da8474.blessings = [
    $9761593eb1d92c30$var$ClassPropertiesBlessing,
    $9761593eb1d92c30$var$TargetPropertiesBlessing,
    $9761593eb1d92c30$var$ValuePropertiesBlessing,
    $9761593eb1d92c30$var$OutletPropertiesBlessing
];
$9761593eb1d92c30$export$bd0bf19f25da8474.targets = [];
$9761593eb1d92c30$export$bd0bf19f25da8474.outlets = [];
$9761593eb1d92c30$export$bd0bf19f25da8474.values = {};










function $6c5afe00ef2f00bb$var$_defineProperty(e, r, t) {
    return (r = $6c5afe00ef2f00bb$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $6c5afe00ef2f00bb$var$_toPropertyKey(t) {
    var i = $6c5afe00ef2f00bb$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $6c5afe00ef2f00bb$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $6c5afe00ef2f00bb$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_class, Controller);
    var _super = (0, $1c23ba689bfccaac$export$71511d61b312f219)(_class);
    function _class() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _class);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args)));
        $6c5afe00ef2f00bb$var$_defineProperty((0, $9b101634070cfba3$export$71511d61b312f219)(_this), "items", []);
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_class, [
        {
            key: "connect",
            value: function connect() {
                var items = this.element.getElementsByClassName("accordion-item");
                for(var i = 0; i < items.length; i++)this.items.push(items[i]);
                console.log(items);
            }
        },
        {
            key: "closeAll",
            value: function closeAll(e) {
                this.items.forEach(function(item) {
                    item.classList.remove("active");
                });
            }
        },
        {
            key: "toggle",
            value: function toggle(e) {
                var el = e.currentTarget, i = el.dataset.key, item = this.items[i];
                if (!item) return;
                var content = item.getElementsByClassName("accordion-content");
                content = content.length ? content[0] : null;
                if (!content) return;
                var isOpen = item.classList.contains("active");
                if (isOpen) item.classList.remove("active");
                else {
                    item.classList.remove("active");
                    item.classList.add("active");
                }
            }
        }
    ]);
    return _class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));









var $2be48b05c8019145$export$d7eeb7266a7f734a = function(w) {
    var width = w.innerWidth && w.document.documentElement.clientWidth ? Math.min(w.innerWidth, w.document.documentElement.clientWidth) : w.innerWidth || w.document.documentElement.clientWidth || w.document.getElementsByTagName("body")[0].clientWidth;
    return {
        h: w.document.documentElement.clientHeight,
        w: width
    };
};
var $2be48b05c8019145$export$c4a223a8ba9e4ea5 = function(w) {
    return w.scrollY || w.document.documentElement.scrollTop;
};
var $2be48b05c8019145$export$61fc7d43ac8f84b0 = function(fn) {
    var timeout;
    return function debounce() {
        if (timeout) window.cancelAnimationFrame(timeout);
        timeout = window.requestAnimationFrame(fn);
    };
};
var $2be48b05c8019145$export$27a0fc5ea7ce230 = function(items, isActive, classes) {
    var active = classes.active.length ? classes.active.split(" ") : [];
    var inactive = classes.inactive.length ? classes.inactive.split(" ") : [];
    items.forEach(function(item, i) {
        var _item_classList, _item_classList1, _item_classList2, _item_classList3;
        if (active.length) (_item_classList = item.classList).remove.apply(_item_classList, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(active));
        if (inactive.length) (_item_classList1 = item.classList).remove.apply(_item_classList1, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(inactive));
        if (isActive(item, i)) {
            if (active.length) (_item_classList2 = item.classList).add.apply(_item_classList2, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(active));
        } else if (inactive.length) (_item_classList3 = item.classList).add.apply(_item_classList3, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(inactive));
    });
};
var $2be48b05c8019145$export$28ee1007e174a2a6 = function(callback) {
    if (document.readyState != "loading") callback();
    else if (document.addEventListener) document.addEventListener("DOMContentLoaded", callback);
    else document.attachEvent("onreadystatechange", function() {
        if (document.readyState == "complete") callback();
    });
};


function $ce37487ff92820e5$var$_defineProperty(e, r, t) {
    return (r = $ce37487ff92820e5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ce37487ff92820e5$var$_toPropertyKey(t) {
    var i = $ce37487ff92820e5$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $ce37487ff92820e5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ce37487ff92820e5$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    var _super = (0, $1c23ba689bfccaac$export$71511d61b312f219)(_Class);
    function _Class() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        return _super.apply(this, arguments);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                this.body = document.getElementsByTagName("body")[0];
                this.top = 0;
                this.element["burgerController"] = this;
                window.addEventListener("resize", (0, $2be48b05c8019145$export$61fc7d43ac8f84b0)(this.closeIfOpen.bind(this)));
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                window.removeEventListener("resize", (0, $2be48b05c8019145$export$61fc7d43ac8f84b0)(this.closeIfOpen.bind(this)));
            }
        },
        {
            key: "closeIfOpen",
            value: function closeIfOpen() {
                if (this.navTarget.classList.contains("active")) this.close();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.navOpenTarget.classList.remove("active");
                this.navCloseTarget.classList.remove("active");
            }
        },
        {
            key: "open",
            value: function open(e, modal) {
                if (modal) {
                    this.modalTarget.classList.remove("active");
                    this.modalTarget.classList.add("active");
                    this.menuTarget.classList.remove("active");
                    this.navTarget.classList.remove("menu");
                    this.navTarget.classList.remove("modal");
                    this.navTarget.classList.add("modal");
                } else {
                    this.modalTarget.classList.remove("active");
                    this.navTarget.classList.remove("modal");
                    this.navTarget.classList.remove("menu");
                    this.navTarget.classList.add("menu");
                    this.menuTarget.classList.remove("active");
                    this.menuTarget.classList.add("active");
                }
                this.reset();
                this.top = (0, $2be48b05c8019145$export$c4a223a8ba9e4ea5)(window);
                this.navTarget.classList.remove("active");
                this.navTarget.classList.add("active");
                this.navCloseTarget.classList.add("active");
                this.body.classList.remove("menuOpen");
                this.body.classList.add("menuOpen");
            }
        },
        {
            key: "openUrl",
            value: function openUrl(url) {
                var _this = this;
                fetch(url).then(function(r) {
                    return r.text();
                }).then(function(html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, "text/html");
                    var element = doc.getElementById("modalContent");
                    console.log(element);
                    _this.modalContentTarget.innerHTML = element.innerHTML;
                    _this.open(null, true);
                });
            }
        },
        {
            key: "openModal",
            value: function openModal(e) {
                var el = e.currentTarget;
                var url = el.getAttribute("href");
                if (!el) return;
                e.preventDefault();
                this.openUrl(url);
            }
        },
        {
            key: "close",
            value: function close() {
                this.reset();
                this.navTarget.classList.remove("fadeInLeft");
                this.navTarget.classList.add("fadeOutLeft");
                this.body.classList.remove("menuOpen");
                window.scroll(0, this.top);
                this.navTarget.classList.remove("active");
                this.navTarget.classList.remove("fadeOutLeft");
                this.navTarget.classList.add("fadeInLeft");
                this.navTarget.classList.remove("active");
                this.navOpenTarget.classList.add("active");
            }
        },
        {
            key: "top",
            value: function top() {
                var el = window;
                el.scrollTop = 0;
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$ce37487ff92820e5$var$_defineProperty($ce37487ff92820e5$export$2e2bcd8739ae039, "targets", [
    "navOpen",
    "navClose",
    "nav",
    "menu",
    "modal",
    "modalContent"
]);















"use strict";
function $547100571c4e1abe$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $b497ee7dadad447e$exports = {};
// shim for using process in browser
var $b497ee7dadad447e$var$process = $b497ee7dadad447e$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $b497ee7dadad447e$var$cachedSetTimeout;
var $b497ee7dadad447e$var$cachedClearTimeout;
function $b497ee7dadad447e$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $b497ee7dadad447e$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $b497ee7dadad447e$var$cachedSetTimeout = setTimeout;
        else $b497ee7dadad447e$var$cachedSetTimeout = $b497ee7dadad447e$var$defaultSetTimout;
    } catch (e) {
        $b497ee7dadad447e$var$cachedSetTimeout = $b497ee7dadad447e$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $b497ee7dadad447e$var$cachedClearTimeout = clearTimeout;
        else $b497ee7dadad447e$var$cachedClearTimeout = $b497ee7dadad447e$var$defaultClearTimeout;
    } catch (e) {
        $b497ee7dadad447e$var$cachedClearTimeout = $b497ee7dadad447e$var$defaultClearTimeout;
    }
})();
function $b497ee7dadad447e$var$runTimeout(fun) {
    if ($b497ee7dadad447e$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($b497ee7dadad447e$var$cachedSetTimeout === $b497ee7dadad447e$var$defaultSetTimout || !$b497ee7dadad447e$var$cachedSetTimeout) && setTimeout) {
        $b497ee7dadad447e$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b497ee7dadad447e$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $b497ee7dadad447e$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $b497ee7dadad447e$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $b497ee7dadad447e$var$runClearTimeout(marker) {
    if ($b497ee7dadad447e$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($b497ee7dadad447e$var$cachedClearTimeout === $b497ee7dadad447e$var$defaultClearTimeout || !$b497ee7dadad447e$var$cachedClearTimeout) && clearTimeout) {
        $b497ee7dadad447e$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b497ee7dadad447e$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $b497ee7dadad447e$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $b497ee7dadad447e$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $b497ee7dadad447e$var$queue = [];
var $b497ee7dadad447e$var$draining = false;
var $b497ee7dadad447e$var$currentQueue;
var $b497ee7dadad447e$var$queueIndex = -1;
function $b497ee7dadad447e$var$cleanUpNextTick() {
    if (!$b497ee7dadad447e$var$draining || !$b497ee7dadad447e$var$currentQueue) return;
    $b497ee7dadad447e$var$draining = false;
    if ($b497ee7dadad447e$var$currentQueue.length) $b497ee7dadad447e$var$queue = $b497ee7dadad447e$var$currentQueue.concat($b497ee7dadad447e$var$queue);
    else $b497ee7dadad447e$var$queueIndex = -1;
    if ($b497ee7dadad447e$var$queue.length) $b497ee7dadad447e$var$drainQueue();
}
function $b497ee7dadad447e$var$drainQueue() {
    if ($b497ee7dadad447e$var$draining) return;
    var timeout = $b497ee7dadad447e$var$runTimeout($b497ee7dadad447e$var$cleanUpNextTick);
    $b497ee7dadad447e$var$draining = true;
    var len = $b497ee7dadad447e$var$queue.length;
    while(len){
        $b497ee7dadad447e$var$currentQueue = $b497ee7dadad447e$var$queue;
        $b497ee7dadad447e$var$queue = [];
        while(++$b497ee7dadad447e$var$queueIndex < len)if ($b497ee7dadad447e$var$currentQueue) $b497ee7dadad447e$var$currentQueue[$b497ee7dadad447e$var$queueIndex].run();
        $b497ee7dadad447e$var$queueIndex = -1;
        len = $b497ee7dadad447e$var$queue.length;
    }
    $b497ee7dadad447e$var$currentQueue = null;
    $b497ee7dadad447e$var$draining = false;
    $b497ee7dadad447e$var$runClearTimeout(timeout);
}
$b497ee7dadad447e$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $b497ee7dadad447e$var$queue.push(new $b497ee7dadad447e$var$Item(fun, args));
    if ($b497ee7dadad447e$var$queue.length === 1 && !$b497ee7dadad447e$var$draining) $b497ee7dadad447e$var$runTimeout($b497ee7dadad447e$var$drainQueue);
};
// v8 likes predictible objects
function $b497ee7dadad447e$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$b497ee7dadad447e$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$b497ee7dadad447e$var$process.title = "browser";
$b497ee7dadad447e$var$process.browser = true;
$b497ee7dadad447e$var$process.env = {};
$b497ee7dadad447e$var$process.argv = [];
$b497ee7dadad447e$var$process.version = ""; // empty string to avoid regexp issues
$b497ee7dadad447e$var$process.versions = {};
function $b497ee7dadad447e$var$noop() {}
$b497ee7dadad447e$var$process.on = $b497ee7dadad447e$var$noop;
$b497ee7dadad447e$var$process.addListener = $b497ee7dadad447e$var$noop;
$b497ee7dadad447e$var$process.once = $b497ee7dadad447e$var$noop;
$b497ee7dadad447e$var$process.off = $b497ee7dadad447e$var$noop;
$b497ee7dadad447e$var$process.removeListener = $b497ee7dadad447e$var$noop;
$b497ee7dadad447e$var$process.removeAllListeners = $b497ee7dadad447e$var$noop;
$b497ee7dadad447e$var$process.emit = $b497ee7dadad447e$var$noop;
$b497ee7dadad447e$var$process.prependListener = $b497ee7dadad447e$var$noop;
$b497ee7dadad447e$var$process.prependOnceListener = $b497ee7dadad447e$var$noop;
$b497ee7dadad447e$var$process.listeners = function(name) {
    return [];
};
$b497ee7dadad447e$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$b497ee7dadad447e$var$process.cwd = function() {
    return "/";
};
$b497ee7dadad447e$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$b497ee7dadad447e$var$process.umask = function() {
    return 0;
};


"use strict";
// utils is a library of generic helper functions non-specific to axios
var $c6fd95db66a95a37$var$toString = Object.prototype.toString;
var $c6fd95db66a95a37$var$getPrototypeOf = Object.getPrototypeOf;
var $c6fd95db66a95a37$var$kindOf = function(cache) {
    return function(thing) {
        var str = $c6fd95db66a95a37$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
var $c6fd95db66a95a37$var$kindOfTest = function(type) {
    type = type.toLowerCase();
    return function(thing) {
        return $c6fd95db66a95a37$var$kindOf(thing) === type;
    };
};
var $c6fd95db66a95a37$var$typeOfTest = function(type) {
    return function(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(thing)) === type;
    };
};
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ var $c6fd95db66a95a37$var$isArray = Array.isArray;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ var $c6fd95db66a95a37$var$isUndefined = $c6fd95db66a95a37$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c6fd95db66a95a37$var$isBuffer(val) {
    return val !== null && !$c6fd95db66a95a37$var$isUndefined(val) && val.constructor !== null && !$c6fd95db66a95a37$var$isUndefined(val.constructor) && $c6fd95db66a95a37$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $c6fd95db66a95a37$var$isArrayBuffer = $c6fd95db66a95a37$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c6fd95db66a95a37$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c6fd95db66a95a37$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ var $c6fd95db66a95a37$var$isString = $c6fd95db66a95a37$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ var $c6fd95db66a95a37$var$isFunction = $c6fd95db66a95a37$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ var $c6fd95db66a95a37$var$isNumber = $c6fd95db66a95a37$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ var $c6fd95db66a95a37$var$isObject = function(thing) {
    return thing !== null && typeof thing === "object";
};
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ var $c6fd95db66a95a37$var$isBoolean = function(thing) {
    return thing === true || thing === false;
};
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ var $c6fd95db66a95a37$var$isPlainObject = function(val) {
    if ($c6fd95db66a95a37$var$kindOf(val) !== "object") return false;
    var prototype = $c6fd95db66a95a37$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $c6fd95db66a95a37$var$isDate = $c6fd95db66a95a37$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $c6fd95db66a95a37$var$isFile = $c6fd95db66a95a37$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $c6fd95db66a95a37$var$isBlob = $c6fd95db66a95a37$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ var $c6fd95db66a95a37$var$isFileList = $c6fd95db66a95a37$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ var $c6fd95db66a95a37$var$isStream = function(val) {
    return $c6fd95db66a95a37$var$isObject(val) && $c6fd95db66a95a37$var$isFunction(val.pipe);
};
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ var $c6fd95db66a95a37$var$isFormData = function(thing) {
    var kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c6fd95db66a95a37$var$isFunction(thing.append) && ((kind = $c6fd95db66a95a37$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c6fd95db66a95a37$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $c6fd95db66a95a37$var$isURLSearchParams = $c6fd95db66a95a37$var$kindOfTest("URLSearchParams");
var $c6fd95db66a95a37$var$_map = (0, $1733e6e3a24db77c$export$71511d61b312f219)([
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($c6fd95db66a95a37$var$kindOfTest), 4), $c6fd95db66a95a37$var$isReadableStream = $c6fd95db66a95a37$var$_map[0], $c6fd95db66a95a37$var$isRequest = $c6fd95db66a95a37$var$_map[1], $c6fd95db66a95a37$var$isResponse = $c6fd95db66a95a37$var$_map[2], $c6fd95db66a95a37$var$isHeaders = $c6fd95db66a95a37$var$_map[3];
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ var $c6fd95db66a95a37$var$trim = function(str) {
    return str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
};
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c6fd95db66a95a37$var$forEach(obj, fn) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_allOwnKeys = _ref.allOwnKeys, allOwnKeys = _ref_allOwnKeys === void 0 ? false : _ref_allOwnKeys;
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    var i;
    var l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c6fd95db66a95a37$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        var keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        var len = keys.length;
        var key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c6fd95db66a95a37$var$findKey(obj, key) {
    key = key.toLowerCase();
    var keys = Object.keys(obj);
    var i = keys.length;
    var _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
var $c6fd95db66a95a37$var$_global = function() {
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
}();
var $c6fd95db66a95a37$var$isContextDefined = function(context) {
    return !$c6fd95db66a95a37$var$isUndefined(context) && context !== $c6fd95db66a95a37$var$_global;
};
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c6fd95db66a95a37$var$merge() {
    var caseless = ($c6fd95db66a95a37$var$isContextDefined(this) && this || {}).caseless;
    var result = {};
    var assignValue = function(val, key) {
        var targetKey = caseless && $c6fd95db66a95a37$var$findKey(result, key) || key;
        if ($c6fd95db66a95a37$var$isPlainObject(result[targetKey]) && $c6fd95db66a95a37$var$isPlainObject(val)) result[targetKey] = $c6fd95db66a95a37$var$merge(result[targetKey], val);
        else if ($c6fd95db66a95a37$var$isPlainObject(val)) result[targetKey] = $c6fd95db66a95a37$var$merge({}, val);
        else if ($c6fd95db66a95a37$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(var i = 0, l = arguments.length; i < l; i++)arguments[i] && $c6fd95db66a95a37$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ var $c6fd95db66a95a37$var$extend = function(a, b, thisArg) {
    var allOwnKeys = (arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}).allOwnKeys;
    $c6fd95db66a95a37$var$forEach(b, function(val, key) {
        if (thisArg && $c6fd95db66a95a37$var$isFunction(val)) a[key] = (0, $547100571c4e1abe$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ var $c6fd95db66a95a37$var$stripBOM = function(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ var $c6fd95db66a95a37$var$inherits = function(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ var $c6fd95db66a95a37$var$toFlatObject = function(sourceObj, destObj, filter, propFilter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c6fd95db66a95a37$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ var $c6fd95db66a95a37$var$endsWith = function(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ var $c6fd95db66a95a37$var$toArray = function(thing) {
    if (!thing) return null;
    if ($c6fd95db66a95a37$var$isArray(thing)) return thing;
    var i = thing.length;
    if (!$c6fd95db66a95a37$var$isNumber(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
var $c6fd95db66a95a37$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== "undefined" && $c6fd95db66a95a37$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ var $c6fd95db66a95a37$var$forEachEntry = function(obj, fn) {
    var generator = obj && obj[Symbol.iterator];
    var iterator = generator.call(obj);
    var result;
    while((result = iterator.next()) && !result.done){
        var pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ var $c6fd95db66a95a37$var$matchAll = function(regExp, str) {
    var matches;
    var arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ var $c6fd95db66a95a37$var$isHTMLForm = $c6fd95db66a95a37$var$kindOfTest("HTMLFormElement");
var $c6fd95db66a95a37$var$toCamelCase = function(str) {
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ var $c6fd95db66a95a37$var$hasOwnProperty = function(param) {
    var hasOwnProperty = param.hasOwnProperty;
    return function(obj, prop) {
        return hasOwnProperty.call(obj, prop);
    };
}(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ var $c6fd95db66a95a37$var$isRegExp = $c6fd95db66a95a37$var$kindOfTest("RegExp");
var $c6fd95db66a95a37$var$reduceDescriptors = function(obj, reducer) {
    var descriptors = Object.getOwnPropertyDescriptors(obj);
    var reducedDescriptors = {};
    $c6fd95db66a95a37$var$forEach(descriptors, function(descriptor, name) {
        var ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ var $c6fd95db66a95a37$var$freezeMethods = function(obj) {
    $c6fd95db66a95a37$var$reduceDescriptors(obj, function(descriptor, name) {
        // skip restricted props in strict mode
        if ($c6fd95db66a95a37$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        var value = obj[name];
        if (!$c6fd95db66a95a37$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = function() {
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
var $c6fd95db66a95a37$var$toObjectSet = function(arrayOrString, delimiter) {
    var obj = {};
    var define = function(arr) {
        arr.forEach(function(value) {
            obj[value] = true;
        });
    };
    $c6fd95db66a95a37$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
var $c6fd95db66a95a37$var$noop = function() {};
var $c6fd95db66a95a37$var$toFiniteNumber = function(value, defaultValue) {
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
var $c6fd95db66a95a37$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
var $c6fd95db66a95a37$var$DIGIT = "0123456789";
var $c6fd95db66a95a37$var$ALPHABET = {
    DIGIT: $c6fd95db66a95a37$var$DIGIT,
    ALPHA: $c6fd95db66a95a37$var$ALPHA,
    ALPHA_DIGIT: $c6fd95db66a95a37$var$ALPHA + $c6fd95db66a95a37$var$ALPHA.toUpperCase() + $c6fd95db66a95a37$var$DIGIT
};
var $c6fd95db66a95a37$var$generateString = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16, alphabet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c6fd95db66a95a37$var$ALPHABET.ALPHA_DIGIT;
    var str = "";
    var length = alphabet.length;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c6fd95db66a95a37$var$isSpecCompliantForm(thing) {
    return !!(thing && $c6fd95db66a95a37$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
var $c6fd95db66a95a37$var$toJSONObject = function(obj) {
    var stack = new Array(10);
    var visit = function(source, i) {
        if ($c6fd95db66a95a37$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                var target = $c6fd95db66a95a37$var$isArray(source) ? [] : {};
                $c6fd95db66a95a37$var$forEach(source, function(value, key) {
                    var reducedValue = visit(value, i + 1);
                    !$c6fd95db66a95a37$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
var $c6fd95db66a95a37$var$isAsyncFn = $c6fd95db66a95a37$var$kindOfTest("AsyncFunction");
var $c6fd95db66a95a37$var$isThenable = function(thing) {
    return thing && ($c6fd95db66a95a37$var$isObject(thing) || $c6fd95db66a95a37$var$isFunction(thing)) && $c6fd95db66a95a37$var$isFunction(thing.then) && $c6fd95db66a95a37$var$isFunction(thing["catch"]);
};
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
var $c6fd95db66a95a37$var$_setImmediate = function(setImmediateSupported, postMessageSupported) {
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? function(token, callbacks) {
        $c6fd95db66a95a37$var$_global.addEventListener("message", function(param) {
            var source = param.source, data = param.data;
            if (source === $c6fd95db66a95a37$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return function(cb) {
            callbacks.push(cb);
            $c6fd95db66a95a37$var$_global.postMessage(token, "*");
        };
    }("axios@".concat(Math.random()), []) : function(cb) {
        return setTimeout(cb);
    };
}(typeof setImmediate === "function", $c6fd95db66a95a37$var$isFunction($c6fd95db66a95a37$var$_global.postMessage));
var $c6fd95db66a95a37$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($c6fd95db66a95a37$var$_global) : typeof $b497ee7dadad447e$exports !== "undefined" && $b497ee7dadad447e$exports.nextTick || $c6fd95db66a95a37$var$_setImmediate;
var // *********************
$c6fd95db66a95a37$export$2e2bcd8739ae039 = {
    isArray: $c6fd95db66a95a37$var$isArray,
    isArrayBuffer: $c6fd95db66a95a37$var$isArrayBuffer,
    isBuffer: $c6fd95db66a95a37$var$isBuffer,
    isFormData: $c6fd95db66a95a37$var$isFormData,
    isArrayBufferView: $c6fd95db66a95a37$var$isArrayBufferView,
    isString: $c6fd95db66a95a37$var$isString,
    isNumber: $c6fd95db66a95a37$var$isNumber,
    isBoolean: $c6fd95db66a95a37$var$isBoolean,
    isObject: $c6fd95db66a95a37$var$isObject,
    isPlainObject: $c6fd95db66a95a37$var$isPlainObject,
    isReadableStream: $c6fd95db66a95a37$var$isReadableStream,
    isRequest: $c6fd95db66a95a37$var$isRequest,
    isResponse: $c6fd95db66a95a37$var$isResponse,
    isHeaders: $c6fd95db66a95a37$var$isHeaders,
    isUndefined: $c6fd95db66a95a37$var$isUndefined,
    isDate: $c6fd95db66a95a37$var$isDate,
    isFile: $c6fd95db66a95a37$var$isFile,
    isBlob: $c6fd95db66a95a37$var$isBlob,
    isRegExp: $c6fd95db66a95a37$var$isRegExp,
    isFunction: $c6fd95db66a95a37$var$isFunction,
    isStream: $c6fd95db66a95a37$var$isStream,
    isURLSearchParams: $c6fd95db66a95a37$var$isURLSearchParams,
    isTypedArray: $c6fd95db66a95a37$var$isTypedArray,
    isFileList: $c6fd95db66a95a37$var$isFileList,
    forEach: $c6fd95db66a95a37$var$forEach,
    merge: $c6fd95db66a95a37$var$merge,
    extend: $c6fd95db66a95a37$var$extend,
    trim: $c6fd95db66a95a37$var$trim,
    stripBOM: $c6fd95db66a95a37$var$stripBOM,
    inherits: $c6fd95db66a95a37$var$inherits,
    toFlatObject: $c6fd95db66a95a37$var$toFlatObject,
    kindOf: $c6fd95db66a95a37$var$kindOf,
    kindOfTest: $c6fd95db66a95a37$var$kindOfTest,
    endsWith: $c6fd95db66a95a37$var$endsWith,
    toArray: $c6fd95db66a95a37$var$toArray,
    forEachEntry: $c6fd95db66a95a37$var$forEachEntry,
    matchAll: $c6fd95db66a95a37$var$matchAll,
    isHTMLForm: $c6fd95db66a95a37$var$isHTMLForm,
    hasOwnProperty: $c6fd95db66a95a37$var$hasOwnProperty,
    hasOwnProp: $c6fd95db66a95a37$var$hasOwnProperty,
    reduceDescriptors: $c6fd95db66a95a37$var$reduceDescriptors,
    freezeMethods: $c6fd95db66a95a37$var$freezeMethods,
    toObjectSet: $c6fd95db66a95a37$var$toObjectSet,
    toCamelCase: $c6fd95db66a95a37$var$toCamelCase,
    noop: $c6fd95db66a95a37$var$noop,
    toFiniteNumber: $c6fd95db66a95a37$var$toFiniteNumber,
    findKey: $c6fd95db66a95a37$var$findKey,
    global: $c6fd95db66a95a37$var$_global,
    isContextDefined: $c6fd95db66a95a37$var$isContextDefined,
    ALPHABET: $c6fd95db66a95a37$var$ALPHABET,
    generateString: $c6fd95db66a95a37$var$generateString,
    isSpecCompliantForm: $c6fd95db66a95a37$var$isSpecCompliantForm,
    toJSONObject: $c6fd95db66a95a37$var$toJSONObject,
    isAsyncFn: $c6fd95db66a95a37$var$isAsyncFn,
    isThenable: $c6fd95db66a95a37$var$isThenable,
    setImmediate: $c6fd95db66a95a37$var$_setImmediate,
    asap: $c6fd95db66a95a37$var$asap
};











"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $82194958dcf3d811$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).inherits($82194958dcf3d811$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
var $82194958dcf3d811$var$prototype = $82194958dcf3d811$var$AxiosError.prototype;
var $82194958dcf3d811$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach(function(code) {
    $82194958dcf3d811$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($82194958dcf3d811$var$AxiosError, $82194958dcf3d811$var$descriptors);
Object.defineProperty($82194958dcf3d811$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$82194958dcf3d811$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($82194958dcf3d811$var$prototype);
    (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, function(prop) {
        return prop !== "isAxiosError";
    });
    $82194958dcf3d811$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $82194958dcf3d811$export$2e2bcd8739ae039 = $82194958dcf3d811$var$AxiosError;


// eslint-disable-next-line strict
var $983413b2a0eaae0e$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 





var $438a2a62f0a90b29$export$a143d493d941bafc;
var $438a2a62f0a90b29$export$e4cf37d7f6fb9e0a;
var $438a2a62f0a90b29$export$f99ded8fe4b79145;
var $438a2a62f0a90b29$export$599f31c3813fae4d;
"use strict";
var $623efc618916115a$export$a48f0734ac7c2329;
var $623efc618916115a$export$d622b2ad8d90c771;
var $623efc618916115a$export$6100ba28696e12de;
"use strict";
$623efc618916115a$export$a48f0734ac7c2329 = $623efc618916115a$var$byteLength;
$623efc618916115a$export$d622b2ad8d90c771 = $623efc618916115a$var$toByteArray;
$623efc618916115a$export$6100ba28696e12de = $623efc618916115a$var$fromByteArray;
var $623efc618916115a$var$lookup = [];
var $623efc618916115a$var$revLookup = [];
var $623efc618916115a$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $623efc618916115a$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $623efc618916115a$var$i = 0, $623efc618916115a$var$len = $623efc618916115a$var$code.length; $623efc618916115a$var$i < $623efc618916115a$var$len; ++$623efc618916115a$var$i){
    $623efc618916115a$var$lookup[$623efc618916115a$var$i] = $623efc618916115a$var$code[$623efc618916115a$var$i];
    $623efc618916115a$var$revLookup[$623efc618916115a$var$code.charCodeAt($623efc618916115a$var$i)] = $623efc618916115a$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$623efc618916115a$var$revLookup["-".charCodeAt(0)] = 62;
$623efc618916115a$var$revLookup["_".charCodeAt(0)] = 63;
function $623efc618916115a$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $623efc618916115a$var$byteLength(b64) {
    var lens = $623efc618916115a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $623efc618916115a$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $623efc618916115a$var$toByteArray(b64) {
    var tmp;
    var lens = $623efc618916115a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $623efc618916115a$var$Arr($623efc618916115a$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $623efc618916115a$var$revLookup[b64.charCodeAt(i)] << 18 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $623efc618916115a$var$revLookup[b64.charCodeAt(i)] << 2 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $623efc618916115a$var$revLookup[b64.charCodeAt(i)] << 10 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $623efc618916115a$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $623efc618916115a$var$tripletToBase64(num) {
    return $623efc618916115a$var$lookup[num >> 18 & 0x3F] + $623efc618916115a$var$lookup[num >> 12 & 0x3F] + $623efc618916115a$var$lookup[num >> 6 & 0x3F] + $623efc618916115a$var$lookup[num & 0x3F];
}
function $623efc618916115a$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($623efc618916115a$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $623efc618916115a$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($623efc618916115a$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($623efc618916115a$var$lookup[tmp >> 2] + $623efc618916115a$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($623efc618916115a$var$lookup[tmp >> 10] + $623efc618916115a$var$lookup[tmp >> 4 & 0x3F] + $623efc618916115a$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a38d2305e673c028$export$aafa59e2e03f2942;
var $a38d2305e673c028$export$68d8715fc104d294;
$a38d2305e673c028$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a38d2305e673c028$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $438a2a62f0a90b29$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$438a2a62f0a90b29$export$a143d493d941bafc = $438a2a62f0a90b29$var$Buffer;
$438a2a62f0a90b29$export$e4cf37d7f6fb9e0a = $438a2a62f0a90b29$var$SlowBuffer;
$438a2a62f0a90b29$export$f99ded8fe4b79145 = 50;
var $438a2a62f0a90b29$var$K_MAX_LENGTH = 0x7fffffff;
$438a2a62f0a90b29$export$599f31c3813fae4d = $438a2a62f0a90b29$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $438a2a62f0a90b29$var$Buffer.TYPED_ARRAY_SUPPORT = $438a2a62f0a90b29$var$typedArraySupport();
if (!$438a2a62f0a90b29$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $438a2a62f0a90b29$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function foo() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($438a2a62f0a90b29$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function get() {
        if (!$438a2a62f0a90b29$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($438a2a62f0a90b29$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function get() {
        if (!$438a2a62f0a90b29$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $438a2a62f0a90b29$var$createBuffer(length) {
    if (length > $438a2a62f0a90b29$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $438a2a62f0a90b29$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $438a2a62f0a90b29$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $438a2a62f0a90b29$var$allocUnsafe(arg);
    }
    return $438a2a62f0a90b29$var$from(arg, encodingOrOffset, length);
}
$438a2a62f0a90b29$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $438a2a62f0a90b29$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $438a2a62f0a90b29$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $438a2a62f0a90b29$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(value)));
    if ($438a2a62f0a90b29$var$isInstance(value, ArrayBuffer) || value && $438a2a62f0a90b29$var$isInstance(value.buffer, ArrayBuffer)) return $438a2a62f0a90b29$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($438a2a62f0a90b29$var$isInstance(value, SharedArrayBuffer) || value && $438a2a62f0a90b29$var$isInstance(value.buffer, SharedArrayBuffer))) return $438a2a62f0a90b29$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $438a2a62f0a90b29$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $438a2a62f0a90b29$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $438a2a62f0a90b29$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + (typeof value === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(value)));
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $438a2a62f0a90b29$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $438a2a62f0a90b29$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($438a2a62f0a90b29$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($438a2a62f0a90b29$var$Buffer, Uint8Array);
function $438a2a62f0a90b29$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $438a2a62f0a90b29$var$alloc(size, fill, encoding) {
    $438a2a62f0a90b29$var$assertSize(size);
    if (size <= 0) return $438a2a62f0a90b29$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $438a2a62f0a90b29$var$createBuffer(size).fill(fill, encoding) : $438a2a62f0a90b29$var$createBuffer(size).fill(fill);
    return $438a2a62f0a90b29$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $438a2a62f0a90b29$var$Buffer.alloc = function(size, fill, encoding) {
    return $438a2a62f0a90b29$var$alloc(size, fill, encoding);
};
function $438a2a62f0a90b29$var$allocUnsafe(size) {
    $438a2a62f0a90b29$var$assertSize(size);
    return $438a2a62f0a90b29$var$createBuffer(size < 0 ? 0 : $438a2a62f0a90b29$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $438a2a62f0a90b29$var$Buffer.allocUnsafe = function(size) {
    return $438a2a62f0a90b29$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $438a2a62f0a90b29$var$Buffer.allocUnsafeSlow = function(size) {
    return $438a2a62f0a90b29$var$allocUnsafe(size);
};
function $438a2a62f0a90b29$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$438a2a62f0a90b29$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $438a2a62f0a90b29$var$byteLength(string, encoding) | 0;
    var buf = $438a2a62f0a90b29$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $438a2a62f0a90b29$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $438a2a62f0a90b29$var$checked(array.length) | 0;
    var buf = $438a2a62f0a90b29$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $438a2a62f0a90b29$var$fromArrayView(arrayView) {
    if ($438a2a62f0a90b29$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $438a2a62f0a90b29$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $438a2a62f0a90b29$var$fromArrayLike(arrayView);
}
function $438a2a62f0a90b29$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $438a2a62f0a90b29$var$Buffer.prototype);
    return buf;
}
function $438a2a62f0a90b29$var$fromObject(obj) {
    if ($438a2a62f0a90b29$var$Buffer.isBuffer(obj)) {
        var len = $438a2a62f0a90b29$var$checked(obj.length) | 0;
        var buf = $438a2a62f0a90b29$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $438a2a62f0a90b29$var$numberIsNaN(obj.length)) return $438a2a62f0a90b29$var$createBuffer(0);
        return $438a2a62f0a90b29$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $438a2a62f0a90b29$var$fromArrayLike(obj.data);
}
function $438a2a62f0a90b29$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $438a2a62f0a90b29$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $438a2a62f0a90b29$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $438a2a62f0a90b29$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $438a2a62f0a90b29$var$Buffer.alloc(+length);
}
$438a2a62f0a90b29$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $438a2a62f0a90b29$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$438a2a62f0a90b29$var$Buffer.compare = function compare(a, b) {
    if ($438a2a62f0a90b29$var$isInstance(a, Uint8Array)) a = $438a2a62f0a90b29$var$Buffer.from(a, a.offset, a.byteLength);
    if ($438a2a62f0a90b29$var$isInstance(b, Uint8Array)) b = $438a2a62f0a90b29$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$438a2a62f0a90b29$var$Buffer.isBuffer(a) || !$438a2a62f0a90b29$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$438a2a62f0a90b29$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$438a2a62f0a90b29$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $438a2a62f0a90b29$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $438a2a62f0a90b29$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($438a2a62f0a90b29$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$438a2a62f0a90b29$var$Buffer.isBuffer(buf)) buf = $438a2a62f0a90b29$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$438a2a62f0a90b29$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $438a2a62f0a90b29$var$byteLength(string, encoding) {
    if ($438a2a62f0a90b29$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $438a2a62f0a90b29$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + (typeof string === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(string)));
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $438a2a62f0a90b29$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $438a2a62f0a90b29$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $438a2a62f0a90b29$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$438a2a62f0a90b29$var$Buffer.byteLength = $438a2a62f0a90b29$var$byteLength;
function $438a2a62f0a90b29$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $438a2a62f0a90b29$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $438a2a62f0a90b29$var$utf8Slice(this, start, end);
        case "ascii":
            return $438a2a62f0a90b29$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $438a2a62f0a90b29$var$latin1Slice(this, start, end);
        case "base64":
            return $438a2a62f0a90b29$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $438a2a62f0a90b29$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$438a2a62f0a90b29$var$Buffer.prototype._isBuffer = true;
function $438a2a62f0a90b29$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$438a2a62f0a90b29$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$438a2a62f0a90b29$var$swap(this, i, i + 1);
    return this;
};
$438a2a62f0a90b29$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $438a2a62f0a90b29$var$swap(this, i, i + 3);
        $438a2a62f0a90b29$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$438a2a62f0a90b29$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $438a2a62f0a90b29$var$swap(this, i, i + 7);
        $438a2a62f0a90b29$var$swap(this, i + 1, i + 6);
        $438a2a62f0a90b29$var$swap(this, i + 2, i + 5);
        $438a2a62f0a90b29$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$438a2a62f0a90b29$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $438a2a62f0a90b29$var$utf8Slice(this, 0, length);
    return $438a2a62f0a90b29$var$slowToString.apply(this, arguments);
};
$438a2a62f0a90b29$var$Buffer.prototype.toLocaleString = $438a2a62f0a90b29$var$Buffer.prototype.toString;
$438a2a62f0a90b29$var$Buffer.prototype.equals = function equals(b) {
    if (!$438a2a62f0a90b29$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $438a2a62f0a90b29$var$Buffer.compare(this, b) === 0;
};
$438a2a62f0a90b29$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $438a2a62f0a90b29$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($438a2a62f0a90b29$var$customInspectSymbol) $438a2a62f0a90b29$var$Buffer.prototype[$438a2a62f0a90b29$var$customInspectSymbol] = $438a2a62f0a90b29$var$Buffer.prototype.inspect;
$438a2a62f0a90b29$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($438a2a62f0a90b29$var$isInstance(target, Uint8Array)) target = $438a2a62f0a90b29$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$438a2a62f0a90b29$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + (typeof target === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(target)));
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $438a2a62f0a90b29$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($438a2a62f0a90b29$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $438a2a62f0a90b29$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($438a2a62f0a90b29$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $438a2a62f0a90b29$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $438a2a62f0a90b29$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $438a2a62f0a90b29$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$438a2a62f0a90b29$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$438a2a62f0a90b29$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $438a2a62f0a90b29$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$438a2a62f0a90b29$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $438a2a62f0a90b29$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $438a2a62f0a90b29$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    var i;
    for(i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($438a2a62f0a90b29$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $438a2a62f0a90b29$var$utf8Write(buf, string, offset, length) {
    return $438a2a62f0a90b29$var$blitBuffer($438a2a62f0a90b29$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $438a2a62f0a90b29$var$asciiWrite(buf, string, offset, length) {
    return $438a2a62f0a90b29$var$blitBuffer($438a2a62f0a90b29$var$asciiToBytes(string), buf, offset, length);
}
function $438a2a62f0a90b29$var$base64Write(buf, string, offset, length) {
    return $438a2a62f0a90b29$var$blitBuffer($438a2a62f0a90b29$var$base64ToBytes(string), buf, offset, length);
}
function $438a2a62f0a90b29$var$ucs2Write(buf, string, offset, length) {
    return $438a2a62f0a90b29$var$blitBuffer($438a2a62f0a90b29$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$438a2a62f0a90b29$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $438a2a62f0a90b29$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $438a2a62f0a90b29$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $438a2a62f0a90b29$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $438a2a62f0a90b29$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $438a2a62f0a90b29$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$438a2a62f0a90b29$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $438a2a62f0a90b29$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $623efc618916115a$export$6100ba28696e12de(buf);
    else return $623efc618916115a$export$6100ba28696e12de(buf.slice(start, end));
}
function $438a2a62f0a90b29$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $438a2a62f0a90b29$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $438a2a62f0a90b29$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $438a2a62f0a90b29$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $438a2a62f0a90b29$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $438a2a62f0a90b29$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $438a2a62f0a90b29$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $438a2a62f0a90b29$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $438a2a62f0a90b29$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $438a2a62f0a90b29$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $438a2a62f0a90b29$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$438a2a62f0a90b29$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $438a2a62f0a90b29$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $438a2a62f0a90b29$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$438a2a62f0a90b29$var$Buffer.prototype.readUintLE = $438a2a62f0a90b29$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readUintBE = $438a2a62f0a90b29$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readUint8 = $438a2a62f0a90b29$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$438a2a62f0a90b29$var$Buffer.prototype.readUint16LE = $438a2a62f0a90b29$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$438a2a62f0a90b29$var$Buffer.prototype.readUint16BE = $438a2a62f0a90b29$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$438a2a62f0a90b29$var$Buffer.prototype.readUint32LE = $438a2a62f0a90b29$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$438a2a62f0a90b29$var$Buffer.prototype.readUint32BE = $438a2a62f0a90b29$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$438a2a62f0a90b29$var$Buffer.prototype.readBigUInt64LE = $438a2a62f0a90b29$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $438a2a62f0a90b29$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $438a2a62f0a90b29$var$boundsError(offset, this.length - 8);
    var lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$438a2a62f0a90b29$var$Buffer.prototype.readBigUInt64BE = $438a2a62f0a90b29$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $438a2a62f0a90b29$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $438a2a62f0a90b29$var$boundsError(offset, this.length - 8);
    var hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$438a2a62f0a90b29$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$438a2a62f0a90b29$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$438a2a62f0a90b29$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$438a2a62f0a90b29$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$438a2a62f0a90b29$var$Buffer.prototype.readBigInt64LE = $438a2a62f0a90b29$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $438a2a62f0a90b29$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $438a2a62f0a90b29$var$boundsError(offset, this.length - 8);
    var val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$438a2a62f0a90b29$var$Buffer.prototype.readBigInt64BE = $438a2a62f0a90b29$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $438a2a62f0a90b29$var$validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === undefined || last === undefined) $438a2a62f0a90b29$var$boundsError(offset, this.length - 8);
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$438a2a62f0a90b29$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return $a38d2305e673c028$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$438a2a62f0a90b29$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 4, this.length);
    return $a38d2305e673c028$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$438a2a62f0a90b29$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 8, this.length);
    return $a38d2305e673c028$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$438a2a62f0a90b29$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkOffset(offset, 8, this.length);
    return $a38d2305e673c028$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $438a2a62f0a90b29$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$438a2a62f0a90b29$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$438a2a62f0a90b29$var$Buffer.prototype.writeUintLE = $438a2a62f0a90b29$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $438a2a62f0a90b29$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUintBE = $438a2a62f0a90b29$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $438a2a62f0a90b29$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUint8 = $438a2a62f0a90b29$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUint16LE = $438a2a62f0a90b29$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUint16BE = $438a2a62f0a90b29$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUint32LE = $438a2a62f0a90b29$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeUint32BE = $438a2a62f0a90b29$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $438a2a62f0a90b29$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $438a2a62f0a90b29$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $438a2a62f0a90b29$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $438a2a62f0a90b29$var$checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$438a2a62f0a90b29$var$Buffer.prototype.writeBigUInt64LE = $438a2a62f0a90b29$var$defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $438a2a62f0a90b29$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$438a2a62f0a90b29$var$Buffer.prototype.writeBigUInt64BE = $438a2a62f0a90b29$var$defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $438a2a62f0a90b29$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$438a2a62f0a90b29$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $438a2a62f0a90b29$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $438a2a62f0a90b29$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$438a2a62f0a90b29$var$Buffer.prototype.writeBigInt64LE = $438a2a62f0a90b29$var$defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $438a2a62f0a90b29$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$438a2a62f0a90b29$var$Buffer.prototype.writeBigInt64BE = $438a2a62f0a90b29$var$defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $438a2a62f0a90b29$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $438a2a62f0a90b29$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $438a2a62f0a90b29$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $a38d2305e673c028$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$438a2a62f0a90b29$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $438a2a62f0a90b29$var$writeFloat(this, value, offset, true, noAssert);
};
$438a2a62f0a90b29$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $438a2a62f0a90b29$var$writeFloat(this, value, offset, false, noAssert);
};
function $438a2a62f0a90b29$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $438a2a62f0a90b29$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $a38d2305e673c028$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$438a2a62f0a90b29$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $438a2a62f0a90b29$var$writeDouble(this, value, offset, true, noAssert);
};
$438a2a62f0a90b29$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $438a2a62f0a90b29$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$438a2a62f0a90b29$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$438a2a62f0a90b29$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$438a2a62f0a90b29$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$438a2a62f0a90b29$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $438a2a62f0a90b29$var$Buffer.isBuffer(val) ? val : $438a2a62f0a90b29$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
var $438a2a62f0a90b29$var$errors = {};
function $438a2a62f0a90b29$var$E(sym, getMessage, Base) {
    $438a2a62f0a90b29$var$errors[sym] = /*#__PURE__*/ function(Base) {
        (0, $28f6179e2b599279$export$71511d61b312f219)(NodeError, Base);
        var _super = (0, $1c23ba689bfccaac$export$71511d61b312f219)(NodeError);
        function NodeError() {
            (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, NodeError);
            var _this;
            _this = _super.call(this);
            Object.defineProperty((0, $9b101634070cfba3$export$71511d61b312f219)(_this), "message", {
                value: getMessage.apply((0, $9b101634070cfba3$export$71511d61b312f219)(_this), arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            _this.name = "".concat(_this.name, " [").concat(sym, "]");
            // Access the stack to generate the error message including the error code
            // from the name.
            _this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete _this.name;
            return _this;
        }
        (0, $625388bbfb3cd523$export$71511d61b312f219)(NodeError, [
            {
                key: "code",
                get: function get() {
                    return sym;
                },
                set: function set(value) {
                    Object.defineProperty(this, "code", {
                        configurable: true,
                        enumerable: true,
                        value: value,
                        writable: true
                    });
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
                }
            }
        ]);
        return NodeError;
    }(Base);
}
$438a2a62f0a90b29$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return "".concat(name, " is outside of buffer bounds");
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$438a2a62f0a90b29$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return 'The "'.concat(name, '" argument must be of type number. Received type ').concat(typeof actual === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(actual));
}, TypeError);
$438a2a62f0a90b29$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $438a2a62f0a90b29$var$addNumericalSeparator(String(input));
    else if ((typeof input === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(input)) === "bigint") {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $438a2a62f0a90b29$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
}, RangeError);
function $438a2a62f0a90b29$var$addNumericalSeparator(val) {
    var res = "";
    var i = val.length;
    var start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = "_".concat(val.slice(i - 3, i)).concat(res);
    return "".concat(val.slice(0, i)).concat(res);
}
// CHECK FUNCTIONS
// ===============
function $438a2a62f0a90b29$var$checkBounds(buf, offset, byteLength) {
    $438a2a62f0a90b29$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $438a2a62f0a90b29$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $438a2a62f0a90b29$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        var n = (typeof min === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(min)) === "bigint" ? "n" : "";
        var range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = ">= 0".concat(n, " and < 2").concat(n, " ** ").concat((byteLength + 1) * 8).concat(n);
            else range = ">= -(2".concat(n, " ** ").concat((byteLength + 1) * 8 - 1).concat(n, ") and < 2 ** ") + "".concat((byteLength + 1) * 8 - 1).concat(n);
        } else range = ">= ".concat(min).concat(n, " and <= ").concat(max).concat(n);
        throw new $438a2a62f0a90b29$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $438a2a62f0a90b29$var$checkBounds(buf, offset, byteLength);
}
function $438a2a62f0a90b29$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $438a2a62f0a90b29$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $438a2a62f0a90b29$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $438a2a62f0a90b29$var$validateNumber(value, type);
        throw new $438a2a62f0a90b29$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $438a2a62f0a90b29$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $438a2a62f0a90b29$var$errors.ERR_OUT_OF_RANGE(type || "offset", ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
}
// HELPER FUNCTIONS
// ================
var $438a2a62f0a90b29$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $438a2a62f0a90b29$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($438a2a62f0a90b29$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $438a2a62f0a90b29$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $438a2a62f0a90b29$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $438a2a62f0a90b29$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $438a2a62f0a90b29$var$base64ToBytes(str) {
    return $623efc618916115a$export$d622b2ad8d90c771($438a2a62f0a90b29$var$base64clean(str));
}
function $438a2a62f0a90b29$var$blitBuffer(src, dst, offset, length) {
    var i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $438a2a62f0a90b29$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $438a2a62f0a90b29$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $438a2a62f0a90b29$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $438a2a62f0a90b29$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $438a2a62f0a90b29$var$BufferBigIntNotDefined : fn;
}
function $438a2a62f0a90b29$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $1eeade30cbff36ce$require$Buffer = $438a2a62f0a90b29$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $1eeade30cbff36ce$var$isVisitable(thing) {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $1eeade30cbff36ce$var$removeBrackets(key) {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $1eeade30cbff36ce$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $1eeade30cbff36ce$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $1eeade30cbff36ce$var$isFlatArray(arr) {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(arr) && !arr.some($1eeade30cbff36ce$var$isVisitable);
}
var $1eeade30cbff36ce$var$predicates = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toFlatObject((0, $c6fd95db66a95a37$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $1eeade30cbff36ce$var$toFormData(obj, formData, options) {
    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $983413b2a0eaae0e$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    var metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    var visitor = options.visitor || defaultVisitor;
    var dots = options.dots;
    var indexes = options.indexes;
    var _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    var useBlob = _Blob && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $1eeade30cbff36ce$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        var arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(value) && $1eeade30cbff36ce$var$isFlatArray(value) || ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFileList(value) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $1eeade30cbff36ce$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $1eeade30cbff36ce$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($1eeade30cbff36ce$var$isVisitable(value)) return true;
        formData.append($1eeade30cbff36ce$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    var stack = [];
    var exposedHelpers = Object.assign($1eeade30cbff36ce$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $1eeade30cbff36ce$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            var result = !((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $1eeade30cbff36ce$export$2e2bcd8739ae039 = $1eeade30cbff36ce$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $3ea7c6f17f32ff00$var$encode(str) {
    var charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $3ea7c6f17f32ff00$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $1eeade30cbff36ce$export$2e2bcd8739ae039)(params, this, options);
}
var $3ea7c6f17f32ff00$var$prototype = $3ea7c6f17f32ff00$var$AxiosURLSearchParams.prototype;
$3ea7c6f17f32ff00$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$3ea7c6f17f32ff00$var$prototype.toString = function toString(encoder) {
    var _encode = encoder ? function _encode(value) {
        return encoder.call(this, value, $3ea7c6f17f32ff00$var$encode);
    } : $3ea7c6f17f32ff00$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $3ea7c6f17f32ff00$export$2e2bcd8739ae039 = $3ea7c6f17f32ff00$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $f9896427eceadcee$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $f9896427eceadcee$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var _encode = options && options.encode || $f9896427eceadcee$var$encode;
    var serializeFn = options && options.serialize;
    var serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $3ea7c6f17f32ff00$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}





"use strict";
var $b2b4d635b99ab9ff$var$InterceptorManager = /*#__PURE__*/ function() {
    function InterceptorManager() {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, InterceptorManager);
        this.handlers = [];
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(InterceptorManager, [
        {
            /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ key: "use",
            value: function use(fulfilled, rejected, options) {
                this.handlers.push({
                    fulfilled: fulfilled,
                    rejected: rejected,
                    synchronous: options ? options.synchronous : false,
                    runWhen: options ? options.runWhen : null
                });
                return this.handlers.length - 1;
            }
        },
        {
            /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ key: "eject",
            value: function eject(id) {
                if (this.handlers[id]) this.handlers[id] = null;
            }
        },
        {
            /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ key: "clear",
            value: function clear() {
                if (this.handlers) this.handlers = [];
            }
        },
        {
            /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ key: "forEach",
            value: function forEach(fn) {
                (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
                    if (h !== null) fn(h);
                });
            }
        }
    ]);
    return InterceptorManager;
}();
var $b2b4d635b99ab9ff$export$2e2bcd8739ae039 = $b2b4d635b99ab9ff$var$InterceptorManager;





"use strict";
var $53b3f7096dbc152f$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






function $2cfc0dd9fa59fdb8$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $a6437d79afda84c4$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}



"use strict";
var $9a92d05ddfce05cc$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $3ea7c6f17f32ff00$export$2e2bcd8739ae039);


"use strict";
var $65d6465ab8ae31e5$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $0d2074ee94622b01$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $a1c9841e029434f4$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, $9a92d05ddfce05cc$export$2e2bcd8739ae039),
        FormData: (0, $65d6465ab8ae31e5$export$2e2bcd8739ae039),
        Blob: (0, $0d2074ee94622b01$export$2e2bcd8739ae039)
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $96bd9a3362da6da6$exports = {};

$parcel$export($96bd9a3362da6da6$exports, "hasBrowserEnv", function () { return $96bd9a3362da6da6$export$c4996c4b7b93b0bf; });
$parcel$export($96bd9a3362da6da6$exports, "navigator", function () { return $96bd9a3362da6da6$export$ec7c8efa7f5790ae; });
$parcel$export($96bd9a3362da6da6$exports, "hasStandardBrowserEnv", function () { return $96bd9a3362da6da6$export$c0bcc9250309d66; });
$parcel$export($96bd9a3362da6da6$exports, "hasStandardBrowserWebWorkerEnv", function () { return $96bd9a3362da6da6$export$c81692cf5af97dac; });
$parcel$export($96bd9a3362da6da6$exports, "origin", function () { return $96bd9a3362da6da6$export$f710a83a91838a36; });
var $96bd9a3362da6da6$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
var $96bd9a3362da6da6$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ var $96bd9a3362da6da6$export$c0bcc9250309d66 = $96bd9a3362da6da6$export$c4996c4b7b93b0bf && (!$96bd9a3362da6da6$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($96bd9a3362da6da6$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ var $96bd9a3362da6da6$export$c81692cf5af97dac = function() {
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
}();
var $96bd9a3362da6da6$export$f710a83a91838a36 = $96bd9a3362da6da6$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $4f26f8d637e1fdc5$export$2e2bcd8739ae039 = (0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, $96bd9a3362da6da6$exports, (0, $a1c9841e029434f4$export$2e2bcd8739ae039));


"use strict";
function $7b08810bd6fe6820$export$2e2bcd8739ae039(data, options) {
    return (0, $1eeade30cbff36ce$export$2e2bcd8739ae039)(data, new (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function visitor(value, key, path, helpers) {
            if ((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).isNode && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5defdff28a25b37d$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map(function(match) {
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5defdff28a25b37d$var$arrayToObject(arr) {
    var obj = {};
    var keys = Object.keys(arr);
    var i;
    var len = keys.length;
    var key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5defdff28a25b37d$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        var name = path[index++];
        if (name === "__proto__") return true;
        var isNumericKey = Number.isFinite(+name);
        var isLast = index >= path.length;
        name = !name && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        var result = buildPath(path, value, target[name], index);
        if (result && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5defdff28a25b37d$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFormData(formData) && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        var obj = {};
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEachEntry(formData, function(name, value) {
            buildPath($5defdff28a25b37d$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5defdff28a25b37d$export$2e2bcd8739ae039 = $5defdff28a25b37d$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $7c8f8d5bb202b6a6$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $7c8f8d5bb202b6a6$var$defaults = {
    transitional: (0, $53b3f7096dbc152f$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            var contentType = headers.getContentType() || "";
            var hasJSONContentType = contentType.indexOf("application/json") > -1;
            var isObjectPayload = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            var isFormData = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5defdff28a25b37d$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBuffer(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isStream(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFile(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBlob(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            var isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $7b08810bd6fe6820$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    var _FormData = this.env && this.env.FormData;
                    return (0, $1eeade30cbff36ce$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $7c8f8d5bb202b6a6$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $7c8f8d5bb202b6a6$var$defaults.transitional;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var JSONRequested = this.responseType === "json";
            if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isResponse(data) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                var silentJSONParsing = transitional && transitional.silentJSONParsing;
                var strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $82194958dcf3d811$export$2e2bcd8739ae039).from(e, (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            Accept: "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], function(method) {
    $7c8f8d5bb202b6a6$var$defaults.headers[method] = {};
});
var $7c8f8d5bb202b6a6$export$2e2bcd8739ae039 = $7c8f8d5bb202b6a6$var$defaults;








"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $deaa86df7a7dca04$var$ignoreDuplicateOf = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $deaa86df7a7dca04$export$2e2bcd8739ae039 = function(rawHeaders) {
    var parsed = {};
    var key;
    var val;
    var i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $deaa86df7a7dca04$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
var $74fcf8410f1e027a$var$$internals = Symbol("internals");
function $74fcf8410f1e027a$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $74fcf8410f1e027a$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(value) ? value.map($74fcf8410f1e027a$var$normalizeValue) : String(value);
}
function $74fcf8410f1e027a$var$parseTokens(str) {
    var tokens = Object.create(null);
    var tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    var match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
var $74fcf8410f1e027a$var$isValidHeaderName = function(str) {
    return /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
};
function $74fcf8410f1e027a$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $74fcf8410f1e027a$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, function(w, _char, str) {
        return _char.toUpperCase() + str;
    });
}
function $74fcf8410f1e027a$var$buildAccessors(obj, header) {
    var accessorName = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach(function(methodName) {
        Object.defineProperty(obj, methodName + accessorName, {
            value: function value(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
var $74fcf8410f1e027a$var$AxiosHeaders = /*#__PURE__*/ function() {
    function AxiosHeaders(headers) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, AxiosHeaders);
        headers && this.set(headers);
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(AxiosHeaders, [
        {
            key: "set",
            value: function set(header, valueOrRewrite, rewrite) {
                var self = this;
                function setHeader(_value, _header, _rewrite) {
                    var lHeader = $74fcf8410f1e027a$var$normalizeHeader(_header);
                    if (!lHeader) throw new Error("header name must be a non-empty string");
                    var key = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(self, lHeader);
                    if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $74fcf8410f1e027a$var$normalizeValue(_value);
                }
                var setHeaders = function(headers, _rewrite) {
                    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(headers, function(_value, _header) {
                        return setHeader(_value, _header, _rewrite);
                    });
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
                else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$74fcf8410f1e027a$var$isValidHeaderName(header)) setHeaders((0, $deaa86df7a7dca04$export$2e2bcd8739ae039)(header), valueOrRewrite);
                else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isHeaders(header)) try {
                    for(var _iterator = header.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $1733e6e3a24db77c$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        setHeader(value, key, rewrite);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                            _iterator["return"]();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else header != null && setHeader(valueOrRewrite, header, rewrite);
                return this;
            }
        },
        {
            key: "get",
            value: function get(header, parser) {
                header = $74fcf8410f1e027a$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(this, header);
                    if (key) {
                        var value = this[key];
                        if (!parser) return value;
                        if (parser === true) return $74fcf8410f1e027a$var$parseTokens(value);
                        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                        throw new TypeError("parser must be boolean|regexp|function");
                    }
                }
            }
        },
        {
            key: "has",
            value: function has(header, matcher) {
                header = $74fcf8410f1e027a$var$normalizeHeader(header);
                if (header) {
                    var key = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(this, header);
                    return !!(key && this[key] !== undefined && (!matcher || $74fcf8410f1e027a$var$matchHeaderValue(this, this[key], key, matcher)));
                }
                return false;
            }
        },
        {
            key: "delete",
            value: function _delete(header, matcher) {
                var self = this;
                var deleted = false;
                function deleteHeader(_header) {
                    _header = $74fcf8410f1e027a$var$normalizeHeader(_header);
                    if (_header) {
                        var key = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(self, _header);
                        if (key && (!matcher || $74fcf8410f1e027a$var$matchHeaderValue(self, self[key], key, matcher))) {
                            delete self[key];
                            deleted = true;
                        }
                    }
                }
                if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
                else deleteHeader(header);
                return deleted;
            }
        },
        {
            key: "clear",
            value: function clear(matcher) {
                var keys = Object.keys(this);
                var i = keys.length;
                var deleted = false;
                while(i--){
                    var key = keys[i];
                    if (!matcher || $74fcf8410f1e027a$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                        delete this[key];
                        deleted = true;
                    }
                }
                return deleted;
            }
        },
        {
            key: "normalize",
            value: function normalize(format) {
                var self = this;
                var headers = {};
                (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    var key = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey(headers, header);
                    if (key) {
                        self[key] = $74fcf8410f1e027a$var$normalizeValue(value);
                        delete self[header];
                        return;
                    }
                    var normalized = format ? $74fcf8410f1e027a$var$formatHeader(header) : String(header).trim();
                    if (normalized !== header) delete self[header];
                    self[normalized] = $74fcf8410f1e027a$var$normalizeValue(value);
                    headers[normalized] = true;
                });
                return this;
            }
        },
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++){
                    targets[_key] = arguments[_key];
                }
                var _this_constructor;
                return (_this_constructor = this.constructor).concat.apply(_this_constructor, [
                    this
                ].concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(targets)));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(asStrings) {
                var obj = Object.create(null);
                (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(this, function(value, header) {
                    value != null && value !== false && (obj[header] = asStrings && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
                });
                return obj;
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return Object.entries(this.toJSON())[Symbol.iterator]();
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Object.entries(this.toJSON()).map(function(param) {
                    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), header = _param[0], value = _param[1];
                    return header + ": " + value;
                }).join("\n");
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "AxiosHeaders";
            }
        }
    ], [
        {
            key: "from",
            value: function from(thing) {
                return thing instanceof this ? thing : new this(thing);
            }
        },
        {
            key: "concat",
            value: function concat(first) {
                for(var _len = arguments.length, targets = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    targets[_key - 1] = arguments[_key];
                }
                var computed = new this(first);
                targets.forEach(function(target) {
                    return computed.set(target);
                });
                return computed;
            }
        },
        {
            key: "accessor",
            value: function accessor(header) {
                var internals = this[$74fcf8410f1e027a$var$$internals] = this[$74fcf8410f1e027a$var$$internals] = {
                    accessors: {}
                };
                var accessors = internals.accessors;
                var prototype = this.prototype;
                function defineAccessor(_header) {
                    var lHeader = $74fcf8410f1e027a$var$normalizeHeader(_header);
                    if (!accessors[lHeader]) {
                        $74fcf8410f1e027a$var$buildAccessors(prototype, _header);
                        accessors[lHeader] = true;
                    }
                }
                (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
                return this;
            }
        }
    ]);
    return AxiosHeaders;
}();
$74fcf8410f1e027a$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).reduceDescriptors($74fcf8410f1e027a$var$AxiosHeaders.prototype, function(param, key) {
    var value = param.value;
    var mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: function() {
            return value;
        },
        set: function(headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).freezeMethods($74fcf8410f1e027a$var$AxiosHeaders);
var $74fcf8410f1e027a$export$2e2bcd8739ae039 = $74fcf8410f1e027a$var$AxiosHeaders;


"use strict";
function $09abcdf599ca47fd$export$2e2bcd8739ae039(fns, response) {
    var config = this || (0, $7c8f8d5bb202b6a6$export$2e2bcd8739ae039);
    var context = response || config;
    var headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(context.headers);
    var data = context.data;
    (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $ad1a5450a5160689$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $b4466f79dd14f203$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $82194958dcf3d811$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).inherits($b4466f79dd14f203$var$CanceledError, (0, $82194958dcf3d811$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $b4466f79dd14f203$export$2e2bcd8739ae039 = $b4466f79dd14f203$var$CanceledError;









"use strict";
function $c0c665f8f7f2c495$export$2e2bcd8739ae039(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $4aa597b942719605$export$2e2bcd8739ae039(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}






"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $f85ac55cb3f96026$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    var bytes = new Array(samplesCount);
    var timestamps = new Array(samplesCount);
    var head = 0;
    var tail = 0;
    var firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        var now = Date.now();
        var startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        var i = tail;
        var bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        var passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $f85ac55cb3f96026$export$2e2bcd8739ae039 = $f85ac55cb3f96026$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $db64eb36ffee3aef$var$throttle(fn, freq) {
    var timestamp = 0;
    var threshold = 1000 / freq;
    var lastArgs;
    var timer;
    var invoke = function(args) {
        var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    var throttled = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        var passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(function() {
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    var flush = function() {
        return lastArgs && invoke(lastArgs);
    };
    return [
        throttled,
        flush
    ];
}
var $db64eb36ffee3aef$export$2e2bcd8739ae039 = $db64eb36ffee3aef$var$throttle;



var $e224c15f6e2f6fba$export$c1b28109d46c3592 = function(listener, isDownloadStream) {
    var freq = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3;
    var bytesNotified = 0;
    var _speedometer = (0, $f85ac55cb3f96026$export$2e2bcd8739ae039)(50, 250);
    return (0, $db64eb36ffee3aef$export$2e2bcd8739ae039)(function(e) {
        var loaded = e.loaded;
        var total = e.lengthComputable ? e.total : undefined;
        var progressBytes = loaded - bytesNotified;
        var rate = _speedometer(progressBytes);
        var inRange = loaded <= total;
        bytesNotified = loaded;
        var data = (0, $a6437d79afda84c4$export$71511d61b312f219)({
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        }, isDownloadStream ? "download" : "upload", true);
        listener(data);
    }, freq);
};
var $e224c15f6e2f6fba$export$d9fadd12586c18d6 = function(total, throttled) {
    var lengthComputable = total != null;
    return [
        function(loaded) {
            return throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            });
        },
        throttled[1]
    ];
};
var $e224c15f6e2f6fba$export$5d35863c355a22a9 = function(fn) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).asap(function() {
            return fn.apply(void 0, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
        });
    };
};






function $e2b29f910c0df710$export$71511d61b312f219(arr) {
    return (0, $a5f6cdc932bbffa3$export$71511d61b312f219)(arr) || (0, $222be757f0b96279$export$71511d61b312f219)(arr) || (0, $36be118b55e0b615$export$71511d61b312f219)(arr) || (0, $c634cf1d97a12780$export$71511d61b312f219)();
}







"use strict";
var $b68a4e7e99c6d789$export$2e2bcd8739ae039 = (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $8e85fda76462c38e$export$2e2bcd8739ae039 = (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write: function(name, value, expires, path, domain, secure) {
        var cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read: function(name) {
        var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function(name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write: function() {},
    read: function() {
        return null;
    },
    remove: function() {}
};


"use strict";
function $49f0e6122e6d6215$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $84aa1f6d68ee8578$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $a145a933c101048a$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $49f0e6122e6d6215$export$2e2bcd8739ae039)(requestedURL)) return (0, $84aa1f6d68ee8578$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}





"use strict";
var $d6ec2a123bef168e$var$headersToObject = function(thing) {
    return thing instanceof (0, $74fcf8410f1e027a$export$2e2bcd8739ae039) ? (0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, thing) : thing;
};
function $d6ec2a123bef168e$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    var mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: function(a, b) {
            return mergeDeepProperties($d6ec2a123bef168e$var$headersToObject(a), $d6ec2a123bef168e$var$headersToObject(b), true);
        }
    };
    (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(config1[prop], config2[prop], prop);
        (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $a37a65c5c782d854$export$2e2bcd8739ae039 = function(config) {
    var newConfig = (0, $d6ec2a123bef168e$export$2e2bcd8739ae039)({}, config);
    var data = newConfig.data, withXSRFToken = newConfig.withXSRFToken, xsrfHeaderName = newConfig.xsrfHeaderName, xsrfCookieName = newConfig.xsrfCookieName, headers = newConfig.headers, auth = newConfig.auth;
    newConfig.headers = headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $f9896427eceadcee$export$2e2bcd8739ae039)((0, $a145a933c101048a$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    var contentType;
    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            var _ref = (0, $e2b29f910c0df710$export$71511d61b312f219)(contentType ? contentType.split(";").map(function(token) {
                return token.trim();
            }).filter(Boolean) : []), type = _ref[0], tokens = _ref.slice(1);
            headers.setContentType([
                type || "multipart/form-data"
            ].concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(tokens)).join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $b68a4e7e99c6d789$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            var xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $8e85fda76462c38e$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


var $7d658be7e59b6c8f$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $7d658be7e59b6c8f$export$2e2bcd8739ae039 = $7d658be7e59b6c8f$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var _config = (0, $a37a65c5c782d854$export$2e2bcd8739ae039)(config);
        var requestData = _config.data;
        var requestHeaders = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(_config.headers).normalize();
        var responseType = _config.responseType, onUploadProgress = _config.onUploadProgress, onDownloadProgress = _config.onDownloadProgress;
        var onCanceled;
        var uploadThrottled, downloadThrottled;
        var flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        var request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c0c665f8f7f2c495$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Request aborted", (0, $82194958dcf3d811$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Network Error", (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            var transitional = _config.transitional || (0, $53b3f7096dbc152f$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $82194958dcf3d811$export$2e2bcd8739ae039).ETIMEDOUT : (0, $82194958dcf3d811$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            var ref;
            ref = (0, $1733e6e3a24db77c$export$71511d61b312f219)((0, $e224c15f6e2f6fba$export$c1b28109d46c3592)(onDownloadProgress, true), 2), downloadThrottled = ref[0], flushDownload = ref[1], ref;
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            var ref1;
            ref1 = (0, $1733e6e3a24db77c$export$71511d61b312f219)((0, $e224c15f6e2f6fba$export$c1b28109d46c3592)(onUploadProgress), 2), uploadThrottled = ref1[0], flushUpload = ref1[1], ref1;
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $b4466f79dd14f203$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        var protocol = (0, $4aa597b942719605$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};




function $f0cc97789eddd92a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f0cc97789eddd92a$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f0cc97789eddd92a$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}











var $833f8f6a265fff68$var$composeSignals = function(signals, timeout) {
    var length = (signals = signals ? signals.filter(Boolean) : []).length;
    if (timeout || length) {
        var controller = new AbortController();
        var aborted;
        var onabort = function onabort(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                var err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $82194958dcf3d811$export$2e2bcd8739ae039) ? err : new (0, $b4466f79dd14f203$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        var timer = timeout && setTimeout(function() {
            timer = null;
            onabort(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("timeout ".concat(timeout, " of ms exceeded"), (0, $82194958dcf3d811$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        var unsubscribe = function() {
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach(function(signal) {
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach(function(signal) {
            return signal.addEventListener("abort", onabort);
        });
        var signal = controller.signal;
        signal.unsubscribe = function() {
            return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).asap(unsubscribe);
        };
        return signal;
    }
};
var $833f8f6a265fff68$export$2e2bcd8739ae039 = $833f8f6a265fff68$var$composeSignals;


function $17e74aaec9f0c9e2$export$71511d61b312f219(inner, awaitWrap) {
    var iter = {}, waiting = false;
    function pump(key, value) {
        waiting = true;
        value = new Promise(function(resolve) {
            resolve(inner[key](value));
        });
        return {
            done: false,
            value: awaitWrap(value)
        };
    }
    if (typeof Symbol === "function" && Symbol.iterator) iter[Symbol.iterator] = function() {
        return this;
    };
    iter.next = function(value) {
        if (waiting) {
            waiting = false;
            return value;
        }
        return pump("next", value);
    };
    if (typeof inner.throw === "function") iter.throw = function(value) {
        if (waiting) {
            waiting = false;
            throw value;
        }
        return pump("throw", value);
    };
    if (typeof inner.return === "function") iter.return = function(value) {
        return pump("return", value);
    };
    return iter;
}


function $58e2e9f5f01f626d$export$71511d61b312f219(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new $58e2e9f5f01f626d$var$AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function $58e2e9f5f01f626d$var$AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return $58e2e9f5f01f626d$var$AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, $58e2e9f5f01f626d$var$AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new $58e2e9f5f01f626d$var$AsyncFromSyncIterator(s);
}



function $0cb13c87dfd30140$export$71511d61b312f219(value) {
    this.wrapped = value;
}


function $dba6b08d41f84d66$export$71511d61b312f219(value) {
    return new (0, $0cb13c87dfd30140$export$71511d61b312f219)(value);
}



function $7470c90b63c2ed80$export$71511d61b312f219(gen) {
    var front, back;
    function send(key, arg) {
        return new Promise(function(resolve, reject) {
            var request = {
                key: key,
                arg: arg,
                resolve: resolve,
                reject: reject,
                next: null
            };
            if (back) back = back.next = request;
            else {
                front = back = request;
                resume(key, arg);
            }
        });
    }
    function resume(key, arg) {
        try {
            var result = gen[key](arg);
            var value = result.value;
            var wrappedAwait = value instanceof (0, $0cb13c87dfd30140$export$71511d61b312f219);
            Promise.resolve(wrappedAwait ? value.wrapped : value).then(function(arg) {
                if (wrappedAwait) {
                    resume("next", arg);
                    return;
                }
                settle(result.done ? "return" : "normal", arg);
            }, function(err) {
                resume("throw", err);
            });
        } catch (err) {
            settle("throw", err);
        }
    }
    function settle(type, value) {
        switch(type){
            case "return":
                front.resolve({
                    value: value,
                    done: true
                });
                break;
            case "throw":
                front.reject(value);
                break;
            default:
                front.resolve({
                    value: value,
                    done: false
                });
                break;
        }
        front = front.next;
        if (front) resume(front.key, front.arg);
        else back = null;
    }
    this._invoke = send;
    if (typeof gen.return !== "function") this.return = undefined;
}
if (typeof Symbol === "function" && Symbol.asyncIterator) $7470c90b63c2ed80$export$71511d61b312f219.prototype[Symbol.asyncIterator] = function() {
    return this;
};
$7470c90b63c2ed80$export$71511d61b312f219.prototype.next = function(arg) {
    return this._invoke("next", arg);
};
$7470c90b63c2ed80$export$71511d61b312f219.prototype.throw = function(arg) {
    return this._invoke("throw", arg);
};
$7470c90b63c2ed80$export$71511d61b312f219.prototype.return = function(arg) {
    return this._invoke("return", arg);
};


function $a1fec2d0f280b502$export$71511d61b312f219(fn) {
    return function() {
        return new (0, $7470c90b63c2ed80$export$71511d61b312f219)(fn.apply(this, arguments));
    };
}




var $d136e98d8c08ca6b$export$71b051935044bd5d = function streamChunk(chunk, chunkSize) {
    var len, pos, end;
    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
        switch(_state.label){
            case 0:
                len = chunk.byteLength;
                if (!(!chunkSize || len < chunkSize)) return [
                    3,
                    2
                ];
                return [
                    4,
                    chunk
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                pos = 0;
                _state.label = 3;
            case 3:
                if (!(pos < len)) return [
                    3,
                    5
                ];
                end = pos + chunkSize;
                return [
                    4,
                    chunk.slice(pos, end)
                ];
            case 4:
                _state.sent();
                pos = end;
                return [
                    3,
                    3
                ];
            case 5:
                return [
                    2
                ];
        }
    });
};
var $d136e98d8c08ca6b$export$f9f241124ee3198e = function() {
    var _ref = (0, $a1fec2d0f280b502$export$71511d61b312f219)(function(iterable, chunkSize) {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, err;
        return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        8,
                        13
                    ]);
                    _iterator = (0, $58e2e9f5f01f626d$export$71511d61b312f219)($d136e98d8c08ca6b$var$readStream(iterable));
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        (0, $dba6b08d41f84d66$export$71511d61b312f219)(_iterator.next())
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        6
                    ];
                    _value = _step.value;
                    chunk = _value;
                    return [
                        5,
                        (0, $248fc3c53839d9ba$export$19a8beecd37a4c45)((0, $17e74aaec9f0c9e2$export$71511d61b312f219)((0, $58e2e9f5f01f626d$export$71511d61b312f219)($d136e98d8c08ca6b$export$71b051935044bd5d(chunk, chunkSize)), (0, $dba6b08d41f84d66$export$71511d61b312f219)))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 6:
                    return [
                        3,
                        13
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        13
                    ];
                case 8:
                    _state.trys.push([
                        8,
                        ,
                        11,
                        12
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator["return"] != null)) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        _iterator["return"]()
                    ];
                case 9:
                    _state.sent();
                    _state.label = 10;
                case 10:
                    return [
                        3,
                        12
                    ];
                case 11:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        7
                    ];
                case 13:
                    return [
                        2
                    ];
            }
        });
    });
    return function readBytes(iterable, chunkSize) {
        return _ref.apply(this, arguments);
    };
}();
var $d136e98d8c08ca6b$var$readStream = function() {
    var _ref = (0, $a1fec2d0f280b502$export$71511d61b312f219)(function(stream) {
        var reader, _ref, done, value;
        return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!stream[Symbol.asyncIterator]) return [
                        3,
                        2
                    ];
                    return [
                        5,
                        (0, $248fc3c53839d9ba$export$19a8beecd37a4c45)((0, $17e74aaec9f0c9e2$export$71511d61b312f219)((0, $58e2e9f5f01f626d$export$71511d61b312f219)(stream), (0, $dba6b08d41f84d66$export$71511d61b312f219)))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
                case 2:
                    reader = stream.getReader();
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        ,
                        9,
                        11
                    ]);
                    _state.label = 4;
                case 4:
                    return [
                        4,
                        (0, $dba6b08d41f84d66$export$71511d61b312f219)(reader.read())
                    ];
                case 5:
                    _ref = _state.sent(), done = _ref.done, value = _ref.value;
                    if (done) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        value
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        4
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    return [
                        4,
                        (0, $dba6b08d41f84d66$export$71511d61b312f219)(reader.cancel())
                    ];
                case 10:
                    _state.sent();
                    return [
                        7
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    });
    return function readStream(stream) {
        return _ref.apply(this, arguments);
    };
}();
var $d136e98d8c08ca6b$export$b0119225647bd83 = function(stream, chunkSize, onProgress, onFinish) {
    var iterator = $d136e98d8c08ca6b$export$f9f241124ee3198e(stream, chunkSize);
    var bytes = 0;
    var done;
    var _onFinish = function(e) {
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        pull: function(controller) {
            return (0, $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                var _ref, done, value, len, loadedBytes, err;
                return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                iterator.next()
                            ];
                        case 1:
                            _ref = _state.sent(), done = _ref.done, value = _ref.value;
                            if (done) {
                                _onFinish();
                                controller.close();
                                return [
                                    2
                                ];
                            }
                            len = value.byteLength;
                            if (onProgress) {
                                loadedBytes = bytes += len;
                                onProgress(loadedBytes);
                            }
                            controller.enqueue(new Uint8Array(value));
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            _onFinish(err);
                            throw err;
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        },
        cancel: function(reason) {
            _onFinish(reason);
            return iterator["return"]();
        }
    }, {
        highWaterMark: 2
    });
};






var $f563560c7540a370$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
var $f563560c7540a370$var$isReadableStreamSupported = $f563560c7540a370$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
var $f563560c7540a370$var$encodeText = $f563560c7540a370$var$isFetchSupported && (typeof TextEncoder === "function" ? function(encoder) {
    return function(str) {
        return encoder.encode(str);
    };
}(new TextEncoder()) : function() {
    var _ref = (0, $cd0bb46fcf33db2e$export$71511d61b312f219)(function(str) {
        var _;
        return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _ = Uint8Array.bind;
                    return [
                        4,
                        new Response(str).arrayBuffer()
                    ];
                case 1:
                    return [
                        2,
                        new (_.apply(Uint8Array, [
                            void 0,
                            _state.sent()
                        ]))
                    ];
            }
        });
    });
    return function(str) {
        return _ref.apply(this, arguments);
    };
}());
var $f563560c7540a370$var$test = function(fn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    try {
        return !!fn.apply(void 0, (0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args));
    } catch (e) {
        return false;
    }
};
var $f563560c7540a370$var$supportsRequestStream = $f563560c7540a370$var$isReadableStreamSupported && $f563560c7540a370$var$test(function() {
    var duplexAccessed = false;
    var hasContentType = new Request((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
var $f563560c7540a370$var$DEFAULT_CHUNK_SIZE = 65536;
var $f563560c7540a370$var$supportsResponseStream = $f563560c7540a370$var$isReadableStreamSupported && $f563560c7540a370$var$test(function() {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isReadableStream(new Response("").body);
});
var $f563560c7540a370$var$resolvers = {
    stream: $f563560c7540a370$var$supportsResponseStream && function(res) {
        return res.body;
    }
};
$f563560c7540a370$var$isFetchSupported && function(res) {
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach(function(type) {
        !$f563560c7540a370$var$resolvers[type] && ($f563560c7540a370$var$resolvers[type] = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(res[type]) ? function(res) {
            return res[type]();
        } : function(_, config) {
            throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Response type '".concat(type, "' is not supported"), (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
}(new Response);
var $f563560c7540a370$var$getBodyLength = function() {
    var _ref = (0, $cd0bb46fcf33db2e$export$71511d61b312f219)(function(body) {
        var _request;
        return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (body == null) return [
                        2,
                        0
                    ];
                    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isBlob(body)) return [
                        2,
                        body.size
                    ];
                    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return [
                        3,
                        2
                    ];
                    _request = new Request((0, $4f26f8d637e1fdc5$export$2e2bcd8739ae039).origin, {
                        method: "POST",
                        body: body
                    });
                    return [
                        4,
                        _request.arrayBuffer()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().byteLength
                    ];
                case 2:
                    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArrayBuffer(body)) return [
                        2,
                        body.byteLength
                    ];
                    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
                    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(body)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        $f563560c7540a370$var$encodeText(body)
                    ];
                case 3:
                    return [
                        2,
                        _state.sent().byteLength
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getBodyLength(body) {
        return _ref.apply(this, arguments);
    };
}();
var $f563560c7540a370$var$resolveBodyLength = function() {
    var _ref = (0, $cd0bb46fcf33db2e$export$71511d61b312f219)(function(headers, body) {
        var length;
        return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
            length = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
            return [
                2,
                length == null ? $f563560c7540a370$var$getBodyLength(body) : length
            ];
        });
    });
    return function resolveBodyLength(headers, body) {
        return _ref.apply(this, arguments);
    };
}();
var $f563560c7540a370$export$2e2bcd8739ae039 = $f563560c7540a370$var$isFetchSupported && function() {
    var _ref = (0, $cd0bb46fcf33db2e$export$71511d61b312f219)(function(config) {
        var _resolveConfig, url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, _resolveConfig_withCredentials, withCredentials, fetchOptions, composedSignal, request, unsubscribe, requestContentLength, _tmp, _request, contentTypeHeader, _progressEventDecorator, onProgress, flush, isCredentialsSupported, response, isStreamResponse, options, responseContentLength, _ref, onProgress1, flush1, responseData, err;
        return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _resolveConfig = (0, $a37a65c5c782d854$export$2e2bcd8739ae039)(config), url = _resolveConfig.url, method = _resolveConfig.method, data = _resolveConfig.data, signal = _resolveConfig.signal, cancelToken = _resolveConfig.cancelToken, timeout = _resolveConfig.timeout, onDownloadProgress = _resolveConfig.onDownloadProgress, onUploadProgress = _resolveConfig.onUploadProgress, responseType = _resolveConfig.responseType, headers = _resolveConfig.headers, _resolveConfig_withCredentials = _resolveConfig.withCredentials, withCredentials = _resolveConfig_withCredentials === void 0 ? "same-origin" : _resolveConfig_withCredentials, fetchOptions = _resolveConfig.fetchOptions;
                    responseType = responseType ? (responseType + "").toLowerCase() : "text";
                    composedSignal = (0, $833f8f6a265fff68$export$2e2bcd8739ae039)([
                        signal,
                        cancelToken && cancelToken.toAbortSignal()
                    ], timeout);
                    unsubscribe = composedSignal && composedSignal.unsubscribe && function() {
                        composedSignal.unsubscribe();
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        7,
                        ,
                        8
                    ]);
                    _tmp = onUploadProgress && $f563560c7540a370$var$supportsRequestStream && method !== "get" && method !== "head";
                    if (!_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $f563560c7540a370$var$resolveBodyLength(headers, data)
                    ];
                case 2:
                    _tmp = (requestContentLength = _state.sent()) !== 0;
                    _state.label = 3;
                case 3:
                    if (_tmp) {
                        _request = new Request(url, {
                            method: "POST",
                            body: data,
                            duplex: "half"
                        });
                        ;
                        if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
                        if (_request.body) {
                            _progressEventDecorator = (0, $1733e6e3a24db77c$export$71511d61b312f219)((0, $e224c15f6e2f6fba$export$d9fadd12586c18d6)(requestContentLength, (0, $e224c15f6e2f6fba$export$c1b28109d46c3592)((0, $e224c15f6e2f6fba$export$5d35863c355a22a9)(onUploadProgress))), 2), onProgress = _progressEventDecorator[0], flush = _progressEventDecorator[1];
                            data = (0, $d136e98d8c08ca6b$export$b0119225647bd83)(_request.body, $f563560c7540a370$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
                        }
                    }
                    if (!(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
                    // Cloudflare Workers throws when credentials are defined
                    // see https://github.com/cloudflare/workerd/issues/902
                    isCredentialsSupported = "credentials" in Request.prototype;
                    request = new Request(url, (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, fetchOptions), {
                        signal: composedSignal,
                        method: method.toUpperCase(),
                        headers: headers.normalize().toJSON(),
                        body: data,
                        duplex: "half",
                        credentials: isCredentialsSupported ? withCredentials : undefined
                    }));
                    return [
                        4,
                        fetch(request)
                    ];
                case 4:
                    response = _state.sent();
                    isStreamResponse = $f563560c7540a370$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
                    if ($f563560c7540a370$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                        options = {};
                        [
                            "status",
                            "statusText",
                            "headers"
                        ].forEach(function(prop) {
                            options[prop] = response[prop];
                        });
                        responseContentLength = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
                        _ref = (0, $1733e6e3a24db77c$export$71511d61b312f219)(onDownloadProgress && (0, $e224c15f6e2f6fba$export$d9fadd12586c18d6)(responseContentLength, (0, $e224c15f6e2f6fba$export$c1b28109d46c3592)((0, $e224c15f6e2f6fba$export$5d35863c355a22a9)(onDownloadProgress), true)) || [], 2), onProgress1 = _ref[0], flush1 = _ref[1];
                        response = new Response((0, $d136e98d8c08ca6b$export$b0119225647bd83)(response.body, $f563560c7540a370$var$DEFAULT_CHUNK_SIZE, onProgress1, function() {
                            flush1 && flush1();
                            unsubscribe && unsubscribe();
                        }), options);
                    }
                    responseType = responseType || "text";
                    return [
                        4,
                        $f563560c7540a370$var$resolvers[(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).findKey($f563560c7540a370$var$resolvers, responseType) || "text"](response, config)
                    ];
                case 5:
                    responseData = _state.sent();
                    !isStreamResponse && unsubscribe && unsubscribe();
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            (0, $c0c665f8f7f2c495$export$2e2bcd8739ae039)(resolve, reject, {
                                data: responseData,
                                headers: (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(response.headers),
                                status: response.status,
                                statusText: response.statusText,
                                config: config,
                                request: request
                            });
                        })
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    err = _state.sent();
                    unsubscribe && unsubscribe();
                    if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Network Error", (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
                        cause: err.cause || err
                    });
                    throw (0, $82194958dcf3d811$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return function(config) {
        return _ref.apply(this, arguments);
    };
}();



var $ecc2e934cf4b2586$var$knownAdapters = {
    http: (0, $983413b2a0eaae0e$export$2e2bcd8739ae039),
    xhr: (0, $7d658be7e59b6c8f$export$2e2bcd8739ae039),
    fetch: (0, $f563560c7540a370$export$2e2bcd8739ae039)
};
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach($ecc2e934cf4b2586$var$knownAdapters, function(fn, value) {
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $ecc2e934cf4b2586$var$renderReason = function(reason) {
    return "- ".concat(reason);
};
var $ecc2e934cf4b2586$var$isResolvedHandle = function(adapter) {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
};
var $ecc2e934cf4b2586$export$2e2bcd8739ae039 = {
    getAdapter: function(adapters) {
        adapters = (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        var length = adapters.length;
        var nameOrAdapter;
        var adapter;
        var rejectedReasons = {};
        for(var i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            var id = void 0;
            adapter = nameOrAdapter;
            if (!$ecc2e934cf4b2586$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $ecc2e934cf4b2586$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Unknown adapter '".concat(id, "'"));
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            var reasons = Object.entries(rejectedReasons).map(function(param) {
                var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), id = _param[0], state = _param[1];
                return "adapter ".concat(id, " ") + (state === false ? "is not supported by the environment" : "is not available in the build");
            });
            var s = length ? reasons.length > 1 ? "since :\n" + reasons.map($ecc2e934cf4b2586$var$renderReason).join("\n") : " " + $ecc2e934cf4b2586$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("There is no suitable adapter to dispatch the request " + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $ecc2e934cf4b2586$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $078d153ff3a29674$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $b4466f79dd14f203$export$2e2bcd8739ae039)(null, config);
}
function $078d153ff3a29674$export$2e2bcd8739ae039(config) {
    $078d153ff3a29674$var$throwIfCancellationRequested(config);
    config.headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $09abcdf599ca47fd$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    var adapter = (0, $ecc2e934cf4b2586$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $7c8f8d5bb202b6a6$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $078d153ff3a29674$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $09abcdf599ca47fd$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ad1a5450a5160689$export$2e2bcd8739ae039)(reason)) {
            $078d153ff3a29674$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $09abcdf599ca47fd$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}





var $25c3930f89e6179f$export$a4ad2735b021c132 = "1.7.7";



"use strict";
var $f61feb979da78eab$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $f61feb979da78eab$var$validators[type] = function validator(thing) {
        return (typeof thing === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(thing)) === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $f61feb979da78eab$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $f61feb979da78eab$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $25c3930f89e6179f$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$f61feb979da78eab$var$deprecatedWarnings[opt]) {
            $f61feb979da78eab$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $f61feb979da78eab$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("options must be an object", (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $82194958dcf3d811$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $82194958dcf3d811$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $f61feb979da78eab$export$2e2bcd8739ae039 = {
    assertOptions: $f61feb979da78eab$var$assertOptions,
    validators: $f61feb979da78eab$var$validators
};



"use strict";
var $32554a0f086aa968$var$validators = (0, $f61feb979da78eab$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ var $32554a0f086aa968$var$Axios = /*#__PURE__*/ function() {
    function Axios(instanceConfig) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, Axios);
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $b2b4d635b99ab9ff$export$2e2bcd8739ae039)(),
            response: new (0, $b2b4d635b99ab9ff$export$2e2bcd8739ae039)()
        };
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(Axios, [
        {
            key: "request",
            value: /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ function request(configOrUrl, config) {
                var _this = this;
                return (0, $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                    var err, dummy, stack;
                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._request(configOrUrl, config)
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                err = _state.sent();
                                if (err instanceof Error) {
                                    ;
                                    Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                                    // slice off the Error: ... line
                                    stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                                    try {
                                        if (!err.stack) err.stack = stack;
                                        else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                                    } catch (e) {
                                    // ignore the case where "stack" is an un-writable property
                                    }
                                }
                                throw err;
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_request",
            value: function _request(configOrUrl, config) {
                /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
                if (typeof configOrUrl === "string") {
                    config = config || {};
                    config.url = configOrUrl;
                } else config = configOrUrl || {};
                config = (0, $d6ec2a123bef168e$export$2e2bcd8739ae039)(this.defaults, config);
                var transitional = config.transitional, paramsSerializer = config.paramsSerializer, headers = config.headers;
                if (transitional !== undefined) (0, $f61feb979da78eab$export$2e2bcd8739ae039).assertOptions(transitional, {
                    silentJSONParsing: $32554a0f086aa968$var$validators.transitional($32554a0f086aa968$var$validators["boolean"]),
                    forcedJSONParsing: $32554a0f086aa968$var$validators.transitional($32554a0f086aa968$var$validators["boolean"]),
                    clarifyTimeoutError: $32554a0f086aa968$var$validators.transitional($32554a0f086aa968$var$validators["boolean"])
                }, false);
                if (paramsSerializer != null) {
                    if ((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                        serialize: paramsSerializer
                    };
                    else (0, $f61feb979da78eab$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                        encode: $32554a0f086aa968$var$validators["function"],
                        serialize: $32554a0f086aa968$var$validators["function"]
                    }, true);
                }
                // Set config.method
                config.method = (config.method || this.defaults.method || "get").toLowerCase();
                // Flatten headers
                var contextHeaders = headers && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
                headers && (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach([
                    "delete",
                    "get",
                    "head",
                    "post",
                    "put",
                    "patch",
                    "common"
                ], function(method) {
                    delete headers[method];
                });
                config.headers = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039).concat(contextHeaders, headers);
                // filter out skipped interceptors
                var requestInterceptorChain = [];
                var synchronousRequestInterceptors = true;
                this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
                    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
                    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
                    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
                });
                var responseInterceptorChain = [];
                this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
                    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
                });
                var promise;
                var i = 0;
                var len;
                if (!synchronousRequestInterceptors) {
                    var chain = [
                        (0, $078d153ff3a29674$export$2e2bcd8739ae039).bind(this),
                        undefined
                    ];
                    chain.unshift.apply(chain, requestInterceptorChain);
                    chain.push.apply(chain, responseInterceptorChain);
                    len = chain.length;
                    promise = Promise.resolve(config);
                    while(i < len)promise = promise.then(chain[i++], chain[i++]);
                    return promise;
                }
                len = requestInterceptorChain.length;
                var newConfig = config;
                i = 0;
                while(i < len){
                    var onFulfilled = requestInterceptorChain[i++];
                    var onRejected = requestInterceptorChain[i++];
                    try {
                        newConfig = onFulfilled(newConfig);
                    } catch (error) {
                        onRejected.call(this, error);
                        break;
                    }
                }
                try {
                    promise = (0, $078d153ff3a29674$export$2e2bcd8739ae039).call(this, newConfig);
                } catch (error) {
                    return Promise.reject(error);
                }
                i = 0;
                len = responseInterceptorChain.length;
                while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
                return promise;
            }
        },
        {
            key: "getUri",
            value: function getUri(config) {
                config = (0, $d6ec2a123bef168e$export$2e2bcd8739ae039)(this.defaults, config);
                var fullPath = (0, $a145a933c101048a$export$2e2bcd8739ae039)(config.baseURL, config.url);
                return (0, $f9896427eceadcee$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
            }
        }
    ]);
    return Axios;
}();
// Provide aliases for supported request methods
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $32554a0f086aa968$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $d6ec2a123bef168e$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c6fd95db66a95a37$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $d6ec2a123bef168e$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $32554a0f086aa968$var$Axios.prototype[method] = generateHTTPMethod();
    $32554a0f086aa968$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $32554a0f086aa968$export$2e2bcd8739ae039 = $32554a0f086aa968$var$Axios;









"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ var $d8cf381d353a4513$var$CancelToken = /*#__PURE__*/ function() {
    function CancelToken(executor) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, CancelToken);
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        var token = this;
        // eslint-disable-next-line func-names
        this.promise.then(function(cancel) {
            if (!token._listeners) return;
            var i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = function(onfulfilled) {
            var _resolve;
            // eslint-disable-next-line func-names
            var promise = new Promise(function(resolve) {
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $b4466f79dd14f203$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(CancelToken, [
        {
            /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ key: "throwIfRequested",
            value: function throwIfRequested() {
                if (this.reason) throw this.reason;
            }
        },
        {
            /**
   * Subscribe to the cancel signal
   */ key: "subscribe",
            value: function subscribe(listener) {
                if (this.reason) {
                    listener(this.reason);
                    return;
                }
                if (this._listeners) this._listeners.push(listener);
                else this._listeners = [
                    listener
                ];
            }
        },
        {
            /**
   * Unsubscribe from the cancel signal
   */ key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (!this._listeners) return;
                var index = this._listeners.indexOf(listener);
                if (index !== -1) this._listeners.splice(index, 1);
            }
        },
        {
            key: "toAbortSignal",
            value: function toAbortSignal() {
                var _this = this;
                var controller = new AbortController();
                var abort = function(err) {
                    controller.abort(err);
                };
                this.subscribe(abort);
                controller.signal.unsubscribe = function() {
                    return _this.unsubscribe(abort);
                };
                return controller.signal;
            }
        }
    ], [
        {
            key: "source",
            value: /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ function source() {
                var cancel;
                var token = new CancelToken(function executor(c) {
                    cancel = c;
                });
                return {
                    token: token,
                    cancel: cancel
                };
            }
        }
    ]);
    return CancelToken;
}();
var $d8cf381d353a4513$export$2e2bcd8739ae039 = $d8cf381d353a4513$var$CancelToken;






"use strict";
function $3227eba814d38007$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $d4c636500f91910b$export$2e2bcd8739ae039(payload) {
    return (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}





var $1b327d89d2379b44$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($1b327d89d2379b44$var$HttpStatusCode).forEach(function(param) {
    var _param = (0, $1733e6e3a24db77c$export$71511d61b312f219)(param, 2), key = _param[0], value = _param[1];
    $1b327d89d2379b44$var$HttpStatusCode[value] = key;
});
var $1b327d89d2379b44$export$2e2bcd8739ae039 = $1b327d89d2379b44$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $d8b49c18383d4ddb$var$createInstance(defaultConfig) {
    var context = new (0, $32554a0f086aa968$export$2e2bcd8739ae039)(defaultConfig);
    var instance = (0, $547100571c4e1abe$export$2e2bcd8739ae039)((0, $32554a0f086aa968$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).extend(instance, (0, $32554a0f086aa968$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c6fd95db66a95a37$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $d8b49c18383d4ddb$var$createInstance((0, $d6ec2a123bef168e$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $d8b49c18383d4ddb$var$axios = $d8b49c18383d4ddb$var$createInstance((0, $7c8f8d5bb202b6a6$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$d8b49c18383d4ddb$var$axios.Axios = (0, $32554a0f086aa968$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$d8b49c18383d4ddb$var$axios.CanceledError = (0, $b4466f79dd14f203$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios.CancelToken = (0, $d8cf381d353a4513$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios.isCancel = (0, $ad1a5450a5160689$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios.VERSION = (0, $25c3930f89e6179f$export$a4ad2735b021c132);
$d8b49c18383d4ddb$var$axios.toFormData = (0, $1eeade30cbff36ce$export$2e2bcd8739ae039);
// Expose AxiosError class
$d8b49c18383d4ddb$var$axios.AxiosError = (0, $82194958dcf3d811$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$d8b49c18383d4ddb$var$axios.Cancel = $d8b49c18383d4ddb$var$axios.CanceledError;
// Expose all/spread
$d8b49c18383d4ddb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$d8b49c18383d4ddb$var$axios.spread = (0, $3227eba814d38007$export$2e2bcd8739ae039);
// Expose isAxiosError
$d8b49c18383d4ddb$var$axios.isAxiosError = (0, $d4c636500f91910b$export$2e2bcd8739ae039);
// Expose mergeConfig
$d8b49c18383d4ddb$var$axios.mergeConfig = (0, $d6ec2a123bef168e$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios.AxiosHeaders = (0, $74fcf8410f1e027a$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios.formToJSON = function(thing) {
    return (0, $5defdff28a25b37d$export$2e2bcd8739ae039)((0, $c6fd95db66a95a37$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
};
$d8b49c18383d4ddb$var$axios.getAdapter = (0, $ecc2e934cf4b2586$export$2e2bcd8739ae039).getAdapter;
$d8b49c18383d4ddb$var$axios.HttpStatusCode = (0, $1b327d89d2379b44$export$2e2bcd8739ae039);
$d8b49c18383d4ddb$var$axios["default"] = $d8b49c18383d4ddb$var$axios;
var // this module should only have a default export
$d8b49c18383d4ddb$export$2e2bcd8739ae039 = $d8b49c18383d4ddb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
var $a9e2c987c7f89efe$export$1c00760e9e5a4e95 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).Axios, $a9e2c987c7f89efe$export$c1fbed17c2f6a328 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).AxiosError, $a9e2c987c7f89efe$export$1ab0c6b20d94fa14 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).CanceledError, $a9e2c987c7f89efe$export$3b22524397b493c6 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).isCancel, $a9e2c987c7f89efe$export$fd08e3cb425f0d61 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).CancelToken, $a9e2c987c7f89efe$export$a4ad2735b021c132 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).VERSION, $a9e2c987c7f89efe$export$84bf76cd7afc7469 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).all, $a9e2c987c7f89efe$export$848c9b7ead0df967 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).Cancel, $a9e2c987c7f89efe$export$fbafdbe06a5b5a9a = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).isAxiosError, $a9e2c987c7f89efe$export$3ae0fd4797ed47c8 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).spread, $a9e2c987c7f89efe$export$10ae0d317ea97f8b = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).toFormData, $a9e2c987c7f89efe$export$4e7d6ff0f3e6520 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).AxiosHeaders, $a9e2c987c7f89efe$export$a972f69c851492b3 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).HttpStatusCode, $a9e2c987c7f89efe$export$86d7c59254d6a2c9 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).formToJSON, $a9e2c987c7f89efe$export$17ddc20a97d669e2 = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).getAdapter, $a9e2c987c7f89efe$export$7ec1ebcfa9d8bd6a = (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).mergeConfig;















var $1fd43aa358ead3cf$var$_this = undefined;
function $1fd43aa358ead3cf$var$_defineProperty(e, r, t) {
    return (r = $1fd43aa358ead3cf$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1fd43aa358ead3cf$var$_toPropertyKey(t) {
    var i = $1fd43aa358ead3cf$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $1fd43aa358ead3cf$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $1fd43aa358ead3cf$var$AbstractFormField = /*#__PURE__*/ function() {
    "use strict";
    function AbstractFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, AbstractFormField);
        $1fd43aa358ead3cf$var$_defineProperty(this, "name", null);
        $1fd43aa358ead3cf$var$_defineProperty(this, "isRequired", null);
        $1fd43aa358ead3cf$var$_defineProperty(this, "element", null);
        $1fd43aa358ead3cf$var$_defineProperty(this, "type", null);
        $1fd43aa358ead3cf$var$_defineProperty(this, "changeListeners", []);
        var name = options.name, isRequired = options.isRequired, type = options.type;
        this.element = element;
        this.name = name;
        this.type = type;
        this.isRequired = isRequired;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(AbstractFormField, [
        {
            key: "onChange",
            value: function onChange(callback) {
                this.changeListeners.push(callback);
            }
        },
        {
            key: "handleChanges",
            value: function handleChanges() {
                var _this = this;
                this.changeListeners.forEach(function(fn) {
                    return fn(_this);
                });
            }
        },
        {
            key: "getLabel",
            value: function getLabel() {
                return this.label;
            }
        },
        {
            key: "getValue",
            value: function getValue() {}
        },
        {
            key: "setValue",
            value: function setValue() {}
        },
        {
            key: "isValid",
            value: function isValid() {}
        },
        {
            key: "validate",
            value: function validate() {
                this.element.classList.remove("has-error");
                if (!this.isValid()) this.element.classList.add("has-error");
            }
        },
        {
            key: "getName",
            value: function getName() {
                return this.name;
            }
        }
    ]);
    return AbstractFormField;
}();
$1fd43aa358ead3cf$var$AbstractFormField.prototype.getLabel = function() {
    return $1fd43aa358ead3cf$var$_this.label;
};
var $1fd43aa358ead3cf$export$2e2bcd8739ae039 = $1fd43aa358ead3cf$var$AbstractFormField;


var $179db65871bc5893$var$InputFormField = /*#__PURE__*/ function(AbstractFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(InputFormField, AbstractFormField);
    var _super = (0, $1c23ba689bfccaac$export$71511d61b312f219)(InputFormField);
    function InputFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, InputFormField);
        var _this;
        _this = _super.call(this, element, (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
            type: "input"
        }));
        _this.input = element.querySelectorAll("input")[0];
        _this.input.addEventListener("keyup", _this.handleChanges.bind((0, $9b101634070cfba3$export$71511d61b312f219)(_this)));
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(InputFormField, [
        {
            key: "getValue",
            value: function getValue() {
                return this.input.value;
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                this.input.value = value;
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                if (!this.isRequired) return true;
                if (this.input.getAttribute("type") === "email") return /\S+@\S+\.\S+/.test(this.input.value);
                if (this.input.getAttribute("type") === "date" && this.input.getAttribute("min")) {
                    var inputDate = new Date(this.input.value);
                    var currentDate = new Date();
                    currentDate.setHours(0, 0, 0, 0);
                    return inputDate > currentDate;
                }
                return this.input.value.trim() !== "";
            }
        }
    ]);
    return InputFormField;
}((0, $1fd43aa358ead3cf$export$2e2bcd8739ae039));
var $179db65871bc5893$export$2e2bcd8739ae039 = $179db65871bc5893$var$InputFormField;










var $afe3978601e1bcbb$var$TextareaFormField = /*#__PURE__*/ function(AbstractFormField) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(TextareaFormField, AbstractFormField);
    var _super = (0, $1c23ba689bfccaac$export$71511d61b312f219)(TextareaFormField);
    function TextareaFormField(element, options) {
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, TextareaFormField);
        var _this;
        _this = _super.call(this, element, (0, $f0cc97789eddd92a$export$71511d61b312f219)((0, $2cfc0dd9fa59fdb8$export$71511d61b312f219)({}, options), {
            type: "textarea"
        }));
        _this.input = element.querySelectorAll("textarea")[0];
        _this.input.addEventListener("keyup", _this.handleChanges.bind((0, $9b101634070cfba3$export$71511d61b312f219)(_this)));
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(TextareaFormField, [
        {
            key: "getValue",
            value: function getValue() {
                return this.input ? this.input.value : "";
            }
        },
        {
            key: "setValue",
            value: function setValue(value) {
                this.input.value = value;
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                if (!this.isRequired) return true;
                return this.input.value.trim() !== "";
            }
        }
    ]);
    return TextareaFormField;
}((0, $1fd43aa358ead3cf$export$2e2bcd8739ae039));
var $afe3978601e1bcbb$export$2e2bcd8739ae039 = $afe3978601e1bcbb$var$TextareaFormField;


function $16da752e42cc99d4$var$_defineProperty(e, r, t) {
    return (r = $16da752e42cc99d4$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $16da752e42cc99d4$var$_toPropertyKey(t) {
    var i = $16da752e42cc99d4$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $16da752e42cc99d4$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $16da752e42cc99d4$var$FormFields = /*#__PURE__*/ function() {
    "use strict";
    function FormFields(parent) {
        var onValidate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, selector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "data-field-name";
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, FormFields);
        $16da752e42cc99d4$var$_defineProperty(this, "firstValidated", false);
        $16da752e42cc99d4$var$_defineProperty(this, "onValidate", null);
        $16da752e42cc99d4$var$_defineProperty(this, "name", null);
        $16da752e42cc99d4$var$_defineProperty(this, "fields", []);
        $16da752e42cc99d4$var$_defineProperty(this, "map", {
            input: (0, $179db65871bc5893$export$2e2bcd8739ae039),
            textarea: (0, $afe3978601e1bcbb$export$2e2bcd8739ae039)
        });
        this.onValidate = onValidate;
        var fields = parent.querySelectorAll("[".concat(selector, "]"));
        this.name = parent.getAttribute("name");
        for(var i = 0; i < fields.length; i++){
            var el = fields[i];
            var name = el.dataset.fieldName || el.dataset.surveyFieldName;
            var type = el.dataset.fieldType;
            var isRequired = el.dataset.fieldRequired === "1";
            var FieldClass = typeof this.map[type] !== "undefined" ? this.map[type] : null;
            if (FieldClass) this.fields.push(new FieldClass(el, {
                name: name,
                isRequired: isRequired
            }));
        }
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(FormFields, [
        {
            key: "validate",
            value: function validate() {
                var isValid = true;
                this.fields.forEach(function(field) {
                    field.validate();
                    isValid = isValid && field.isValid();
                });
                if (!this.firstValidated && !isValid) {
                    this.firstValidated = true;
                    this.validateOnChange();
                }
                if (this.onValidate) this.onValidate(isValid);
                return isValid;
            }
        },
        {
            key: "validateOnChange",
            value: function validateOnChange() {
                var _this = this;
                this.fields.forEach(function(field) {
                    console.log(field);
                    field.onChange(_this.validate.bind(_this));
                });
            }
        },
        {
            key: "setValue",
            value: function setValue(name, value) {
                this.fields.forEach(function(field) {
                    if (field.getName() === name) field.setValue(value);
                });
            }
        },
        {
            key: "getFields",
            value: function getFields() {
                return this.fields;
            }
        },
        {
            key: "getRequiredFields",
            value: function getRequiredFields() {
                var items = [];
                this.fields.forEach(function(field) {
                    if (field.isRequired) items.push(field);
                });
                return items;
            }
        },
        {
            key: "getDataObject",
            value: function getDataObject() {
                var data = {};
                this.fields.forEach(function(field) {
                    if (field.getValue()) data[field.getName()] = field.getValue();
                });
                return data;
            }
        },
        {
            key: "getData",
            value: function getData() {
                var data = new FormData();
                var object = this.getDataObject();
                Object.keys(object).forEach(function(key) {
                    data.append(key, object[key]);
                });
                return data;
            }
        }
    ]);
    return FormFields;
}();
var $16da752e42cc99d4$export$2e2bcd8739ae039 = $16da752e42cc99d4$var$FormFields;


function $f27c19a18ca6512e$var$_defineProperty(e, r, t) {
    return (r = $f27c19a18ca6512e$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f27c19a18ca6512e$var$_toPropertyKey(t) {
    var i = $f27c19a18ca6512e$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $0cd339a6e98df7f5$export$71511d61b312f219)(i)) ? i : i + "";
}
function $f27c19a18ca6512e$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $f27c19a18ca6512e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Controller) {
    "use strict";
    (0, $28f6179e2b599279$export$71511d61b312f219)(_Class, Controller);
    var _super = (0, $1c23ba689bfccaac$export$71511d61b312f219)(_Class);
    function _Class() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0, $4eedc8287d3685e8$export$71511d61b312f219)(this, _Class);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0, $f655aa2a9acfd1eb$export$71511d61b312f219)(args)));
        $f27c19a18ca6512e$var$_defineProperty((0, $9b101634070cfba3$export$71511d61b312f219)(_this), "messages", {});
        $f27c19a18ca6512e$var$_defineProperty((0, $9b101634070cfba3$export$71511d61b312f219)(_this), "action", null);
        $f27c19a18ca6512e$var$_defineProperty((0, $9b101634070cfba3$export$71511d61b312f219)(_this), "formNames", []);
        $f27c19a18ca6512e$var$_defineProperty((0, $9b101634070cfba3$export$71511d61b312f219)(_this), "steps", []);
        return _this;
    }
    (0, $625388bbfb3cd523$export$71511d61b312f219)(_Class, [
        {
            key: "connect",
            value: function connect() {
                this.formTarget = this.element.querySelector("form");
                this.formNames.push("contact");
                this.submitButton = this.element.querySelector(".form-next-step-button");
                this.submitButton.addEventListener("click", this.next.bind(this));
                this.form = new (0, $16da752e42cc99d4$export$2e2bcd8739ae039)(this.formTarget);
                this.messages = JSON.parse(atob(this.element.dataset.messages));
                this.action = this.element.dataset.action;
                var items = this.element.getElementsByClassName("form-step");
                for(var i = 0; i < items.length; i++)this.steps.push(items[i]);
            }
        },
        {
            key: "next",
            value: function next(e) {
                var _this = this;
                return (0, $cd0bb46fcf33db2e$export$71511d61b312f219)(function() {
                    var isValid, onSuccess, onError, body;
                    return (0, $248fc3c53839d9ba$export$67ebef60e6f28a6)(this, function(_state) {
                        e.preventDefault();
                        isValid = _this.form.validate();
                        if (!isValid) {
                            _this.showError(_this.messages.required);
                            return [
                                2
                            ];
                        }
                        onSuccess = function(r) {
                            _this.resetError();
                            _this.steps[0].classList.remove("active");
                            _this.steps[1].classList.add("active");
                        };
                        onError = function(r) {
                            if (r.response && r.response.data && r.response.data.error) _this.showError(r.response.data.error);
                            else _this.showError(_this.messages.unknown);
                        };
                        body = _this.form.getData();
                        body.append("step", "0");
                        if (_this.formNames.length) body.append("forms", _this.formNames);
                        (0, $d8b49c18383d4ddb$export$2e2bcd8739ae039).post(_this.action, body).then(onSuccess)["catch"](onError);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "showError",
            value: function showError(message) {
                this.errorTarget.innerHTML = message;
            }
        },
        {
            key: "resetError",
            value: function resetError() {
                this.errorTarget.innerHTML = "";
            }
        }
    ]);
    return _Class;
}((0, $9761593eb1d92c30$export$bd0bf19f25da8474));
$f27c19a18ca6512e$var$_defineProperty($f27c19a18ca6512e$export$2e2bcd8739ae039, "targets", [
    "error"
]);


var $e7f24e80db9536d7$var$application = (0, $9761593eb1d92c30$export$16975c34e60e1e61).start();
$e7f24e80db9536d7$var$application.register("accordion", (0, $6c5afe00ef2f00bb$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register("burger", (0, $ce37487ff92820e5$export$2e2bcd8739ae039));
$e7f24e80db9536d7$var$application.register("form-contact", (0, $f27c19a18ca6512e$export$2e2bcd8739ae039));


var $a7bb02e485c8f6ee$exports = {};
/*! smooth-scroll v16.1.3 | (c) 2020 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */ window.Element && !Element.prototype.closest && (Element.prototype.closest = function(e) {
    var t, n = (this.document || this.ownerDocument).querySelectorAll(e), o = this;
    do {
        for(t = n.length; 0 <= --t && n.item(t) !== o;);
    }while (t < 0 && (o = o.parentElement));
    return o;
}), function() {
    if ("function" == typeof window.CustomEvent) return;
    function e(e, t) {
        t = t || {
            bubbles: !1,
            cancelable: !1,
            detail: void 0
        };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
    }
    e.prototype = window.Event.prototype, window.CustomEvent = e;
}(), function() {
    for(var r = 0, e = [
        "ms",
        "moz",
        "webkit",
        "o"
    ], t = 0; t < e.length && !window.requestAnimationFrame; ++t)window.requestAnimationFrame = window[e[t] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[e[t] + "CancelAnimationFrame"] || window[e[t] + "CancelRequestAnimationFrame"];
    window.requestAnimationFrame || (window.requestAnimationFrame = function(e, t) {
        var n = (new Date).getTime(), o = Math.max(0, 16 - (n - r)), a = window.setTimeout(function() {
            e(n + o);
        }, o);
        return r = n + o, a;
    }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(e) {
        clearTimeout(e);
    });
}(), function(e, t) {
    "function" == typeof define && define.amd ? define([], function() {
        return t(e);
    }) : $a7bb02e485c8f6ee$exports = t(e);
}("undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof window ? window : $a7bb02e485c8f6ee$exports, function(M) {
    "use strict";
    var q = {
        ignore: "[data-scroll-ignore]",
        header: null,
        topOnEmptyHash: !0,
        speed: 500,
        speedAsDuration: !1,
        durationMax: null,
        durationMin: null,
        clip: !0,
        offset: 0,
        easing: "easeInOutCubic",
        customEasing: null,
        updateURL: !0,
        popstate: !0,
        emitEvents: !0
    }, I = function I() {
        var n = {};
        return Array.prototype.forEach.call(arguments, function(e) {
            for(var t in e){
                if (!e.hasOwnProperty(t)) return;
                n[t] = e[t];
            }
        }), n;
    }, r = function r(e) {
        "#" === e.charAt(0) && (e = e.substr(1));
        for(var t, n = String(e), o = n.length, a = -1, r = "", i = n.charCodeAt(0); ++a < o;){
            if (0 === (t = n.charCodeAt(a))) throw new InvalidCharacterError("Invalid character: the input contains U+0000.");
            1 <= t && t <= 31 || 127 == t || 0 === a && 48 <= t && t <= 57 || 1 === a && 48 <= t && t <= 57 && 45 === i ? r += "\\" + t.toString(16) + " " : r += 128 <= t || 45 === t || 95 === t || 48 <= t && t <= 57 || 65 <= t && t <= 90 || 97 <= t && t <= 122 ? n.charAt(a) : "\\" + n.charAt(a);
        }
        return "#" + r;
    }, F = function F() {
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
    }, L = function L(e) {
        var t;
        return e ? (t = e, parseInt(M.getComputedStyle(t).height, 10) + e.offsetTop) : 0;
    }, x = function x(e, t, n) {
        0 === e && document.body.focus(), n || (e.focus(), document.activeElement !== e && (e.setAttribute("tabindex", "-1"), e.focus(), e.style.outline = "none"), M.scrollTo(0, t));
    }, H = function H(e, t, n, o) {
        if (t.emitEvents && "function" == typeof M.CustomEvent) {
            var a = new CustomEvent(e, {
                bubbles: !0,
                detail: {
                    anchor: n,
                    toggle: o
                }
            });
            document.dispatchEvent(a);
        }
    };
    return function(o, e) {
        var b, a, A, O, C = {};
        C.cancelScroll = function(e) {
            cancelAnimationFrame(O), O = null, e || H("scrollCancel", b);
        }, C.animateScroll = function(a, r, e) {
            C.cancelScroll();
            var i = I(b || q, e || {}), c = "[object Number]" === Object.prototype.toString.call(a), t = c || !a.tagName ? null : a;
            if (c || t) {
                var s = M.pageYOffset;
                i.header && !A && (A = document.querySelector(i.header));
                var n, o, u, l, m, d, f, h, p = L(A), g = c ? a : function(e, t, n, o) {
                    var _$a = 0;
                    if (e.offsetParent) for(; _$a += e.offsetTop, e = e.offsetParent;);
                    return _$a = Math.max(_$a - t - n, 0), o && (_$a = Math.min(_$a, F() - M.innerHeight)), _$a;
                }(t, p, parseInt("function" == typeof i.offset ? i.offset(a, r) : i.offset, 10), i.clip), y = g - s, v = F(), w = 0, S = (n = y, u = (o = i).speedAsDuration ? o.speed : Math.abs(n / 1e3 * o.speed), o.durationMax && u > o.durationMax ? o.durationMax : o.durationMin && u < o.durationMin ? o.durationMin : parseInt(u, 10)), E = function E1(e) {
                    var t, n, o;
                    l || (l = e), w += e - l, d = s + y * (n = m = 1 < (m = 0 === S ? 0 : w / S) ? 1 : m, "easeInQuad" === (t = i).easing && (o = n * n), "easeOutQuad" === t.easing && (o = n * (2 - n)), "easeInOutQuad" === t.easing && (o = n < .5 ? 2 * n * n : (4 - 2 * n) * n - 1), "easeInCubic" === t.easing && (o = n * n * n), "easeOutCubic" === t.easing && (o = --n * n * n + 1), "easeInOutCubic" === t.easing && (o = n < .5 ? 4 * n * n * n : (n - 1) * (2 * n - 2) * (2 * n - 2) + 1), "easeInQuart" === t.easing && (o = n * n * n * n), "easeOutQuart" === t.easing && (o = 1 - --n * n * n * n), "easeInOutQuart" === t.easing && (o = n < .5 ? 8 * n * n * n * n : 1 - 8 * --n * n * n * n), "easeInQuint" === t.easing && (o = n * n * n * n * n), "easeOutQuint" === t.easing && (o = 1 + --n * n * n * n * n), "easeInOutQuint" === t.easing && (o = n < .5 ? 16 * n * n * n * n * n : 1 + 16 * --n * n * n * n * n), t.customEasing && (o = t.customEasing(n)), o || n), M.scrollTo(0, Math.floor(d)), function(e, t) {
                        var n = M.pageYOffset;
                        if (e == t || n == t || (s < t && M.innerHeight + n) >= v) return C.cancelScroll(!0), x(a, t, c), H("scrollStop", i, a, r), O = l = null, true;
                    }(d, g) || (O = M.requestAnimationFrame(E), l = e);
                };
                0 === M.pageYOffset && M.scrollTo(0, 0), f = a, h = i, c || history.pushState && h.updateURL && history.pushState({
                    smoothScroll: JSON.stringify(h),
                    anchor: f.id
                }, document.title, f === document.documentElement ? "#top" : "#" + f.id), "matchMedia" in M && M.matchMedia("(prefers-reduced-motion)").matches ? x(a, Math.floor(g), !1) : (H("scrollStart", i, a, r), C.cancelScroll(!0), M.requestAnimationFrame(E));
            }
        };
        var t = function t(e) {
            if (!e.defaultPrevented && !(0 !== e.button || e.metaKey || e.ctrlKey || e.shiftKey) && "closest" in e.target && (a = e.target.closest(o)) && "a" === a.tagName.toLowerCase() && !e.target.closest(b.ignore) && a.hostname === M.location.hostname && a.pathname === M.location.pathname && /#/.test(a.href)) {
                var t, n;
                try {
                    t = r(decodeURIComponent(a.hash));
                } catch (e) {
                    t = r(a.hash);
                }
                if ("#" === t) {
                    if (!b.topOnEmptyHash) return;
                    n = document.documentElement;
                } else n = document.querySelector(t);
                (n = n || "#top" !== t ? n : document.documentElement) && (e.preventDefault(), function(e) {
                    if (history.replaceState && e.updateURL && !history.state) {
                        var t = M.location.hash;
                        t = t || "", history.replaceState({
                            smoothScroll: JSON.stringify(e),
                            anchor: t || M.pageYOffset
                        }, document.title, t || M.location.href);
                    }
                }(b), C.animateScroll(n, a));
            }
        }, n = function n(e) {
            if (null !== history.state && history.state.smoothScroll && history.state.smoothScroll === JSON.stringify(b)) {
                var t = history.state.anchor;
                "string" == typeof t && t && !(t = document.querySelector(r(history.state.anchor))) || C.animateScroll(t, null, {
                    updateURL: !1
                });
            }
        };
        C.destroy = function() {
            b && (document.removeEventListener("click", t, !1), M.removeEventListener("popstate", n, !1), C.cancelScroll(), O = A = a = b = null);
        };
        return function() {
            if (!("querySelector" in document && "addEventListener" in M && "requestAnimationFrame" in M && "closest" in M.Element.prototype)) throw "Smooth Scroll: This browser does not support the required JavaScript methods and browser APIs.";
            C.destroy(), b = I(q, e || {}), A = b.header ? document.querySelector(b.header) : null, document.addEventListener("click", t, !1), b.updateURL && b.popstate && M.addEventListener("popstate", n, !1);
        }(), C;
    };
});



var $e299951ae10ce278$var$scrollConfig = {
    speed: 300,
    speedAsDuration: true,
    header: ".site-nav",
    updateURL: false
};
var $e299951ae10ce278$var$contentLoaded = false, $e299951ae10ce278$var$scrollTo = null;
window.__scroll = new (0, (/*@__PURE__*/$parcel$interopDefault($a7bb02e485c8f6ee$exports)))(".notAClass", $e299951ae10ce278$var$scrollConfig);
window.setTimeout(function() {
    $e299951ae10ce278$var$contentLoaded = true;
    if ($e299951ae10ce278$var$scrollTo) {
        window.__scroll.cancelScroll();
        window.__scroll.animateScroll($e299951ae10ce278$var$scrollTo);
    }
}, 500);
var $e299951ae10ce278$var$handleHash = function handleHash(e) {
    var hash = window.location.hash;
    if (!hash) return false;
    window.__scroll = new (0, (/*@__PURE__*/$parcel$interopDefault($a7bb02e485c8f6ee$exports)))(".notAClass", $e299951ae10ce278$var$scrollConfig);
    if (hash.length) {
        var id = hash.replace("#", "") + "_";
        var el = document.getElementById(id);
        if (!el) return false;
        var doScroll = function() {
            $e299951ae10ce278$var$contentLoaded = true;
            window.__scroll.cancelScroll();
            window.__scroll.animateScroll(el);
        };
        if ($e299951ae10ce278$var$contentLoaded) setTimeout(doScroll, 250);
        else $e299951ae10ce278$var$scrollTo = el;
    }
};
(0, $2be48b05c8019145$export$28ee1007e174a2a6)($e299951ae10ce278$var$handleHash);

})();
//# sourceMappingURL=main.js.map
